// This file is auto-generated by @hey-api/openapi-ts

export {
  add_secrets_vault_secret_version_v1,
  add_secrets_vault_secret_version_v2,
  append_conversation_messages_v2,
  append_finalized_conversation_messages_v1,
  append_inference_conversation_messages_v2,
  backfill_index_v1,
  background_task_error_v1,
  complete_work_claim_v1,
  confluence_add_comment_v1,
  confluence_callback_tenant_v1,
  confluence_check_connection_v1,
  confluence_connect_tenant_v1,
  confluence_create_page_v1,
  confluence_create_tenant_v1,
  confluence_delete_tenant_v1,
  confluence_get_attachment_content_v1,
  confluence_get_comments_v1,
  confluence_get_oauth_scopes_v1,
  confluence_get_page_attachments_v1,
  confluence_get_page_content_v1,
  confluence_get_page_labels_v1,
  confluence_get_pages_v1,
  confluence_get_spaces_v1,
  confluence_get_tenant_v1,
  confluence_get_tenants_v1,
  confluence_patch_tenant_v1,
  confluence_update_page_v1,
  create_agent_session_inference_v1,
  create_agent_session_v1,
  create_api_key_v1,
  create_article_line_range_comment_thread_comment_v1,
  create_article_line_range_comment_thread_v1,
  create_bot_user_v1,
  create_branding_logo_upload_url_v1,
  create_calibration_feedback_dimension_v1,
  create_calibration_feedback_inference_datapoints_v1,
  create_calibration_feedback_queue_items_v1,
  create_calibration_feedback_verdict_v1,
  create_change_request_line_range_comment_thread_comment_v1,
  create_change_request_line_range_comment_thread_v1,
  create_change_request_v1,
  create_conversation_feedback_v2,
  create_data_dump_conversation_v1,
  create_datapoints_v3,
  create_external_inferences_v1,
  create_feedback_label_v1,
  create_finalized_conversations_v2,
  create_image_upload_url_v1,
  create_inference_datapoint_v2,
  create_inference_datapoints_dequeue_v1,
  create_inference_datapoints_enqueue_v1,
  create_inference_datapoints_input_v1,
  create_inference_datapoints_output_v1,
  create_inference_feedback_label_v1,
  create_inference_feedback_v1,
  create_invitation_v1,
  create_judge_v1,
  create_judge_v2,
  create_judgements_v2,
  create_judgements_v3,
  create_judges_v2,
  create_kanonical_datapoints_v2,
  create_kb_access_request_v1,
  create_kb_ingestion_files_v1,
  create_kb_simulation_datapoint_v1,
  create_kb_simulation_datapoints_v1,
  create_kb_simulation_result_judgements_batch_v1,
  create_kb_simulation_result_judgements_v1,
  create_kb_simulation_result_v1,
  create_kb_simulation_results_v1,
  create_kb_upload_url_v1,
  create_knowledge_base_v1,
  create_machine_user_api_key_v1,
  create_machine_user_v1,
  create_oauth_application_v1,
  create_prod_evals_dequeue_v1,
  create_prod_evals_enqueue_v1,
  create_prod_evals_input_v1,
  create_prod_evals_output_v1,
  create_prompt_v1,
  create_secrets_vault_secret_v1,
  create_secrets_vault_secret_v2,
  create_stateful_conversation_inference_v2,
  create_stateful_inference_conversation_inference_v2,
  create_stateless_conversation_inference_v2,
  create_stateless_inference_conversation_inference_v2,
  create_support_ingestion_files_v1,
  create_task_v2,
  create_team_v1,
  create_upload_url_v1,
  create_upload_url_v2,
  create_work_claim_v1,
  create_work_event_v1,
  create_workflow_analytics_event_v1,
  create_workspace_v1,
  delete_agent_session_v1,
  delete_api_key_v1,
  delete_article_line_range_comment_thread_v1,
  delete_calibration_feedback_dimension_v1,
  delete_calibration_feedback_inference_datapoint_v1,
  delete_calibration_feedback_queue_item_v1,
  delete_calibration_feedback_verdict_v1,
  delete_change_request_line_range_comment_thread_v1,
  delete_change_request_v1,
  delete_comment_v1,
  delete_data_dump_conversation_v1,
  delete_datapoint_v2,
  delete_external_inference_v1,
  delete_finalized_conversation_v1,
  delete_inference_conversation_v2,
  delete_inference_datapoint_v1,
  delete_invitation_v1,
  delete_judge_v1,
  delete_judge_v2,
  delete_judgement_v2,
  delete_judgement_v3,
  delete_kanonical_datapoint_v1,
  delete_kb_simulation_datapoint_v1,
  delete_kb_simulation_result_v1,
  delete_knowledge_base_v3,
  delete_machine_user_api_key_v1,
  delete_machine_user_v1,
  delete_oauth_application_v1,
  delete_org_member_v1,
  delete_secrets_vault_secret_v1,
  delete_secrets_vault_secret_version_v1,
  delete_task_v2,
  delete_team_v1,
  delete_user_v1,
  delete_work_claim_v1,
  delete_workspace_v1,
  download_image_attachment_v1,
  download_kb_attachment_v1,
  embed_datapoints_v1,
  embed_v2,
  embedding_search_v1,
  entra_approve_proposed_action_v1,
  entra_check_connection_v1,
  entra_create_proposed_action_v1,
  entra_create_tenant_v1,
  entra_delete_tenant_v1,
  entra_get_directory_role_members_v1,
  entra_get_directory_roles_v1,
  entra_get_full_tenants_v1,
  entra_get_group_members_v1,
  entra_get_group_v1,
  entra_get_groups_v1,
  entra_get_proposed_action_v1,
  entra_get_proposed_actions_v1,
  entra_get_subscribed_skus_v1,
  entra_get_tenant_v1,
  entra_get_tenants_v1,
  entra_get_user_direct_reports_v1,
  entra_get_user_groups_v1,
  entra_get_user_licenses_v1,
  entra_get_user_manager_v1,
  entra_get_user_sign_in_state_v1,
  entra_get_user_v1,
  entra_get_users_v1,
  entra_patch_tenant_v1,
  entra_permission_preflight_v1,
  entra_reject_proposed_action_v1,
  entra_resolve_caller_v1,
  extract_data_dump_conversations_dequeue_v1,
  extract_data_dump_conversations_enqueue_v1,
  extract_data_dump_conversations_input_v1,
  extract_data_dump_conversations_output_v1,
  extract_datapoints_dequeue_v1,
  extract_datapoints_enqueue_v1,
  extract_datapoints_input_v1,
  extract_datapoints_output_v1,
  extract_incoming_knowledge_bases_dequeue_v1,
  extract_incoming_knowledge_bases_enqueue_v1,
  extract_incoming_knowledge_bases_input_v1,
  extract_incoming_knowledge_bases_output_v1,
  finalize_conversations_dequeue_v1,
  finalize_conversations_enqueue_v1,
  finalize_conversations_input_v1,
  finalize_conversations_output_v1,
  finetune_knowledge_bases_dequeue_v1,
  finetune_knowledge_bases_enqueue_v1,
  finetune_knowledge_bases_input_v1,
  finetune_knowledge_bases_output_v1,
  freshservice_add_note_to_ticket_v1,
  freshservice_check_connection_v1,
  freshservice_create_article_v1,
  freshservice_create_folder_v1,
  freshservice_create_tenant_v1,
  freshservice_create_ticket_v1,
  freshservice_delete_tenant_v1,
  freshservice_get_agent_v1,
  freshservice_get_agents_v1,
  freshservice_get_article_v1,
  freshservice_get_articles_v1,
  freshservice_get_categories_v1,
  freshservice_get_folders_v1,
  freshservice_get_full_tenants_v1,
  freshservice_get_requester_v1,
  freshservice_get_requesters_v1,
  freshservice_get_tenant_v1,
  freshservice_get_tenants_v1,
  freshservice_get_ticket_conversations_v1,
  freshservice_get_ticket_v1,
  freshservice_get_tickets_v1,
  freshservice_ingest_webhook_v1,
  freshservice_patch_tenant_v1,
  freshservice_provision_webhook_v1,
  freshservice_reply_to_ticket_v1,
  freshservice_update_article_v1,
  freshservice_update_ticket_v1,
  get_a2a_agent_card_v1,
  get_a2a_agents_v1,
  get_agent_session_inferences_v1,
  get_agent_sessions_v1,
  get_agent_usage_stats_v1,
  get_agent_v1,
  get_agents_v1,
  get_article_line_range_comment_thread_v1,
  get_article_tags_v1,
  get_attachment_data_v1,
  get_attachment_data_v2,
  get_attachment_metadata_v1,
  get_branding_v1,
  get_calibration_feedback_dimension_v1,
  get_calibration_feedback_dimensions_v1,
  get_calibration_feedback_inference_datapoint_tags_v1,
  get_calibration_feedback_inference_datapoint_v1,
  get_calibration_feedback_inference_datapoints_v1,
  get_calibration_feedback_queue_item_tags_v1,
  get_calibration_feedback_queue_item_v1,
  get_calibration_feedback_queue_items_v1,
  get_calibration_feedback_verdict_v1,
  get_calibration_feedback_verdicts_v1,
  get_change_counts_v2,
  get_change_request_line_range_comment_thread_v1,
  get_change_request_possible_assignees_v1,
  get_change_request_tags_v1,
  get_change_request_v1,
  get_change_requests_v1,
  get_change_users_v2,
  get_comment_v1,
  get_conversations_grouped_by_external_id_v1,
  get_conversations_v1,
  get_current_user_v1,
  get_data_dump_conversations_v1,
  get_datapoint_evidence_v1,
  get_datapoint_v3,
  get_edra_access_v1,
  get_edra_pb_openapi,
  get_embedding_summary_v2,
  get_evaluated_inference_datapoints_v1,
  get_external_inference_v1,
  get_external_inferences_v1,
  get_feedback_labels_v1,
  get_finalized_conversations_v2,
  get_frontend_config_v1,
  get_full_agent_session_v1,
  get_full_agent_sessions_v1,
  get_full_api_keys_v1,
  get_full_article_line_range_comment_threads_v1,
  get_full_calibration_feedback_dimensions_v1,
  get_full_calibration_feedback_queue_items_v1,
  get_full_calibration_feedback_verdicts_v1,
  get_full_change_request_line_range_comment_threads_v1,
  get_full_change_requests_v1,
  get_full_comments_v1,
  get_full_data_dump_conversations_v1,
  get_full_datapoints_v1,
  get_full_finalized_conversation_v2,
  get_full_finalized_conversations_v2,
  get_full_inference_conversation_inferences_v2,
  get_full_inference_conversations_v2,
  get_full_inference_datapoint_v1,
  get_full_inference_datapoints_v1,
  get_full_invitations_v1,
  get_full_kb_simulation_compare_v1,
  get_full_kb_simulation_datapoint_v1,
  get_full_kb_simulation_datapoints_v1,
  get_full_kb_simulation_result_judgements_v1,
  get_full_kb_simulation_result_v1,
  get_full_kb_simulation_results_v1,
  get_full_kb_simulation_run_v1,
  get_full_knowledge_bases_v1,
  get_full_oauth_applications_v1,
  get_full_user_agent_sessions_v1,
  get_full_work_events_v1,
  get_inference_conversation_inference_v2,
  get_inference_conversation_v2,
  get_inference_conversations_v2,
  get_inference_feedback_v1,
  get_invitation_v1,
  get_invitations_v1,
  get_judge_v1,
  get_judge_v2,
  get_judgements_full_v3,
  get_judgements_v2,
  get_judges_v1,
  get_judges_v2,
  get_kanonical_datapoint_v2,
  get_kanonical_datapoints_v2,
  get_kb_access_requests_v1,
  get_kb_analytics_chart_content_v1,
  get_kb_child_judgement_metrics_v1,
  get_kb_simulation_branch_breakdown_stats_v1,
  get_kb_simulation_commits_v1,
  get_kb_simulation_compare_summary_v1,
  get_kb_simulation_datapoint_v1,
  get_kb_simulation_datapoints_v1,
  get_kb_simulation_result_v1,
  get_kb_simulation_results_v1,
  get_kb_top_article_judgement_metrics_v2,
  get_knowledge_base_v2,
  get_knowledge_bases_v4,
  get_machine_user_api_keys_v1,
  get_machine_user_v1,
  get_machine_users_v1,
  get_mcp_toolsets_v1,
  get_my_kb_access_request_v1,
  get_notification_settings_v1,
  get_oauth_application_v1,
  get_oauth_applications_v1,
  get_object_article_v1,
  get_org_members_v1,
  get_organization_v1,
  get_organizations_v1,
  get_overview_analytics_chart_content_v1,
  get_overview_analytics_charts_v1,
  get_owned_knowledge_bases_v1,
  get_pool_stats_v1,
  get_prompt_v1,
  get_prompts_v1,
  get_requester_teams_v1,
  get_roles_v1,
  get_sdk_openapi,
  get_secrets_vault_full_secrets_v1,
  get_secrets_vault_secret_v1,
  get_secrets_vault_secret_value_v1,
  get_secrets_vault_secret_value_v2,
  get_secrets_vault_secrets_v1,
  get_section_analytics_chart_content_v1,
  get_section_analytics_charts_v1,
  get_task_v2,
  get_tasks_v2,
  get_team_article_permissions_v1,
  get_team_kb_assignments_v1,
  get_team_v1,
  get_teams_v1,
  get_teams_with_access_v1,
  get_tree_analytics_chart_content_v1,
  get_user_v1,
  get_users_v1,
  get_valkey_value_v1,
  get_verification_metrics_v2,
  get_work_event_v1,
  get_workflow_analytics_chart_content_v1,
  get_workflow_analytics_charts_v1,
  get_workflow_run_analytics_events_v1,
  get_workflow_run_v1,
  get_workflow_runs_v1,
  get_workflows_v1,
  get_workspace_v1,
  get_workspaces_v1,
  git_amend_v1,
  git_branch_create_v1,
  git_branch_delete_v1,
  git_branch_get_v1,
  git_branch_list_v1,
  git_branch_restore_v1,
  git_branch_update_v1,
  git_cherry_pick_v1,
  git_commit_v1,
  git_diff_blame_v1,
  git_diff_v1,
  git_log_v1,
  git_ls_tree_v1,
  git_merge_v1,
  git_rebase_preview_v1,
  git_rebase_v1,
  git_show_article_v1,
  git_show_blob_v1,
  git_show_v1,
  grant_edra_access_v1,
  health,
  hubspot_add_note_v2,
  hubspot_check_connection_v1,
  hubspot_create_tenant_v1,
  hubspot_create_thread_on_ticket_v1,
  hubspot_delete_tenant_v1,
  hubspot_download_manifest_v1,
  hubspot_get_attachment_content_v1,
  hubspot_get_attachment_metadata_v1,
  hubspot_get_company_v1,
  hubspot_get_full_tenants_v1,
  hubspot_get_tenant_v1,
  hubspot_get_tenants_v1,
  hubspot_get_thread_v1,
  hubspot_get_ticket_v1,
  hubspot_ingest_webhook_v1,
  hubspot_list_thread_messages_v1,
  hubspot_list_ticket_notes_v1,
  hubspot_list_tickets_v1,
  hubspot_patch_tenant_v1,
  hubspot_reply_to_thread_v1,
  hubspot_set_ticket_owner_v1,
  hubspot_set_ticket_status_v1,
  hubspot_update_note_v1,
  hubspot_update_ticket_properties_v1,
  hybrid_search_v1,
  jira_check_connection_v1,
  jira_create_tenant_v1,
  jira_delete_tenant_v1,
  jira_get_attachment_content_v2,
  jira_get_custom_field_options_v1,
  jira_get_full_tenants_v1,
  jira_get_issue_v1,
  jira_get_issues_v1,
  jira_get_tenant_v1,
  jira_get_tenants_v1,
  jira_handle_webhook_event_v1,
  jira_patch_tenant_v1,
  jira_post_comment_v2,
  jira_set_custom_field_v1,
  jira_update_issue_labels_v1,
  judgement_filter_options_v1,
  kanonicalize_datapoints_dequeue_v1,
  kanonicalize_datapoints_enqueue_v1,
  kanonicalize_datapoints_input_v1,
  kanonicalize_datapoints_output_v1,
  key_error_v1,
  log_error_v1,
  log_sentry_alert_v1,
  notion_callback_tenant_v1,
  notion_check_connection_v1,
  notion_connect_tenant_v1,
  notion_create_blocks_v1,
  notion_create_page_v1,
  notion_create_tenant_v1,
  notion_delete_block_v1,
  notion_delete_page_v1,
  notion_delete_tenant_v1,
  notion_get_comments_v1,
  notion_get_database_v1,
  notion_get_databases_v1,
  notion_get_page_content_v1,
  notion_get_pages_v1,
  notion_get_tenant_v1,
  notion_get_tenants_v1,
  notion_ingest_webhook_v1,
  notion_query_database_v1,
  notion_reveal_webhook_token_v1,
  notion_update_block_v1,
  notion_update_page_v1,
  oauth_application_authorize_v1,
  oauth_authorization_server_metadata_v1,
  oauth_authorize_v1,
  oauth_openid_configuration_v1,
  oauth_protected_resource_metadata_v1,
  openfga_check_v1,
  openfga_read_tuples_v1,
  openfga_write_tuples_v1,
  type Options,
  outlook_add_email_attachment_v1,
  outlook_copy_email_v1,
  outlook_create_draft_v1,
  outlook_create_subscriptions_v2,
  outlook_delete_email_v1,
  outlook_delete_subscription_v2,
  outlook_forward_email_v1,
  outlook_get_email_attachment_v1,
  outlook_get_subscriptions_v2,
  outlook_mark_email_read_v1,
  outlook_move_email_v1,
  outlook_remove_email_attachment_v1,
  outlook_reply_email_v1,
  outlook_send_email_v1,
  outlook_set_email_categories_v1,
  outlook_set_email_flag_v1,
  outlook_set_email_importance_v1,
  outlook_subscription_event_v2,
  outlook_subscription_lifecycle_v2,
  patch_article_v1,
  patch_commit_v1,
  patch_judge_v2,
  patch_knowledge_base_review_sla_v3,
  patch_knowledge_base_v3,
  patch_notification_settings_v1,
  plain_add_customer_to_groups_v1,
  plain_add_customer_to_plain_tenants_v1,
  plain_add_thread_labels_v1,
  plain_assign_thread_to_self_v1,
  plain_assign_thread_v1,
  plain_change_thread_priority_v1,
  plain_check_connection_v1,
  plain_create_note_v1,
  plain_create_tenant_v1,
  plain_create_thread_v1,
  plain_delete_customer_v1,
  plain_delete_plain_tenant_v1,
  plain_delete_tenant_v1,
  plain_get_companies_v1,
  plain_get_customer_groups_v1,
  plain_get_customer_v1,
  plain_get_customers_v1,
  plain_get_full_tenants_v1,
  plain_get_plain_tenants_v1,
  plain_get_tenant_v1,
  plain_get_tenants_v1,
  plain_get_thread_timeline_v1,
  plain_get_thread_v1,
  plain_get_threads_v1,
  plain_ingest_webhook_v1,
  plain_mark_thread_as_done_v1,
  plain_mark_thread_as_todo_v1,
  plain_patch_tenant_v1,
  plain_remove_thread_labels_v1,
  plain_send_message_v1,
  plain_set_customer_company_v1,
  plain_snooze_thread_v1,
  plain_unassign_thread_v1,
  plain_update_thread_agent_status_v1,
  plain_upsert_company_v1,
  plain_upsert_customer_v1,
  plain_upsert_plain_tenant_v1,
  plain_upsert_thread_field_v1,
  print_logs_v1,
  proxy_oauth_application_introspect_v1,
  proxy_oauth_application_openid_configuration_v1,
  proxy_oauth_application_token_v1,
  proxy_oauth_application_userinfo_v1,
  proxy_oauth_token_v1,
  reader_pool_check_v1,
  regex_search_articles_v1,
  regex_search_datapoints_v1,
  resolve_kb_access_request_v1,
  restore_article_line_range_comment_thread_v1,
  restore_calibration_feedback_dimension_v1,
  restore_calibration_feedback_inference_datapoint_v1,
  restore_calibration_feedback_queue_item_v1,
  restore_calibration_feedback_verdict_v1,
  restore_change_request_line_range_comment_thread_v1,
  restore_change_request_v1,
  restore_comment_v1,
  restore_data_dump_conversation_v1,
  restore_datapoint_v2,
  restore_finalized_conversation_v1,
  restore_inference_conversation_v1,
  restore_inference_datapoint_v1,
  restore_judge_v1,
  restore_kanonical_datapoint_v1,
  restore_kb_simulation_datapoint_v1,
  restore_kb_simulation_result_v1,
  restore_knowledge_base_v3,
  restore_secrets_vault_secret_v1,
  restore_secrets_vault_secret_version_v1,
  restore_task_v2,
  restore_user_v1,
  restore_workspace_v1,
  return_500_v1,
  revoke_edra_access_v1,
  rotate_oauth_application_secret_v1,
  salesforce_callback_tenant_v1,
  salesforce_check_connection_v1,
  salesforce_check_ready_v1,
  salesforce_connect_tenant_v1,
  salesforce_create_article_v1,
  salesforce_create_case_email_draft_v1,
  salesforce_create_case_v1,
  salesforce_create_tenant_v1,
  salesforce_delete_article_v1,
  salesforce_delete_ingest_client_v1,
  salesforce_delete_tenant_v1,
  salesforce_get_account_v1,
  salesforce_get_accounts_v1,
  salesforce_get_articles_v1,
  salesforce_get_case_messages_v1,
  salesforce_get_case_v1,
  salesforce_get_cases_v1,
  salesforce_get_contact_v1,
  salesforce_get_contacts_v1,
  salesforce_get_default_language_v1,
  salesforce_get_entitlement_v1,
  salesforce_get_entitlements_v1,
  salesforce_get_full_tenants_v1,
  salesforce_get_oauth_redirect_uri_v1,
  salesforce_get_queue_v1,
  salesforce_get_queues_v1,
  salesforce_get_record_type_v1,
  salesforce_get_record_types_v1,
  salesforce_get_tenant_v1,
  salesforce_get_tenants_v1,
  salesforce_get_user_v1,
  salesforce_get_users_v1,
  salesforce_ingest_webhook_v1,
  salesforce_oauth_token_v1,
  salesforce_patch_tenant_v1,
  salesforce_post_case_comment_v1,
  salesforce_put_ingest_client_v1,
  salesforce_send_case_email_v1,
  salesforce_update_article_v1,
  salesforce_update_case_v1,
  search_datapoint_evidence_v1,
  search_datapoints_v1,
  search_full_evaluated_inference_datapoints_v1,
  search_reindex_v1,
  search_v1,
  send_agent_session_message_sync_v1,
  send_agent_session_message_v1,
  service_now_add_attachment_v1,
  service_now_add_record_attachment_v1,
  service_now_aggregate_records_v1,
  service_now_attach_tag_v1,
  service_now_change_approval_state_v1,
  service_now_change_assignment_group_v1,
  service_now_change_incident_state_v1,
  service_now_change_request_item_state_v2,
  service_now_change_request_state_v2,
  service_now_change_task_state_v2,
  service_now_checkout_order_guide_v1,
  service_now_create_article_v1,
  service_now_create_catalog_request_v1,
  service_now_create_change_task_v1,
  service_now_create_change_v1,
  service_now_create_incident_v1,
  service_now_create_knowledge_base_v1,
  service_now_create_record_v1,
  service_now_create_tag_v1,
  service_now_create_tenant_v1,
  service_now_delete_staged_catalog_attachment_v1,
  service_now_delete_tenant_v1,
  service_now_empty_cart_v1,
  service_now_evaluate_order_guide_v1,
  service_now_get_approval_state_choices_v1,
  service_now_get_article_v1,
  service_now_get_attachment_content_v1,
  service_now_get_attachments_v1,
  service_now_get_cart_v1,
  service_now_get_catalog_item_v1,
  service_now_get_catalog_variable_lookup_metadata_v1,
  service_now_get_catalog_variable_values_v1,
  service_now_get_incident_state_choices_v1,
  service_now_get_knowledge_base_v1,
  service_now_get_request_item_v1,
  service_now_get_tenant_v1,
  service_now_get_tenants_v1,
  service_now_get_ticket_v1,
  service_now_get_user_profile_v1,
  service_now_handle_webhook_v1,
  service_now_list_approvals_v1,
  service_now_list_articles_v1,
  service_now_list_assignment_groups_v1,
  service_now_list_catalog_items_v1,
  service_now_list_knowledge_bases_v1,
  service_now_list_request_items_v1,
  service_now_list_tags_v1,
  service_now_list_tasks_v1,
  service_now_list_tickets_v1,
  service_now_list_users_v1,
  service_now_reply_tenant_v1,
  service_now_reply_v1,
  service_now_restore_tenant_v1,
  service_now_run_batch_v1,
  service_now_search_records_v1,
  service_now_setup_tenant_v1,
  service_now_stage_catalog_attachment_v1,
  service_now_submit_record_producer_v1,
  service_now_update_article_v1,
  service_now_update_change_v1,
  service_now_update_knowledge_base_v1,
  service_now_update_record_v1,
  service_now_update_tenant_v1,
  set_org_member_role_v1,
  set_org_membership_v1,
  set_team_article_permission_v1,
  set_team_article_permissions_v1,
  set_team_kb_role_v1,
  set_valkey_value_v1,
  sharepoint_callback_tenant_v1,
  sharepoint_check_access_v1,
  sharepoint_check_connection_v1,
  sharepoint_connect_tenant_v1,
  sharepoint_create_download_url_v1,
  sharepoint_create_folder_scope_v1,
  sharepoint_create_item_upload_session_v1,
  sharepoint_create_site_v1,
  sharepoint_create_tenant_v1,
  sharepoint_create_upload_session_v1,
  sharepoint_delete_folder_scope_v1,
  sharepoint_delete_item_v1,
  sharepoint_delete_site_v1,
  sharepoint_delete_tenant_v1,
  sharepoint_get_admin_access_v1,
  sharepoint_get_children_v1,
  sharepoint_get_drives_v1,
  sharepoint_get_folder_scopes_v1,
  sharepoint_get_full_tenants_v1,
  sharepoint_get_item_v1,
  sharepoint_get_sites_v1,
  sharepoint_get_tenant_v1,
  sharepoint_get_tenants_v1,
  sharepoint_grant_site_v1,
  sharepoint_lifecycle_v1,
  sharepoint_notifications_v1,
  sharepoint_patch_tenant_v1,
  sharepoint_update_item_v1,
  slack_add_reaction_v2,
  slack_callback_tenant_v1,
  slack_check_connection_v1,
  slack_connect_tenant_v1,
  slack_create_tenant_v1,
  slack_delete_tenant_v1,
  slack_download_file_v2,
  slack_download_manifest_v1,
  slack_get_channel_messages_v2,
  slack_get_full_tenants_v1,
  slack_get_oauth_scopes_v1,
  slack_get_reactions_v2,
  slack_get_tenant_v1,
  slack_get_tenants_v1,
  slack_get_user_group_users_v1,
  slack_get_user_groups_v1,
  slack_get_user_info_v2,
  slack_list_users_v2,
  slack_open_view_v1,
  slack_patch_tenant_v1,
  slack_post_chat_message_v2,
  slack_publish_home_view_v1,
  slack_push_view_v1,
  slack_receive_event_v2,
  slack_receive_interactivity_v2,
  slack_set_assistant_status_v2,
  slack_set_assistant_title_v1,
  slack_set_channel_description_v2,
  slack_set_channel_topic_v2,
  slack_set_suggested_prompts_v1,
  slack_update_chat_message_v2,
  slack_update_user_group_users_v1,
  slack_update_user_group_v1,
  slack_update_view_v1,
  slack_upload_content_v2,
  slack_upload_files_v2,
  stop_agent_session_v1,
  sync_articles_to_openfga_v1,
  sync_judges_v1,
  sync_kb_owners_v1,
  teams_check_connection_v1,
  teams_create_tenant_v1,
  teams_delete_message_v1,
  teams_delete_tenant_v1,
  teams_download_file_v1,
  teams_download_manifest_v1,
  teams_get_conversation_member_v1,
  teams_get_full_tenants_v1,
  teams_get_icon_v1,
  teams_get_installs_v1,
  teams_get_tenant_v1,
  teams_get_tenants_v1,
  teams_jwks_v1,
  teams_list_conversation_activities_v1,
  teams_list_conversation_members_v1,
  teams_openid_configuration_v1,
  teams_patch_tenant_v1,
  teams_post_message_v1,
  teams_receive_message_v1,
  teams_send_proactive_message_v1,
  teams_update_message_v1,
  teams_upload_icon_v1,
  unwrap_error_v1,
  update_agent_session_v1,
  update_api_key_v1,
  update_article_line_range_comment_thread_v1,
  update_calibration_feedback_verdict_v1,
  update_change_request_line_range_comment_thread_v1,
  update_change_request_v1,
  update_comment_v1,
  update_conversation_v2,
  update_current_user_v1,
  update_data_dump_conversation_v1,
  update_datapoint_by_external_id_v3,
  update_datapoint_v3,
  update_edra_access_v1,
  update_external_inference_v1,
  update_finalized_conversation_message_v1,
  update_finalized_conversation_v1,
  update_index_text_v3,
  update_inference_conversation_inference_v1,
  update_inference_datapoint_v1,
  update_invitation_v1,
  update_judge_v1,
  update_kanonical_datapoint_v1,
  update_kb_simulation_datapoint_v1,
  update_kb_simulation_result_v1,
  update_machine_user_v1,
  update_oauth_application_v1,
  update_org_member_v1,
  update_organization_v1,
  update_secrets_vault_secret_v1,
  update_secrets_vault_secret_version_v1,
  update_task_v2,
  update_team_v1,
  update_workflow_run_v1,
  upsert_external_user_v1,
  upsert_inference_conversation_v2,
  upsert_organization_v1,
  valkey_ping_v1,
  zendesk_callback_tenant_v1,
  zendesk_check_connection_v1,
  zendesk_connect_tenant_v1,
  zendesk_create_tenant_v1,
  zendesk_delete_tenant_v1,
  zendesk_deprovision_webhook_v1,
  zendesk_download_article_attachment_v1,
  zendesk_download_ticket_attachment_v1,
  zendesk_get_categories_v1,
  zendesk_get_oauth_redirect_uri_v1,
  zendesk_get_sections_v1,
  zendesk_get_tenant_v1,
  zendesk_get_tenants_v1,
  zendesk_get_ticket_attachment_content_v1,
  zendesk_get_ticket_v1,
  zendesk_get_user_v1,
  zendesk_get_users_v1,
  zendesk_ingest_webhook_v1,
  zendesk_list_article_attachments_v1,
  zendesk_list_articles_v1,
  zendesk_list_tickets_v1,
  zendesk_patch_tenant_v1,
  zendesk_provision_webhook_v1,
  zendesk_reply_to_ticket_v1,
  zendesk_search_tickets_v1,
  zendesk_update_ticket_tags_v1,
} from "./sdk.gen";
export {
  type A2aAgentCardV1,
  type A2aAgentInterfaceV1,
  type A2aAgentV1,
  type A2aAuthorizationCodeOAuthFlowV1,
  type A2aCapabilitiesV1,
  type A2aConfigV1,
  type A2aCurrentCapabilitiesV1,
  type A2aLegacyAgentCardV1,
  type A2aLegacyOAuth2SecuritySchemeV1,
  type A2aOAuth2SecuritySchemeV1,
  type A2aOAuthFlowsV1,
  type A2aSecurityRequirementV1,
  type A2aSecuritySchemeV1,
  type A2aSkillV1,
  type A2aStringListV1,
  type AddConfluenceCommentParamsV1,
  type AddSecretVersionParamsV1,
  type AddSecretVersionParamsV2,
  type AdfBlockquoteNodeV1Input,
  type AdfBlockquoteNodeV1Output,
  type AdfBorderMarkAttrsV1,
  type AdfBorderMarkV1,
  type AdfBulletListNodeV1Input,
  type AdfBulletListNodeV1Output,
  type AdfCodeBlockAttrsV1,
  type AdfCodeBlockNodeV1Input,
  type AdfCodeBlockNodeV1Output,
  type AdfCodeMarkV1,
  type AdfDateAttrsV1,
  type AdfDateNodeV1,
  type AdfEmMarkV1,
  type AdfEmojiAttrsV1,
  type AdfEmojiNodeV1,
  type AdfExpandAttrsV1,
  type AdfExpandNodeV1Input,
  type AdfExpandNodeV1Output,
  type AdfHardBreakNodeV1,
  type AdfHeadingAttrsV1,
  type AdfHeadingNodeV1Input,
  type AdfHeadingNodeV1Output,
  type AdfInlineCardAttrsV1Input,
  type AdfInlineCardAttrsV1Output,
  type AdfInlineCardNodeV1Input,
  type AdfInlineCardNodeV1Output,
  type AdfInlineNodeV1Input,
  type AdfInlineNodeV1Output,
  type AdfKnownInlineNodeV1Input,
  type AdfKnownInlineNodeV1Output,
  type AdfKnownMarkV1,
  type AdfKnownReadNodeV1Input,
  type AdfKnownReadNodeV1Output,
  type AdfKnownTableCellV1Input,
  type AdfKnownTableCellV1Output,
  type AdfLinkMarkAttrsV1,
  type AdfLinkMarkV1,
  type AdfListItemNodeV1Input,
  type AdfListItemNodeV1Output,
  type AdfMarkV1,
  type AdfMediaAttrsV1,
  type AdfMediaGroupNodeV1,
  type AdfMediaInlineNodeV1,
  type AdfMediaNodeV1,
  type AdfMediaSingleAttrsV1,
  type AdfMediaSingleNodeV1,
  type AdfMentionAttrsV1,
  type AdfMentionNodeV1,
  type AdfNestedExpandNodeV1Input,
  type AdfNestedExpandNodeV1Output,
  type AdfOrderedListAttrsV1,
  type AdfOrderedListNodeV1Input,
  type AdfOrderedListNodeV1Output,
  type AdfPanelAttrsV1,
  type AdfPanelNodeV1Input,
  type AdfPanelNodeV1Output,
  type AdfParagraphNodeV1Input,
  type AdfParagraphNodeV1Output,
  type AdfRuleNodeV1,
  type AdfStatusAttrsV1,
  type AdfStatusNodeV1,
  type AdfStrikeMarkV1,
  type AdfStrongMarkV1,
  type AdfSubsupMarkAttrsV1,
  type AdfSubsupMarkV1,
  type AdfTableAttrsV1,
  type AdfTableCellAttrsV1,
  type AdfTableCellNodeV1Input,
  type AdfTableCellNodeV1Output,
  type AdfTableCellV1Input,
  type AdfTableCellV1Output,
  type AdfTableHeaderNodeV1Input,
  type AdfTableHeaderNodeV1Output,
  type AdfTableNodeV1Input,
  type AdfTableNodeV1Output,
  type AdfTableRowNodeV1Input,
  type AdfTableRowNodeV1Output,
  type AdfTextColorMarkAttrsV1,
  type AdfTextColorMarkV1,
  type AdfTextNodeV1,
  type AdfUnderlineMarkV1,
  type AdfUnknownMarkV1,
  type AdfUnknownNodeV1,
  type AgentErrorEventV1,
  type AgentMessageSocketEventV1,
  type AgentProdEvalItemV1,
  type AgentReasoningSocketEventV1,
  type AgentSessionFullV1,
  type AgentSessionInferenceV1,
  type AgentSessionInferenceWithConversationsV1,
  type AgentSessionUserFilterV1,
  type AgentSessionV1,
  type AgentSocketEventV1,
  type AgentStatusEventV1,
  type AgentTextSocketEventV1,
  type AgentTitleSocketEventV1,
  type AgentToolCallResultSocketEventV1,
  type AgentToolCallSocketEventV1,
  type AgentTraceEntryMessageV1,
  type AgentTraceEntryTurnEndV1,
  type AgentTraceEntryV1,
  type AgentTraceMessageContentBlockV1,
  type AgentTraceMessageFileContentBlockV1,
  type AgentTraceMessageKbCitationContentBlockV1,
  type AgentTraceMessageReasoningContentBlockV1,
  type AgentTraceMessageTextContentBlockV1,
  type AgentTraceMessageToolCallContentBlockV1,
  type AgentTraceMessageToolCallResultContentBlockV1,
  type AgentTraceMessageUiContextContentBlockV1,
  type AgentTraceV1,
  type AgentTurnEndEventV1,
  AgentTurnEndOutcomeV1,
  type AgentUsageDataPointV1,
  type AgentUsageStatsResponseV1,
  type AgentUsageTotalV1,
  type AgentUsageV1,
  type AgentUserUsageV1,
  type AgentV1,
  type AmendEvidenceV1,
  type AnalyticsChartsV1,
  type ApiKeyFullV1,
  type ApiKeySecretPlainValueV2,
  type ApiKeySecretV1,
  type ApiKeySecretValueParamsV1,
  type ApiKeyV1,
  type AppendConversationMessagesPayloadV1,
  type AppendFinalizedConversationMessagesPayloadV1,
  type AppendInferenceConversationMessagesPayloadV1,
  type ArticleByExternalIdRefV1,
  type ArticleByObjectIdRefV1,
  type ArticleLineRangeCommentThreadFullV1,
  type ArticleLineRangeCommentThreadV1,
  ArticlePermissionV1,
  type ArticleSearchContentV1,
  type ArticleTagV1,
  type ArticleV1,
  type ArticleV1DiffSnapshotV2,
  type AspectRatioV1,
  type AttachEvidenceV2,
  AttachmentMediaTypeV1,
  type BackfillIndexRequestV1,
  type BackfillIndexResponseV1,
  type BackgroundTaskErrorResponseV1,
  type BarChartContentSeriesV1,
  type BarChartContentV1,
  type BodySalesforceOauthTokenV1ApiPublicV1SalesforceOauthTokenTenantIdPost,
  type BodySlackUploadFilesV2ApiSlackV2TenantsTenantIdActionsFilesUploadPost,
  type BodyTeamsUploadIconV1ApiTeamsV1TenantsTenantIdIconsPost,
  type BrandingLogoUploadUrlRequestV1,
  type BrandingLogoUploadUrlResponseV1,
  type BrandingV1,
  type CalibrationFeedbackConversationFullV1,
  type CalibrationFeedbackConversationMessageContentBlockV1,
  type CalibrationFeedbackConversationMessageFileContentBlockV1,
  type CalibrationFeedbackConversationMessageFullV1,
  type CalibrationFeedbackConversationMessageKbCitationFullV1,
  type CalibrationFeedbackConversationMessageReasoningContentBlockV1,
  type CalibrationFeedbackConversationMessageTextContentBlockV1,
  type CalibrationFeedbackConversationMessageToolCallContentBlockV1,
  type CalibrationFeedbackConversationMessageToolCallResultContentBlockV1,
  type CalibrationFeedbackConversationToolCallArgsV1,
  type CalibrationFeedbackConversationToolCallResultV1,
  type CalibrationFeedbackDimensionFullV1,
  type CalibrationFeedbackDimensionV1,
  type CalibrationFeedbackDimensionValueV1,
  type CalibrationFeedbackInferenceDatapointFullV1,
  type CalibrationFeedbackInferenceDatapointV1,
  type CalibrationFeedbackQueueItemFullV1,
  CalibrationFeedbackQueueItemStatusV1,
  type CalibrationFeedbackQueueItemV1,
  CalibrationFeedbackReasoningRequestV1,
  type CalibrationFeedbackTagKeyV1,
  type CalibrationFeedbackTagValueV1,
  type CalibrationFeedbackVerdictDimensionV1,
  type CalibrationFeedbackVerdictFullV1,
  type CalibrationFeedbackVerdictV1,
  type CalibrationFeedbackVerdictWithDimensionsV1,
  type CapabilitiesV1,
  type ChangeCountsResponseV2,
  ChangeRequestFullSortV1,
  type ChangeRequestFullV1,
  type ChangeRequestLineRangeCommentThreadFullV1,
  type ChangeRequestLineRangeCommentThreadResolvedV1,
  type ChangeRequestLineRangeCommentThreadV1,
  type ChangeRequestReferenceLineV1,
  type ChangeRequestSearchContentV1,
  ChangeRequestSortV1,
  type ChangeRequestStatusClosedFullV1,
  ChangeRequestStatusKindV1,
  type ChangeRequestStatusOpenFullV1,
  type ChangeRequestStatusPublishedFullV1,
  type ChangeRequestStatusRejectedFullV1,
  type ChangeRequestV1,
  type ChangeStateCountsV2,
  type ChangeUsersResponseV2,
  type ChartContentV1,
  ChartKind,
  ChartSeriesModeV1,
  type ChartSummaryV1,
  type CitationArticleRefV1,
  type ClientOptions,
  ColorScaleV1,
  ColorV1,
  type CommentFullV1,
  type CommentThreadFullV1,
  type CommentThreadResolvedV1,
  type CommentV1,
  ConfluenceAdfSubsupTypeV1,
  type ConfluenceAdfV1,
  type ConfluenceAttachmentContentV1,
  type ConfluenceAttachmentV1,
  type ConfluenceCallbackPayloadV1,
  type ConfluenceCheckConnectionResponseV1,
  type ConfluenceCommentV1,
  type ConfluenceConnectedV1,
  type ConfluenceConnectResponseV1,
  type ConfluenceDisconnectedV1,
  type ConfluenceLabelV1,
  ConfluenceOauthScope,
  type ConfluenceOauthScopesResponseV1,
  type ConfluencePageContentV1,
  type ConfluencePageV1,
  type ConfluenceReadAdfV1Input,
  type ConfluenceReadAdfV1Output,
  type ConfluenceSpaceV1,
  type ConfluenceTenantFullV1,
  type ConfluenceTenantV1,
  type ConversationFeedbackLabelOnlyV1,
  type ConversationFeedbackLabelTextV1,
  ConversationFeedbackLabelV1,
  type ConversationFeedbackTextV1,
  type ConversationFeedbackV1,
  type ConversationFullV1,
  type ConversationFullV2,
  type ConversationInferenceCitationV1,
  type ConversationInferenceResponseV1,
  type ConversationInferenceResponseV2,
  type ConversationInferenceWithFinalizedConversationV1,
  type ConversationMessageContentBlockV1,
  type ConversationMessageFileContentBlockV1,
  type ConversationMessageFullV1,
  type ConversationMessageFullV2,
  type ConversationMessageKbCitationFullV1,
  type ConversationMessageReasoningContentBlockV1,
  ConversationMessageRoleV1Field,
  type ConversationMessageTextContentBlockV1,
  type ConversationMessageToolCallContentBlockV1,
  type ConversationMessageToolCallResultContentBlockV1,
  type ConversationMessageV1,
  type ConversationProdEvalItemV1,
  type ConversationSourceV1,
  type CreateAgentSessionInferenceParamsV1,
  type CreateAgentSessionV1,
  type CreateAgentTraceMessageContentBlockV1,
  type CreateAgentTraceMessageV1,
  type CreateApiKeyParamsV1,
  type CreateArticleLineRangeCommentThreadCommentParamsV1,
  type CreateArticleLineRangeCommentThreadParamsV1,
  type CreateBotUserParamsV1,
  type CreateCalibrationFeedbackConversationMessageContentBlocksV1,
  type CreateCalibrationFeedbackConversationMessageContentBlockV1,
  type CreateCalibrationFeedbackConversationMessageContentV1,
  type CreateCalibrationFeedbackConversationMessageFileContentBlockV1,
  type CreateCalibrationFeedbackConversationMessageKbCitationV1,
  type CreateCalibrationFeedbackConversationMessageTextContentBlockV1,
  type CreateCalibrationFeedbackConversationMessageV1,
  type CreateCalibrationFeedbackDimensionParamsV1,
  type CreateCalibrationFeedbackDimensionValueParamsV1,
  type CreateCalibrationFeedbackInferenceDatapointParamsV1,
  type CreateCalibrationFeedbackInferenceDatapointsParamsV1,
  type CreateCalibrationFeedbackInferenceDatapointsResultV1,
  type CreateCalibrationFeedbackQueueItemParamsV1,
  type CreateCalibrationFeedbackQueueItemsParamsV1,
  type CreateCalibrationFeedbackQueueItemsResultV1,
  type CreateCalibrationFeedbackVerdictDimensionParamsV1,
  type CreateCalibrationFeedbackVerdictParamsV1,
  type CreateChangeRequestLineRangeCommentThreadCommentParamsV1,
  type CreateChangeRequestLineRangeCommentThreadParamsV1,
  type CreateChangeRequestParamsV1,
  type CreateConfluencePageParamsV1,
  type CreateConfluenceTenantParamsV1,
  type CreateConversationFeedbackResponseV2,
  type CreateConversationMessageContentBlocksV1,
  type CreateConversationMessageContentBlockV1,
  type CreateConversationMessageContentV1,
  type CreateConversationMessageFileContentBlockV1,
  type CreateConversationMessageKbCitationV1,
  type CreateConversationMessageTextContentBlockV1,
  type CreateConversationMessageV1,
  type CreateDataDumpConversationRequestV1,
  type CreateDatapointsDatapointV3,
  type CreateDatapointsItemV3,
  type CreateDatapointsRequestV3,
  type CreateDatapointsResponseItemV3,
  type CreateDatapointsResponseV3,
  type CreateEntraProposedActionParamsV1,
  type CreateEntraTenantParamsV1,
  type CreateExternalInferenceCitationV1,
  type CreateExternalInferenceFinalizedConversationItemV1,
  type CreateExternalInferenceInlineItemV1,
  type CreateExternalInferencesParamsV1,
  type CreateExternalInferencesResponseV1,
  type CreateFeedbackLabelParamsV1,
  type CreateFinalizedConversationConversationV2,
  type CreateFinalizedConversationRequestV2,
  type CreateFinalizedConversationResponseV2,
  type CreateFinalizedConversationV2,
  type CreateFreshserviceArticleParamsV1,
  type CreateFreshserviceFolderParamsV1,
  type CreateFreshserviceTenantParamsV1,
  type CreateFreshserviceTicketParamsV1,
  type CreateHubSpotTenantParamsV1,
  type CreateInferenceDatapointParamsV2,
  type CreateInferenceDatapointsDequeueByDagsterRunV1,
  type CreateInferenceDatapointsDequeueByIdsV1,
  type CreateInferenceDatapointsDequeueRequestV1,
  type CreateInferenceDatapointsDequeueResponseV1,
  type CreateInferenceDatapointsEnqueueByDagsterRunV1,
  type CreateInferenceDatapointsEnqueueByIdsV1,
  type CreateInferenceDatapointsEnqueueRequestV1,
  type CreateInferenceDatapointsEnqueueResponseV1,
  type CreateInferenceDatapointsInputItemV1,
  type CreateInferenceDatapointsInputRequestV1,
  type CreateInferenceDatapointsInputResponseV1,
  type CreateInferenceDatapointsOutputDatapointV1,
  type CreateInferenceDatapointsOutputItemV1,
  type CreateInferenceDatapointsOutputRequestV1,
  type CreateInferenceDatapointsOutputResponseV1,
  type CreateInferenceFeedbackLabelParamsV1,
  type CreateInferenceFeedbackParamsV1,
  type CreateInvitationParamsV1,
  type CreateJiraTenantParamsV1,
  type CreateJudgeKindOrdinalV2,
  type CreateJudgementItemV2,
  type CreateJudgementItemV3,
  type CreateJudgementsParamsV2,
  type CreateJudgementsParamsV3,
  type CreateJudgementsResultV3,
  type CreateJudgeOrdinalValueV2,
  type CreateJudgeParamsV1,
  type CreateJudgeParamsV2,
  type CreateJudgesJudgeV2,
  type CreateJudgesKindOrdinalV2,
  type CreateJudgesOrdinalValueV2,
  type CreateJudgesParamsV2,
  type CreateKanonicalDatapointsRequestV2,
  type CreateKanonicalDatapointsResponseItemV2,
  type CreateKanonicalDatapointsResponseV2,
  type CreateKanonicalDatapointV2,
  type CreateKanonicalInputOutputV2,
  type CreateKanonicalMessagesV2,
  type CreateKbAccessRequestParamsV1,
  type CreateKbIngestionFileItemV1,
  type CreateKbIngestionFilesParamsV1,
  type CreateKnowledgeBaseParamsV2,
  type CreateMachineUserApiKeyParamsV1,
  type CreateMachineUserParamsV1,
  type CreateNotionBlocksParamsV1,
  type CreateNotionBlocksResponseV1,
  type CreateNotionPageParamsV1,
  type CreateNotionTenantParamsV1,
  type CreateOAuthApplicationParamsV1,
  type CreateOutlookSubscriptionsParamsV2,
  type CreateOutlookSubscriptionsResponseV2,
  type CreateOutlookSubscriptionsSubscriptionSuccessV2,
  type CreatePlainTenantParamsV1,
  type CreateProdEvalsDequeueByDagsterRunV1,
  type CreateProdEvalsDequeueByIdsV1,
  type CreateProdEvalsDequeueRequestV1,
  type CreateProdEvalsDequeueResponseV1,
  type CreateProdEvalsEnqueueByDagsterRunV1,
  type CreateProdEvalsEnqueueByIdsV1,
  type CreateProdEvalsEnqueueRequestV1,
  type CreateProdEvalsEnqueueResponseV1,
  type CreateProdEvalsInputItemV1,
  type CreateProdEvalsInputRequestV1,
  type CreateProdEvalsInputResponseV1,
  type CreateProdEvalsOutputItemV1,
  type CreateProdEvalsOutputJudgementV1,
  type CreateProdEvalsOutputRequestV1,
  type CreateProdEvalsOutputResponseV1,
  type CreatePromptParamsV1,
  type CreateSalesforceArticleParamsV1,
  type CreateSalesforceCaseCommentParamsV1,
  type CreateSalesforceCaseEmailDraftParamsV1,
  type CreateSalesforceCaseParamsV1,
  type CreateSalesforceTenantParamsV1,
  type CreateSecretParamsV1,
  type CreateSecretParamsV2,
  type CreateServiceNowArticleV1,
  type CreateServiceNowKnowledgeBaseV1,
  type CreateSharepointFolderScopeParamsV1,
  type CreateSharepointItemUploadSessionParamsV1,
  type CreateSharepointSiteParamsV1,
  type CreateSharepointTenantParamsV1,
  type CreateSimulationDatapointConversationsV1,
  type CreateSimulationDatapointParamsV1,
  type CreateSimulationDatapointsParamsV1,
  type CreateSimulationDatapointsResultV1,
  type CreateSimulationResultJudgementBatchItemV1,
  type CreateSimulationResultJudgementItemV1,
  type CreateSimulationResultJudgementsBatchParamsV1,
  type CreateSimulationResultJudgementsBatchResultV1,
  type CreateSimulationResultJudgementsParamsV1,
  type CreateSimulationResultJudgementsResultV1,
  type CreateSimulationResultParamsV1,
  type CreateSimulationResultsParamsV1,
  type CreateSimulationResultsResultV1,
  type CreateSlackTenantParamsV1,
  type CreateStatefulInferenceConversationInferencePayloadV1,
  type CreateStatelessConversationInferenceV1,
  type CreateStatelessInferenceConversationInferencePayloadV1,
  type CreateSupportIngestionFileItemV1,
  type CreateSupportIngestionFilesParamsV1,
  type CreateTaskParamsV2,
  type CreateTeamParamsV1,
  type CreateTeamsTenantParamsV1,
  type CreateWorkClaimParamsV1,
  type CreateWorkClaimResponseV1,
  type CreateWorkEventParamsV1,
  type CreateWorkflowAnalyticsEventRequestV1,
  type CreateWorkflowAnalyticsEventResponseV1,
  type CursorPageV1ConfluenceAttachmentV1,
  type CursorPageV1ConfluenceCommentV1,
  type CursorPageV1ConfluenceLabelV1,
  type CursorPageV1ConfluencePageV1,
  type CursorPageV1ConfluenceSpaceV1,
  type CursorPageV1NotionCommentV1,
  type CursorPageV1NotionDatabaseV1,
  type CursorPageV1NotionPageV1,
  type CursorPageV1PlainCompanyV1,
  type CursorPageV1PlainCustomerGroupV1,
  type CursorPageV1PlainCustomerTenantV1,
  type CursorPageV1PlainCustomerV1,
  type CursorPageV1PlainThreadV1,
  type CursorPageV1PlainTimelineEntryV1,
  type CursorPageV1SharepointDriveItemV1,
  type CursorPageV1SharepointDriveV1,
  type CursorPageV1SimulationCompareV1,
  type CursorPageV1SimulationRunV1,
  type CursorPageV1WorkEventFullV1,
  type DataDumpConversationFullV1,
  type DataDumpConversationV1,
  type DatapointEvidenceV1,
  type DatapointExtractedInputOutputFullV1,
  type DatapointExtractedInputOutputFullV2,
  type DatapointExtractedInputOutputV2,
  type DatapointFullV3,
  type DatapointV2,
  type DebugFgaTupleV1,
  type DebugOpenFgaCheckParamsV1,
  type DebugOpenFgaCheckResultV1,
  type DebugOpenFgaReadParamsV1,
  type DebugOpenFgaReadResultV1,
  type DebugOpenFgaWriteParamsV1,
  type DebugOpenFgaWriteResultV1,
  type DebugReaderPoolCheckV1,
  type DeleteApiConfluenceV1TenantsByTenantIdData,
  type DeleteApiConfluenceV1TenantsByTenantIdError,
  type DeleteApiConfluenceV1TenantsByTenantIdErrors,
  type DeleteApiConfluenceV1TenantsByTenantIdResponse,
  type DeleteApiConfluenceV1TenantsByTenantIdResponses,
  type DeleteApiEntraV1TenantsByTenantIdData,
  type DeleteApiEntraV1TenantsByTenantIdError,
  type DeleteApiEntraV1TenantsByTenantIdErrors,
  type DeleteApiEntraV1TenantsByTenantIdResponse,
  type DeleteApiEntraV1TenantsByTenantIdResponses,
  type DeleteApiFreshserviceV1TenantsByTenantIdData,
  type DeleteApiFreshserviceV1TenantsByTenantIdError,
  type DeleteApiFreshserviceV1TenantsByTenantIdErrors,
  type DeleteApiFreshserviceV1TenantsByTenantIdResponse,
  type DeleteApiFreshserviceV1TenantsByTenantIdResponses,
  type DeleteApiJiraV1TenantsByTenantIdData,
  type DeleteApiJiraV1TenantsByTenantIdError,
  type DeleteApiJiraV1TenantsByTenantIdErrors,
  type DeleteApiJiraV1TenantsByTenantIdResponse,
  type DeleteApiJiraV1TenantsByTenantIdResponses,
  type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
  type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
  type DeleteApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  type DeleteApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  type DeleteApiNotionV1TenantsByTenantIdData,
  type DeleteApiNotionV1TenantsByTenantIdError,
  type DeleteApiNotionV1TenantsByTenantIdErrors,
  type DeleteApiNotionV1TenantsByTenantIdResponse,
  type DeleteApiNotionV1TenantsByTenantIdResponses,
  type DeleteApiOutlookV2SubscriptionsBySubscriptionIdData,
  type DeleteApiOutlookV2SubscriptionsBySubscriptionIdError,
  type DeleteApiOutlookV2SubscriptionsBySubscriptionIdErrors,
  type DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponse,
  type DeleteApiOutlookV2SubscriptionsBySubscriptionIdResponses,
  type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
  type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
  type DeleteApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdData,
  type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdError,
  type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdErrors,
  type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponse,
  type DeleteApiPlainV1TenantsByTenantIdActionsPlainTenantsByPlainTenantIdResponses,
  type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
  type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
  type DeleteApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  type DeleteApiPlainV1TenantsByTenantIdData,
  type DeleteApiPlainV1TenantsByTenantIdError,
  type DeleteApiPlainV1TenantsByTenantIdErrors,
  type DeleteApiPlainV1TenantsByTenantIdResponse,
  type DeleteApiPlainV1TenantsByTenantIdResponses,
  type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdData,
  type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdError,
  type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdErrors,
  type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponse,
  type DeleteApiSalesforceV1TenantsByTenantIdActionsArticlesByMasterIdResponses,
  type DeleteApiSalesforceV1TenantsByTenantIdData,
  type DeleteApiSalesforceV1TenantsByTenantIdError,
  type DeleteApiSalesforceV1TenantsByTenantIdErrors,
  type DeleteApiSalesforceV1TenantsByTenantIdIngestClientData,
  type DeleteApiSalesforceV1TenantsByTenantIdIngestClientError,
  type DeleteApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  type DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  type DeleteApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  type DeleteApiSalesforceV1TenantsByTenantIdResponse,
  type DeleteApiSalesforceV1TenantsByTenantIdResponses,
  type DeleteApiSecretsVaultV1SecretsBySecretIdData,
  type DeleteApiSecretsVaultV1SecretsBySecretIdError,
  type DeleteApiSecretsVaultV1SecretsBySecretIdErrors,
  type DeleteApiSecretsVaultV1SecretsBySecretIdResponse,
  type DeleteApiSecretsVaultV1SecretsBySecretIdResponses,
  type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
  type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
  type DeleteApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  type DeleteApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  type DeleteApiSharepointV1TenantsByTenantIdData,
  type DeleteApiSharepointV1TenantsByTenantIdError,
  type DeleteApiSharepointV1TenantsByTenantIdErrors,
  type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdData,
  type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdError,
  type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdErrors,
  type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponse,
  type DeleteApiSharepointV1TenantsByTenantIdFolderScopesByFolderScopeIdResponses,
  type DeleteApiSharepointV1TenantsByTenantIdResponse,
  type DeleteApiSharepointV1TenantsByTenantIdResponses,
  type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdData,
  type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdError,
  type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdErrors,
  type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponse,
  type DeleteApiSharepointV1TenantsByTenantIdSitesBySiteIdResponses,
  type DeleteApiSlackV1TenantsByTenantIdData,
  type DeleteApiSlackV1TenantsByTenantIdError,
  type DeleteApiSlackV1TenantsByTenantIdErrors,
  type DeleteApiSlackV1TenantsByTenantIdResponse,
  type DeleteApiSlackV1TenantsByTenantIdResponses,
  type DeleteApiTeamsV1TenantsByTenantIdData,
  type DeleteApiTeamsV1TenantsByTenantIdError,
  type DeleteApiTeamsV1TenantsByTenantIdErrors,
  type DeleteApiTeamsV1TenantsByTenantIdResponse,
  type DeleteApiTeamsV1TenantsByTenantIdResponses,
  type DeleteApiV1AgentSessionsByAgentSessionIdData,
  type DeleteApiV1AgentSessionsByAgentSessionIdError,
  type DeleteApiV1AgentSessionsByAgentSessionIdErrors,
  type DeleteApiV1AgentSessionsByAgentSessionIdResponse,
  type DeleteApiV1AgentSessionsByAgentSessionIdResponses,
  type DeleteApiV1ApiKeysByApiKeyIdData,
  type DeleteApiV1ApiKeysByApiKeyIdError,
  type DeleteApiV1ApiKeysByApiKeyIdErrors,
  type DeleteApiV1ApiKeysByApiKeyIdResponse,
  type DeleteApiV1ApiKeysByApiKeyIdResponses,
  type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  type DeleteApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  type DeleteApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  type DeleteApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  type DeleteApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdError,
  type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
  type DeleteApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
  type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
  type DeleteApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
  type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
  type DeleteApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  type DeleteApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  type DeleteApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  type DeleteApiV1ChangeRequestsByChangeRequestIdData,
  type DeleteApiV1ChangeRequestsByChangeRequestIdError,
  type DeleteApiV1ChangeRequestsByChangeRequestIdErrors,
  type DeleteApiV1ChangeRequestsByChangeRequestIdResponse,
  type DeleteApiV1ChangeRequestsByChangeRequestIdResponses,
  type DeleteApiV1CommentsByCommentIdData,
  type DeleteApiV1CommentsByCommentIdError,
  type DeleteApiV1CommentsByCommentIdErrors,
  type DeleteApiV1CommentsByCommentIdResponse,
  type DeleteApiV1CommentsByCommentIdResponses,
  type DeleteApiV1DataDumpConversationsByDataDumpConversationIdData,
  type DeleteApiV1DataDumpConversationsByDataDumpConversationIdError,
  type DeleteApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  type DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponse,
  type DeleteApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  type DeleteApiV1ExternalInferencesByInferenceIdData,
  type DeleteApiV1ExternalInferencesByInferenceIdError,
  type DeleteApiV1ExternalInferencesByInferenceIdErrors,
  type DeleteApiV1ExternalInferencesByInferenceIdResponse,
  type DeleteApiV1ExternalInferencesByInferenceIdResponses,
  type DeleteApiV1FinalizedConversationsByFinalizedConversationIdData,
  type DeleteApiV1FinalizedConversationsByFinalizedConversationIdError,
  type DeleteApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  type DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponse,
  type DeleteApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  type DeleteApiV1HubspotTenantsByTenantIdData,
  type DeleteApiV1HubspotTenantsByTenantIdError,
  type DeleteApiV1HubspotTenantsByTenantIdErrors,
  type DeleteApiV1HubspotTenantsByTenantIdResponse,
  type DeleteApiV1HubspotTenantsByTenantIdResponses,
  type DeleteApiV1InferenceDatapointsByInferenceDatapointIdData,
  type DeleteApiV1InferenceDatapointsByInferenceDatapointIdError,
  type DeleteApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  type DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  type DeleteApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  type DeleteApiV1JudgesByJudgeIdData,
  type DeleteApiV1JudgesByJudgeIdError,
  type DeleteApiV1JudgesByJudgeIdErrors,
  type DeleteApiV1JudgesByJudgeIdResponse,
  type DeleteApiV1JudgesByJudgeIdResponses,
  type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  type DeleteApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  type DeleteApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  type DeleteApiV1KbSimulationResultsBySimulationResultIdData,
  type DeleteApiV1KbSimulationResultsBySimulationResultIdError,
  type DeleteApiV1KbSimulationResultsBySimulationResultIdErrors,
  type DeleteApiV1KbSimulationResultsBySimulationResultIdResponse,
  type DeleteApiV1KbSimulationResultsBySimulationResultIdResponses,
  type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdData,
  type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdError,
  type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdErrors,
  type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponse,
  type DeleteApiV1MachineUsersByMachineUserIdApiKeysByApiKeyIdResponses,
  type DeleteApiV1MachineUsersByMachineUserIdData,
  type DeleteApiV1MachineUsersByMachineUserIdError,
  type DeleteApiV1MachineUsersByMachineUserIdErrors,
  type DeleteApiV1MachineUsersByMachineUserIdResponse,
  type DeleteApiV1MachineUsersByMachineUserIdResponses,
  type DeleteApiV1OauthApplicationsByOauthApplicationIdData,
  type DeleteApiV1OauthApplicationsByOauthApplicationIdError,
  type DeleteApiV1OauthApplicationsByOauthApplicationIdErrors,
  type DeleteApiV1OauthApplicationsByOauthApplicationIdResponse,
  type DeleteApiV1OauthApplicationsByOauthApplicationIdResponses,
  type DeleteApiV1ReposByRepositoryIdBranchesByNameData,
  type DeleteApiV1ReposByRepositoryIdBranchesByNameError,
  type DeleteApiV1ReposByRepositoryIdBranchesByNameErrors,
  type DeleteApiV1ReposByRepositoryIdBranchesByNameResponse,
  type DeleteApiV1ReposByRepositoryIdBranchesByNameResponses,
  type DeleteApiV1ServiceNowTenantsByTenantIdData,
  type DeleteApiV1ServiceNowTenantsByTenantIdError,
  type DeleteApiV1ServiceNowTenantsByTenantIdErrors,
  type DeleteApiV1ServiceNowTenantsByTenantIdResponse,
  type DeleteApiV1ServiceNowTenantsByTenantIdResponses,
  type DeleteApiV1SesameEdraAccessData,
  type DeleteApiV1SesameEdraAccessError,
  type DeleteApiV1SesameEdraAccessErrors,
  type DeleteApiV1SesameEdraAccessResponse,
  type DeleteApiV1SesameEdraAccessResponses,
  type DeleteApiV1UsersByUserIdData,
  type DeleteApiV1UsersByUserIdError,
  type DeleteApiV1UsersByUserIdErrors,
  type DeleteApiV1UsersByUserIdResponse,
  type DeleteApiV1UsersByUserIdResponses,
  type DeleteApiV1WorkClaimsByClaimIdData,
  type DeleteApiV1WorkClaimsByClaimIdError,
  type DeleteApiV1WorkClaimsByClaimIdErrors,
  type DeleteApiV1WorkClaimsByClaimIdResponse,
  type DeleteApiV1WorkClaimsByClaimIdResponses,
  type DeleteApiV1WorkspacesByWorkspaceIdData,
  type DeleteApiV1WorkspacesByWorkspaceIdError,
  type DeleteApiV1WorkspacesByWorkspaceIdErrors,
  type DeleteApiV1WorkspacesByWorkspaceIdResponse,
  type DeleteApiV1WorkspacesByWorkspaceIdResponses,
  type DeleteApiV1ZendeskTenantsByTenantIdData,
  type DeleteApiV1ZendeskTenantsByTenantIdError,
  type DeleteApiV1ZendeskTenantsByTenantIdErrors,
  type DeleteApiV1ZendeskTenantsByTenantIdResponse,
  type DeleteApiV1ZendeskTenantsByTenantIdResponses,
  type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  type DeleteApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  type DeleteApiV2DatapointsByDatapointIdData,
  type DeleteApiV2DatapointsByDatapointIdError,
  type DeleteApiV2DatapointsByDatapointIdErrors,
  type DeleteApiV2DatapointsByDatapointIdResponse,
  type DeleteApiV2DatapointsByDatapointIdResponses,
  type DeleteApiV2InferenceConversationsByExternalIdData,
  type DeleteApiV2InferenceConversationsByExternalIdError,
  type DeleteApiV2InferenceConversationsByExternalIdErrors,
  type DeleteApiV2InferenceConversationsByExternalIdResponse,
  type DeleteApiV2InferenceConversationsByExternalIdResponses,
  type DeleteApiV2JudgementsByJudgementIdData,
  type DeleteApiV2JudgementsByJudgementIdError,
  type DeleteApiV2JudgementsByJudgementIdErrors,
  type DeleteApiV2JudgementsByJudgementIdResponse,
  type DeleteApiV2JudgementsByJudgementIdResponses,
  type DeleteApiV2JudgesByJudgeIdData,
  type DeleteApiV2JudgesByJudgeIdError,
  type DeleteApiV2JudgesByJudgeIdErrors,
  type DeleteApiV2JudgesByJudgeIdResponse,
  type DeleteApiV2JudgesByJudgeIdResponses,
  type DeleteApiV2TasksByTaskIdData,
  type DeleteApiV2TasksByTaskIdError,
  type DeleteApiV2TasksByTaskIdErrors,
  type DeleteApiV2TasksByTaskIdResponse,
  type DeleteApiV2TasksByTaskIdResponses,
  type DeleteApiV3JudgementsByJudgementIdData,
  type DeleteApiV3JudgementsByJudgementIdError,
  type DeleteApiV3JudgementsByJudgementIdErrors,
  type DeleteApiV3JudgementsByJudgementIdResponse,
  type DeleteApiV3JudgementsByJudgementIdResponses,
  type DeleteApiV3KbsByKbIdData,
  type DeleteApiV3KbsByKbIdError,
  type DeleteApiV3KbsByKbIdErrors,
  type DeleteApiV3KbsByKbIdResponse,
  type DeleteApiV3KbsByKbIdResponses,
  type DeleteSubscriptionResponseV2,
  type DiffEntryV2,
  EdraAccessGrantResultV1,
  type EdraAccessGrantV1,
  EdraAccessRemovalResultV1,
  type EdraAccessRemovalV1,
  type EdraAccessRoleChangeV1,
  type EdraAccessRoleParamsV1,
  EdraAccessRoleV1,
  EdraAccessStateV1,
  type EdraAccessV1,
  type EmailNotificationSettingV1,
  type EmbedDatapointsRequestV1,
  type EmbedDatapointsResponseV1,
  type EmbeddingSearchParamsV1,
  type EmbeddingSearchResponseV1,
  type EmbeddingSearchSourceV1,
  type EmbedResponseV2,
  type EntraAddGroupMemberActionV1,
  type EntraAssignLicenseActionV1,
  type EntraCallerIdentityV1,
  EntraCallerTokenModeV1,
  type EntraCapabilityCheckV1,
  EntraCapabilityV1,
  type EntraCertificateCredentialsParamsV1,
  type EntraCheckConnectionResponseV1,
  type EntraClientSecretCredentialsParamsV1,
  type EntraConnectedV1,
  EntraCredentialKindV1,
  type EntraDeleteUserActionV1,
  type EntraDirectoryObjectPageV1,
  type EntraDirectoryObjectV1,
  type EntraDirectoryRolesV1,
  type EntraDirectoryRoleV1,
  type EntraDisableUserActionV1,
  type EntraDisconnectedV1,
  EntraGroupKindV1,
  EntraGroupMembershipKindV1,
  type EntraGroupPageV1,
  type EntraGroupV1,
  type EntraLicenseDetailsV1,
  type EntraLicenseDetailV1,
  type EntraOrganizationV1,
  type EntraPermissionPreflightV1,
  type EntraProposedActionExecutedV1,
  type EntraProposedActionExecutingV1,
  type EntraProposedActionFailedV1,
  type EntraProposedActionProposedV1,
  type EntraProposedActionRejectedV1,
  type EntraProposedActionSpecV1,
  type EntraProposedActionStatusV1,
  type EntraProposedActionV1,
  type EntraRemoveGroupMemberActionV1,
  type EntraRemoveLicenseActionV1,
  type EntraServicePlanV1,
  type EntraSetManagerActionV1,
  type EntraSignInStateV1,
  type EntraSubscribedSkusV1,
  type EntraSubscribedSkuV1,
  type EntraTenantCredentialsParamsV1,
  type EntraTenantCredentialsSummaryV1,
  type EntraTenantFullV1,
  type EntraTenantV1,
  type EntraUserManagerV1,
  type EntraUserPageV1,
  type EntraUserV1,
  type EvalJudgeV1,
  EvalKindV1,
  type EvaluatedInferenceDatapointV1,
  type EvaluatedInferenceFullV1,
  type EventSourceNotificationSettingsV1,
  type EvidenceV2,
  type ExternalInferenceCitationV1,
  type ExternalInferenceFullV1,
  type ExternalInferenceSourceV1,
  type ExternalInferenceV1,
  type ExtractDataDumpConversationsDequeueByDagsterRunV1,
  type ExtractDataDumpConversationsDequeueByIdsV1,
  type ExtractDataDumpConversationsDequeueRequestV1,
  type ExtractDataDumpConversationsDequeueResponseV1,
  type ExtractDataDumpConversationsEnqueueByDagsterRunV1,
  type ExtractDataDumpConversationsEnqueueByIdsV1,
  type ExtractDataDumpConversationsEnqueueRequestV1,
  type ExtractDataDumpConversationsEnqueueResponseV1,
  type ExtractDataDumpConversationsInputRequestV1,
  type ExtractDataDumpConversationsInputResponseV1,
  type ExtractDataDumpConversationsOutputRequestV1,
  type ExtractDataDumpConversationsOutputResponseV1,
  type ExtractDatapointsDequeueByDagsterRunV1,
  type ExtractDatapointsDequeueByIdsV1,
  type ExtractDatapointsDequeueRequestV1,
  type ExtractDatapointsDequeueResponseV1,
  type ExtractDatapointsEnqueueByDagsterRunV1,
  type ExtractDatapointsEnqueueByIdsV1,
  type ExtractDatapointsEnqueueRequestV1,
  type ExtractDatapointsEnqueueResponseV1,
  type ExtractDatapointsInputItemV1,
  type ExtractDatapointsInputRequestV1,
  type ExtractDatapointsInputResponseV1,
  type ExtractDatapointsOutputItemV1,
  type ExtractDatapointsOutputRequestV1,
  type ExtractDatapointsOutputResponseV1,
  type ExtractedConversationFullV2,
  type ExtractedConversationSpanV1,
  type ExtractedConversationV2,
  type ExtractedInputOutputSpansV1,
  type ExtractedMessagesAndSpansFullV1,
  type ExtractIncomingKnowledgeBasesDequeueByDagsterRunV1,
  type ExtractIncomingKnowledgeBasesDequeueByIdsV1,
  type ExtractIncomingKnowledgeBasesDequeueRequestV1,
  type ExtractIncomingKnowledgeBasesDequeueResponseV1,
  type ExtractIncomingKnowledgeBasesEnqueueByDagsterRunV1,
  type ExtractIncomingKnowledgeBasesEnqueueByIdsV1,
  type ExtractIncomingKnowledgeBasesEnqueueRequestV1,
  type ExtractIncomingKnowledgeBasesEnqueueResponseV1,
  type ExtractIncomingKnowledgeBasesInputRequestV1,
  type ExtractIncomingKnowledgeBasesInputResponseV1,
  type ExtractIncomingKnowledgeBasesOutputRequestV1,
  type ExtractIncomingKnowledgeBasesOutputResponseV1,
  type FailedWorkflowRunV1,
  type FinalizeConversationsDequeueByDagsterRunV1,
  type FinalizeConversationsDequeueByIdsV1,
  type FinalizeConversationsDequeueRequestV1,
  type FinalizeConversationsDequeueResponseV1,
  type FinalizeConversationsEnqueueByDagsterRunV1,
  type FinalizeConversationsEnqueueByIdsV1,
  type FinalizeConversationsEnqueueRequestV1,
  type FinalizeConversationsEnqueueResponseV1,
  type FinalizeConversationsInputInferenceConversationV1,
  type FinalizeConversationsInputItemV1,
  type FinalizeConversationsInputRequestV1,
  type FinalizeConversationsInputResponseV1,
  type FinalizeConversationsOutputRequestV1,
  type FinalizeConversationsOutputResponseV1,
  type FinalizedConversationConversationFullV1,
  type FinalizedConversationFullV1,
  type FinalizedConversationFullV2,
  type FinalizedConversationMessageFullV1,
  type FinalizedConversationMessageV1,
  type FinalizedConversationSourceV1,
  type FinalizedConversationV1,
  type FinetuneKnowedgeBasesKnowledgeBaseV1,
  type FinetuneKnowledgeBasesCreateChangeRequestV1,
  type FinetuneKnowledgeBasesDequeueByDagsterRunV1,
  type FinetuneKnowledgeBasesDequeueByIdsV1,
  type FinetuneKnowledgeBasesDequeueRequestV1,
  type FinetuneKnowledgeBasesDequeueResponseV1,
  type FinetuneKnowledgeBasesEnqueueByDagsterRunV1,
  type FinetuneKnowledgeBasesEnqueueByIdsV1,
  type FinetuneKnowledgeBasesEnqueueRequestV1,
  type FinetuneKnowledgeBasesEnqueueResponseV1,
  type FinetuneKnowledgeBasesGitCommitV1,
  type FinetuneKnowledgeBasesInputRequestV1,
  type FinetuneKnowledgeBasesInputResponseV1,
  type FinetuneKnowledgeBasesOutputRequestV1,
  type FinetuneKnowledgeBasesOutputResponseV1,
  type FinetuneKnowledgeBasesUpdatesV1,
  type FreshserviceAddNoteToTicketParamsV1,
  type FreshserviceAgentPageV1,
  type FreshserviceAgentV1,
  type FreshserviceArticleListV1,
  FreshserviceArticleStatusV1,
  type FreshserviceArticleV1,
  type FreshserviceCategoryListV1,
  type FreshserviceCategoryV1,
  type FreshserviceCheckConnectionResponseV1,
  type FreshserviceConversationListV1,
  type FreshserviceConversationV1,
  type FreshserviceFolderListV1,
  type FreshserviceFolderV1,
  type FreshserviceProvisionWebhookResponseV1,
  type FreshserviceReplyToTicketParamsV1,
  type FreshserviceRequesterPageV1,
  type FreshserviceRequesterV1,
  type FreshserviceTenantFullV1,
  FreshserviceTenantStatusV1,
  type FreshserviceTenantV1,
  FreshserviceTicketImpactV1,
  type FreshserviceTicketPageV1,
  FreshserviceTicketPriorityV1,
  FreshserviceTicketStatusV1,
  FreshserviceTicketUrgencyV1,
  type FreshserviceTicketV1,
  type FreshserviceWebhookResponseV1,
  type FrontendConfigV1,
  type FullEvaluatedInferenceDatapointsSearchByArticleV1,
  type FullEvaluatedInferenceDatapointsSearchByKnowledgeBaseV1,
  type FullEvaluatedInferenceDatapointsSearchByPathV1,
  type FullEvaluatedInferenceDatapointsSearchByV1,
  type FullEvaluatedInferenceDatapointV1,
  type GenericSecretPlainValueV2,
  type GenericSecretValueParamsV1,
  type GetA2aAgentsResponseV1,
  type GetAgentsResponseV1,
  type GetAnalyticsChartContentResponseV1,
  type GetApiConfluenceV1OauthScopesData,
  type GetApiConfluenceV1OauthScopesResponse,
  type GetApiConfluenceV1OauthScopesResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentData,
  type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentError,
  type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsAttachmentsByAttachmentIdContentResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsData,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsError,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdAttachmentsResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentData,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentError,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsData,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsError,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdLabelsResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesData,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesError,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  type GetApiConfluenceV1TenantsByTenantIdActionsSpacesData,
  type GetApiConfluenceV1TenantsByTenantIdActionsSpacesError,
  type GetApiConfluenceV1TenantsByTenantIdActionsSpacesErrors,
  type GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponse,
  type GetApiConfluenceV1TenantsByTenantIdActionsSpacesResponses,
  type GetApiConfluenceV1TenantsByTenantIdCheckConnectionData,
  type GetApiConfluenceV1TenantsByTenantIdCheckConnectionError,
  type GetApiConfluenceV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiConfluenceV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiConfluenceV1TenantsByTenantIdData,
  type GetApiConfluenceV1TenantsByTenantIdError,
  type GetApiConfluenceV1TenantsByTenantIdErrors,
  type GetApiConfluenceV1TenantsByTenantIdResponse,
  type GetApiConfluenceV1TenantsByTenantIdResponses,
  type GetApiConfluenceV1TenantsData,
  type GetApiConfluenceV1TenantsError,
  type GetApiConfluenceV1TenantsErrors,
  type GetApiConfluenceV1TenantsResponse,
  type GetApiConfluenceV1TenantsResponses,
  type GetApiDebugV1GetPoolStatsData,
  type GetApiDebugV1GetPoolStatsResponse,
  type GetApiDebugV1GetPoolStatsResponses,
  type GetApiDebugV1KeyErrorData,
  type GetApiDebugV1KeyErrorResponses,
  type GetApiDebugV1LogErrorData,
  type GetApiDebugV1LogErrorResponses,
  type GetApiDebugV1LogSentryAlertData,
  type GetApiDebugV1LogSentryAlertResponses,
  type GetApiDebugV1PrintLogsData,
  type GetApiDebugV1PrintLogsResponses,
  type GetApiDebugV1ReaderPoolCheckData,
  type GetApiDebugV1ReaderPoolCheckResponse,
  type GetApiDebugV1ReaderPoolCheckResponses,
  type GetApiDebugV1Return500Data,
  type GetApiDebugV1Return500Responses,
  type GetApiDebugV1UnwrapErrorData,
  type GetApiDebugV1UnwrapErrorResponses,
  type GetApiDebugV1ValkeyPingData,
  type GetApiDebugV1ValkeyPingResponse,
  type GetApiDebugV1ValkeyPingResponses,
  type GetApiDebugV1ValkeyValuesByKeyData,
  type GetApiDebugV1ValkeyValuesByKeyError,
  type GetApiDebugV1ValkeyValuesByKeyErrors,
  type GetApiDebugV1ValkeyValuesByKeyResponse,
  type GetApiDebugV1ValkeyValuesByKeyResponses,
  type GetApiEntraV1FullTenantsData,
  type GetApiEntraV1FullTenantsError,
  type GetApiEntraV1FullTenantsErrors,
  type GetApiEntraV1FullTenantsResponse,
  type GetApiEntraV1FullTenantsResponses,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersData,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersError,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersErrors,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponse,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesByRoleIdMembersResponses,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesData,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesError,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesErrors,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponse,
  type GetApiEntraV1TenantsByTenantIdActionsDirectoryRolesResponses,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdData,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdError,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdErrors,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersData,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersError,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersErrors,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponse,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdMembersResponses,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponse,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsByGroupIdResponses,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsData,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsError,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsErrors,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsResponse,
  type GetApiEntraV1TenantsByTenantIdActionsGroupsResponses,
  type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusData,
  type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusError,
  type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusErrors,
  type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponse,
  type GetApiEntraV1TenantsByTenantIdActionsSubscribedSkusResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyDirectReportsResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyGroupsResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyLicensesResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyManagerResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeyResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersByUserKeySignInStateResponses,
  type GetApiEntraV1TenantsByTenantIdActionsUsersData,
  type GetApiEntraV1TenantsByTenantIdActionsUsersError,
  type GetApiEntraV1TenantsByTenantIdActionsUsersErrors,
  type GetApiEntraV1TenantsByTenantIdActionsUsersResponse,
  type GetApiEntraV1TenantsByTenantIdActionsUsersResponses,
  type GetApiEntraV1TenantsByTenantIdCheckConnectionData,
  type GetApiEntraV1TenantsByTenantIdCheckConnectionError,
  type GetApiEntraV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiEntraV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiEntraV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiEntraV1TenantsByTenantIdData,
  type GetApiEntraV1TenantsByTenantIdError,
  type GetApiEntraV1TenantsByTenantIdErrors,
  type GetApiEntraV1TenantsByTenantIdPermissionPreflightData,
  type GetApiEntraV1TenantsByTenantIdPermissionPreflightError,
  type GetApiEntraV1TenantsByTenantIdPermissionPreflightErrors,
  type GetApiEntraV1TenantsByTenantIdPermissionPreflightResponse,
  type GetApiEntraV1TenantsByTenantIdPermissionPreflightResponses,
  type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdData,
  type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdError,
  type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdErrors,
  type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponse,
  type GetApiEntraV1TenantsByTenantIdProposedActionsByActionIdResponses,
  type GetApiEntraV1TenantsByTenantIdProposedActionsData,
  type GetApiEntraV1TenantsByTenantIdProposedActionsError,
  type GetApiEntraV1TenantsByTenantIdProposedActionsErrors,
  type GetApiEntraV1TenantsByTenantIdProposedActionsResponse,
  type GetApiEntraV1TenantsByTenantIdProposedActionsResponses,
  type GetApiEntraV1TenantsByTenantIdResponse,
  type GetApiEntraV1TenantsByTenantIdResponses,
  type GetApiEntraV1TenantsData,
  type GetApiEntraV1TenantsError,
  type GetApiEntraV1TenantsErrors,
  type GetApiEntraV1TenantsResponse,
  type GetApiEntraV1TenantsResponses,
  type GetApiFreshserviceV1FullTenantsData,
  type GetApiFreshserviceV1FullTenantsError,
  type GetApiFreshserviceV1FullTenantsErrors,
  type GetApiFreshserviceV1FullTenantsResponse,
  type GetApiFreshserviceV1FullTenantsResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsByAgentIdResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsAgentsResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersByRequesterIdResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsRequestersResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsCategoriesResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdConversationsResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
  type GetApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionData,
  type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionError,
  type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiFreshserviceV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiFreshserviceV1TenantsByTenantIdData,
  type GetApiFreshserviceV1TenantsByTenantIdError,
  type GetApiFreshserviceV1TenantsByTenantIdErrors,
  type GetApiFreshserviceV1TenantsByTenantIdResponse,
  type GetApiFreshserviceV1TenantsByTenantIdResponses,
  type GetApiFreshserviceV1TenantsData,
  type GetApiFreshserviceV1TenantsError,
  type GetApiFreshserviceV1TenantsErrors,
  type GetApiFreshserviceV1TenantsResponse,
  type GetApiFreshserviceV1TenantsResponses,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentData,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentError,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentErrors,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponse,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentContentResponses,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataData,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataError,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataErrors,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponse,
  type GetApiHubspotV1TenantsByTenantIdActionsAttachmentMetadataResponses,
  type GetApiJiraV1FullTenantsData,
  type GetApiJiraV1FullTenantsError,
  type GetApiJiraV1FullTenantsErrors,
  type GetApiJiraV1FullTenantsResponse,
  type GetApiJiraV1FullTenantsResponses,
  type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsData,
  type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsError,
  type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsErrors,
  type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponse,
  type GetApiJiraV1TenantsByTenantIdActionsGetCustomFieldOptionsResponses,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssueData,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssueError,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssueErrors,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssueResponse,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssueResponses,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssuesData,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssuesError,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssuesErrors,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponse,
  type GetApiJiraV1TenantsByTenantIdActionsGetIssuesResponses,
  type GetApiJiraV1TenantsByTenantIdCheckConnectionData,
  type GetApiJiraV1TenantsByTenantIdCheckConnectionError,
  type GetApiJiraV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiJiraV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiJiraV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiJiraV1TenantsByTenantIdData,
  type GetApiJiraV1TenantsByTenantIdError,
  type GetApiJiraV1TenantsByTenantIdErrors,
  type GetApiJiraV1TenantsByTenantIdResponse,
  type GetApiJiraV1TenantsByTenantIdResponses,
  type GetApiJiraV1TenantsData,
  type GetApiJiraV1TenantsError,
  type GetApiJiraV1TenantsErrors,
  type GetApiJiraV1TenantsResponse,
  type GetApiJiraV1TenantsResponses,
  type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentData,
  type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentError,
  type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentErrors,
  type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponse,
  type GetApiJiraV2TenantsByTenantIdActionsAttachmentContentResponses,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdData,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdError,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdErrors,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponse,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdResponses,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesData,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesError,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesErrors,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesResponse,
  type GetApiNotionV1TenantsByTenantIdActionsDatabasesResponses,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentData,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentError,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentErrors,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponse,
  type GetApiNotionV1TenantsByTenantIdActionsPagesByPageIdContentResponses,
  type GetApiNotionV1TenantsByTenantIdActionsPagesData,
  type GetApiNotionV1TenantsByTenantIdActionsPagesError,
  type GetApiNotionV1TenantsByTenantIdActionsPagesErrors,
  type GetApiNotionV1TenantsByTenantIdActionsPagesResponse,
  type GetApiNotionV1TenantsByTenantIdActionsPagesResponses,
  type GetApiNotionV1TenantsByTenantIdCheckConnectionData,
  type GetApiNotionV1TenantsByTenantIdCheckConnectionError,
  type GetApiNotionV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiNotionV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiNotionV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiNotionV1TenantsByTenantIdData,
  type GetApiNotionV1TenantsByTenantIdError,
  type GetApiNotionV1TenantsByTenantIdErrors,
  type GetApiNotionV1TenantsByTenantIdResponse,
  type GetApiNotionV1TenantsByTenantIdResponses,
  type GetApiNotionV1TenantsData,
  type GetApiNotionV1TenantsError,
  type GetApiNotionV1TenantsErrors,
  type GetApiNotionV1TenantsResponse,
  type GetApiNotionV1TenantsResponses,
  type GetApiOutlookV2SubscriptionsData,
  type GetApiOutlookV2SubscriptionsError,
  type GetApiOutlookV2SubscriptionsErrors,
  type GetApiOutlookV2SubscriptionsResponse,
  type GetApiOutlookV2SubscriptionsResponses,
  type GetApiPlainV1FullTenantsData,
  type GetApiPlainV1FullTenantsError,
  type GetApiPlainV1FullTenantsErrors,
  type GetApiPlainV1FullTenantsResponse,
  type GetApiPlainV1FullTenantsResponses,
  type GetApiPlainV1TenantsByTenantIdActionsCompaniesData,
  type GetApiPlainV1TenantsByTenantIdActionsCompaniesError,
  type GetApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  type GetApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
  type GetApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsData,
  type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsError,
  type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsErrors,
  type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponse,
  type GetApiPlainV1TenantsByTenantIdActionsCustomerGroupsResponses,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdData,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdError,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdErrors,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponse,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdResponses,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersData,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersError,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersResponse,
  type GetApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
  type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
  type GetApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdData,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdError,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdErrors,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponse,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdResponses,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineData,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineError,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineErrors,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponse,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTimelineResponses,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsData,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsError,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsResponse,
  type GetApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  type GetApiPlainV1TenantsByTenantIdCheckConnectionData,
  type GetApiPlainV1TenantsByTenantIdCheckConnectionError,
  type GetApiPlainV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiPlainV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiPlainV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiPlainV1TenantsByTenantIdData,
  type GetApiPlainV1TenantsByTenantIdError,
  type GetApiPlainV1TenantsByTenantIdErrors,
  type GetApiPlainV1TenantsByTenantIdResponse,
  type GetApiPlainV1TenantsByTenantIdResponses,
  type GetApiPlainV1TenantsData,
  type GetApiPlainV1TenantsError,
  type GetApiPlainV1TenantsErrors,
  type GetApiPlainV1TenantsResponse,
  type GetApiPlainV1TenantsResponses,
  type GetApiPublicOauthV1AuthorizeData,
  type GetApiPublicOauthV1AuthorizeError,
  type GetApiPublicOauthV1AuthorizeErrors,
  type GetApiPublicOauthV1AuthorizeResponses,
  type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeData,
  type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeError,
  type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeErrors,
  type GetApiPublicOauthV1ByOauthApplicationIdAuthorizeResponses,
  type GetApiPublicOauthV1ByOauthApplicationIdUserinfoData,
  type GetApiPublicOauthV1ByOauthApplicationIdUserinfoError,
  type GetApiPublicOauthV1ByOauthApplicationIdUserinfoErrors,
  type GetApiPublicOauthV1ByOauthApplicationIdUserinfoResponses,
  type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationData,
  type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationError,
  type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationErrors,
  type GetApiPublicOauthV1ByOauthApplicationIdWellKnownOpenidConfigurationResponses,
  type GetApiPublicOauthV1WellKnownOauthAuthorizationServerData,
  type GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponse,
  type GetApiPublicOauthV1WellKnownOauthAuthorizationServerResponses,
  type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyData,
  type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyError,
  type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyErrors,
  type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponse,
  type GetApiPublicOauthV1WellKnownOauthProtectedResourceMcpByToolsetKeyResponses,
  type GetApiPublicOauthV1WellKnownOpenidConfigurationData,
  type GetApiPublicOauthV1WellKnownOpenidConfigurationResponse,
  type GetApiPublicOauthV1WellKnownOpenidConfigurationResponses,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonData,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonError,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonErrors,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponse,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownJwksJsonResponses,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationData,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationError,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationErrors,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponse,
  type GetApiPublicTeamsV1TenantsByTenantIdWellKnownOpenidConfigurationResponses,
  type GetApiPublicV1AgentA2aByAgentKeyAgentData,
  type GetApiPublicV1AgentA2aByAgentKeyAgentError,
  type GetApiPublicV1AgentA2aByAgentKeyAgentErrors,
  type GetApiPublicV1AgentA2aByAgentKeyAgentResponse,
  type GetApiPublicV1AgentA2aByAgentKeyAgentResponses,
  type GetApiSalesforceV1FullTenantsData,
  type GetApiSalesforceV1FullTenantsError,
  type GetApiSalesforceV1FullTenantsErrors,
  type GetApiSalesforceV1FullTenantsResponse,
  type GetApiSalesforceV1FullTenantsResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsByAccountIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsData,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsError,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsAccountsResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  type GetApiSalesforceV1TenantsByTenantIdActionsArticlesError,
  type GetApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesData,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesError,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdMessagesResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesData,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesError,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsByContactIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsData,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsError,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsContactsResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageData,
  type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageError,
  type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsDefaultLanguageResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsByEntitlementIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsData,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsError,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsEntitlementsResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesByQueueIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesData,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesError,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsQueuesResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesByRecordTypeIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesData,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesError,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsRecordTypesResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdData,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdError,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersByUserIdResponses,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersData,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersError,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersErrors,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersResponse,
  type GetApiSalesforceV1TenantsByTenantIdActionsUsersResponses,
  type GetApiSalesforceV1TenantsByTenantIdCheckConnectionData,
  type GetApiSalesforceV1TenantsByTenantIdCheckConnectionError,
  type GetApiSalesforceV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiSalesforceV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiSalesforceV1TenantsByTenantIdCheckReadyData,
  type GetApiSalesforceV1TenantsByTenantIdCheckReadyError,
  type GetApiSalesforceV1TenantsByTenantIdCheckReadyErrors,
  type GetApiSalesforceV1TenantsByTenantIdCheckReadyResponse,
  type GetApiSalesforceV1TenantsByTenantIdCheckReadyResponses,
  type GetApiSalesforceV1TenantsByTenantIdData,
  type GetApiSalesforceV1TenantsByTenantIdError,
  type GetApiSalesforceV1TenantsByTenantIdErrors,
  type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriData,
  type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriError,
  type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriErrors,
  type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponse,
  type GetApiSalesforceV1TenantsByTenantIdOauthRedirectUriResponses,
  type GetApiSalesforceV1TenantsByTenantIdResponse,
  type GetApiSalesforceV1TenantsByTenantIdResponses,
  type GetApiSalesforceV1TenantsData,
  type GetApiSalesforceV1TenantsError,
  type GetApiSalesforceV1TenantsErrors,
  type GetApiSalesforceV1TenantsResponse,
  type GetApiSalesforceV1TenantsResponses,
  type GetApiSecretsVaultV1FullSecretsData,
  type GetApiSecretsVaultV1FullSecretsError,
  type GetApiSecretsVaultV1FullSecretsErrors,
  type GetApiSecretsVaultV1FullSecretsResponse,
  type GetApiSecretsVaultV1FullSecretsResponses,
  type GetApiSecretsVaultV1SecretsBySecretIdData,
  type GetApiSecretsVaultV1SecretsBySecretIdError,
  type GetApiSecretsVaultV1SecretsBySecretIdErrors,
  type GetApiSecretsVaultV1SecretsBySecretIdResponse,
  type GetApiSecretsVaultV1SecretsBySecretIdResponses,
  type GetApiSecretsVaultV1SecretsData,
  type GetApiSecretsVaultV1SecretsError,
  type GetApiSecretsVaultV1SecretsErrors,
  type GetApiSecretsVaultV1SecretsResponse,
  type GetApiSecretsVaultV1SecretsResponses,
  type GetApiSecretsVaultV1SecretsValueData,
  type GetApiSecretsVaultV1SecretsValueError,
  type GetApiSecretsVaultV1SecretsValueErrors,
  type GetApiSecretsVaultV1SecretsValueResponse,
  type GetApiSecretsVaultV1SecretsValueResponses,
  type GetApiSecretsVaultV2SecretsValueData,
  type GetApiSecretsVaultV2SecretsValueError,
  type GetApiSecretsVaultV2SecretsValueErrors,
  type GetApiSecretsVaultV2SecretsValueResponse,
  type GetApiSecretsVaultV2SecretsValueResponses,
  type GetApiServiceNowV1TenantsByTenantIdActionsCartData,
  type GetApiServiceNowV1TenantsByTenantIdActionsCartError,
  type GetApiServiceNowV1TenantsByTenantIdActionsCartErrors,
  type GetApiServiceNowV1TenantsByTenantIdActionsCartResponse,
  type GetApiServiceNowV1TenantsByTenantIdActionsCartResponses,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataData,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataError,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataErrors,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponse,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableLookupMetadataResponses,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesData,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesError,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesErrors,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponse,
  type GetApiServiceNowV1TenantsByTenantIdActionsCatalogVariableValuesResponses,
  type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileData,
  type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileError,
  type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileErrors,
  type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponse,
  type GetApiServiceNowV1TenantsByTenantIdActionsUserProfileResponses,
  type GetApiSharepointV1FullTenantsData,
  type GetApiSharepointV1FullTenantsError,
  type GetApiSharepointV1FullTenantsErrors,
  type GetApiSharepointV1FullTenantsResponse,
  type GetApiSharepointV1FullTenantsResponses,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenData,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenError,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenErrors,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponse,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdChildrenResponses,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  type GetApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesData,
  type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesError,
  type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesErrors,
  type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponse,
  type GetApiSharepointV1TenantsByTenantIdActionsSitesBySiteIdDrivesResponses,
  type GetApiSharepointV1TenantsByTenantIdAdminAccessData,
  type GetApiSharepointV1TenantsByTenantIdAdminAccessError,
  type GetApiSharepointV1TenantsByTenantIdAdminAccessErrors,
  type GetApiSharepointV1TenantsByTenantIdAdminAccessResponse,
  type GetApiSharepointV1TenantsByTenantIdAdminAccessResponses,
  type GetApiSharepointV1TenantsByTenantIdCheckAccessData,
  type GetApiSharepointV1TenantsByTenantIdCheckAccessError,
  type GetApiSharepointV1TenantsByTenantIdCheckAccessErrors,
  type GetApiSharepointV1TenantsByTenantIdCheckAccessResponse,
  type GetApiSharepointV1TenantsByTenantIdCheckAccessResponses,
  type GetApiSharepointV1TenantsByTenantIdCheckConnectionData,
  type GetApiSharepointV1TenantsByTenantIdCheckConnectionError,
  type GetApiSharepointV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiSharepointV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiSharepointV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiSharepointV1TenantsByTenantIdData,
  type GetApiSharepointV1TenantsByTenantIdError,
  type GetApiSharepointV1TenantsByTenantIdErrors,
  type GetApiSharepointV1TenantsByTenantIdFolderScopesData,
  type GetApiSharepointV1TenantsByTenantIdFolderScopesError,
  type GetApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  type GetApiSharepointV1TenantsByTenantIdFolderScopesResponse,
  type GetApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  type GetApiSharepointV1TenantsByTenantIdResponse,
  type GetApiSharepointV1TenantsByTenantIdResponses,
  type GetApiSharepointV1TenantsByTenantIdSitesData,
  type GetApiSharepointV1TenantsByTenantIdSitesError,
  type GetApiSharepointV1TenantsByTenantIdSitesErrors,
  type GetApiSharepointV1TenantsByTenantIdSitesResponse,
  type GetApiSharepointV1TenantsByTenantIdSitesResponses,
  type GetApiSharepointV1TenantsData,
  type GetApiSharepointV1TenantsError,
  type GetApiSharepointV1TenantsErrors,
  type GetApiSharepointV1TenantsResponse,
  type GetApiSharepointV1TenantsResponses,
  type GetApiSlackV1FullTenantsData,
  type GetApiSlackV1FullTenantsError,
  type GetApiSlackV1FullTenantsErrors,
  type GetApiSlackV1FullTenantsResponse,
  type GetApiSlackV1FullTenantsResponses,
  type GetApiSlackV1OauthScopesData,
  type GetApiSlackV1OauthScopesResponse,
  type GetApiSlackV1OauthScopesResponses,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersData,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersError,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersErrors,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponse,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsByUsergroupIdUsersResponses,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsData,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsError,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsErrors,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponse,
  type GetApiSlackV1TenantsByTenantIdActionsUserGroupsResponses,
  type GetApiSlackV1TenantsByTenantIdCheckConnectionData,
  type GetApiSlackV1TenantsByTenantIdCheckConnectionError,
  type GetApiSlackV1TenantsByTenantIdCheckConnectionErrors,
  type GetApiSlackV1TenantsByTenantIdCheckConnectionResponse,
  type GetApiSlackV1TenantsByTenantIdCheckConnectionResponses,
  type GetApiSlackV1TenantsByTenantIdData,
  type GetApiSlackV1TenantsByTenantIdError,
  type GetApiSlackV1TenantsByTenantIdErrors,
  type GetApiSlackV1TenantsByTenantIdManifestData,
  type GetApiSlackV1TenantsByTenantIdManifestError,
  type GetApiSlackV1TenantsByTenantIdManifestErrors,
  type GetApiSlackV1TenantsByTenantIdManifestResponse,
  type GetApiSlackV1TenantsByTenantIdManifestResponses,
  type GetApiSlackV1TenantsByTenantIdResponse,
  type GetApiSlackV1TenantsByTenantIdResponses,
  type GetApiSlackV1TenantsData,
  type GetApiSlackV1TenantsError,
  type GetApiSlackV1TenantsErrors,
  type GetApiSlackV1TenantsResponse,
  type GetApiSlackV1TenantsResponses,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsData,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsError,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsErrors,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponse,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesByTsReactionsResponses,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesData,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesError,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesErrors,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponse,
  type GetApiSlackV2TenantsByTenantIdActionsChannelsByChannelMessagesResponses,
  type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdData,
  type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdError,
  type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdErrors,
  type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponse,
  type GetApiSlackV2TenantsByTenantIdActionsUsersByUserIdResponses,
  type GetApiSlackV2TenantsByTenantIdActionsUsersData,
  type GetApiSlackV2TenantsByTenantIdActionsUsersError,
  type GetApiSlackV2TenantsByTenantIdActionsUsersErrors,
  type GetApiSlackV2TenantsByTenantIdActionsUsersResponse,
  type GetApiSlackV2TenantsByTenantIdActionsUsersResponses,
  type GetApiTeamsV1FullTenantsData,
  type GetApiTeamsV1FullTenantsError,
  type GetApiTeamsV1FullTenantsErrors,
  type GetApiTeamsV1FullTenantsResponse,
  type GetApiTeamsV1FullTenantsResponses,
  type GetApiTeamsV1TenantsByTenantIdData,
  type GetApiTeamsV1TenantsByTenantIdError,
  type GetApiTeamsV1TenantsByTenantIdErrors,
  type GetApiTeamsV1TenantsByTenantIdIconsData,
  type GetApiTeamsV1TenantsByTenantIdIconsError,
  type GetApiTeamsV1TenantsByTenantIdIconsErrors,
  type GetApiTeamsV1TenantsByTenantIdIconsResponses,
  type GetApiTeamsV1TenantsByTenantIdInstallsData,
  type GetApiTeamsV1TenantsByTenantIdInstallsError,
  type GetApiTeamsV1TenantsByTenantIdInstallsErrors,
  type GetApiTeamsV1TenantsByTenantIdInstallsResponse,
  type GetApiTeamsV1TenantsByTenantIdInstallsResponses,
  type GetApiTeamsV1TenantsByTenantIdManifestData,
  type GetApiTeamsV1TenantsByTenantIdManifestError,
  type GetApiTeamsV1TenantsByTenantIdManifestErrors,
  type GetApiTeamsV1TenantsByTenantIdManifestResponses,
  type GetApiTeamsV1TenantsByTenantIdResponse,
  type GetApiTeamsV1TenantsByTenantIdResponses,
  type GetApiTeamsV1TenantsData,
  type GetApiTeamsV1TenantsError,
  type GetApiTeamsV1TenantsErrors,
  type GetApiTeamsV1TenantsResponse,
  type GetApiTeamsV1TenantsResponses,
  type GetApiV1A2aAgentsData,
  type GetApiV1A2aAgentsResponse,
  type GetApiV1A2aAgentsResponses,
  type GetApiV1AgentsByAgentKeyData,
  type GetApiV1AgentsByAgentKeyError,
  type GetApiV1AgentsByAgentKeyErrors,
  type GetApiV1AgentsByAgentKeyResponse,
  type GetApiV1AgentsByAgentKeyResponses,
  type GetApiV1AgentsData,
  type GetApiV1AgentSessionInferenceByAgentSessionIdData,
  type GetApiV1AgentSessionInferenceByAgentSessionIdError,
  type GetApiV1AgentSessionInferenceByAgentSessionIdErrors,
  type GetApiV1AgentSessionInferenceByAgentSessionIdResponse,
  type GetApiV1AgentSessionInferenceByAgentSessionIdResponses,
  type GetApiV1AgentSessionsByAgentSessionIdData,
  type GetApiV1AgentSessionsByAgentSessionIdError,
  type GetApiV1AgentSessionsByAgentSessionIdErrors,
  type GetApiV1AgentSessionsByAgentSessionIdResponse,
  type GetApiV1AgentSessionsByAgentSessionIdResponses,
  type GetApiV1AgentSessionsData,
  type GetApiV1AgentSessionsError,
  type GetApiV1AgentSessionsErrors,
  type GetApiV1AgentSessionsResponse,
  type GetApiV1AgentSessionsResponses,
  type GetApiV1AgentsResponse,
  type GetApiV1AgentsResponses,
  type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentError,
  type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
  type GetApiV1AnalyticsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  type GetApiV1AnalyticsOverviewsChartsData,
  type GetApiV1AnalyticsOverviewsChartsResponse,
  type GetApiV1AnalyticsOverviewsChartsResponses,
  type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentData,
  type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentError,
  type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentErrors,
  type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponse,
  type GetApiV1AnalyticsOverviewsKnowledgeBasesByKbIdChartsByChartKeyContentResponses,
  type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentData,
  type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentError,
  type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentErrors,
  type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponse,
  type GetApiV1AnalyticsSectionsBySectionIdChartsByChartKeyContentResponses,
  type GetApiV1AnalyticsSectionsChartsData,
  type GetApiV1AnalyticsSectionsChartsError,
  type GetApiV1AnalyticsSectionsChartsErrors,
  type GetApiV1AnalyticsSectionsChartsResponse,
  type GetApiV1AnalyticsSectionsChartsResponses,
  type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentData,
  type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentError,
  type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentErrors,
  type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponse,
  type GetApiV1AnalyticsTreesByKbIdChartsByChartKeyContentResponses,
  type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentData,
  type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentError,
  type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentErrors,
  type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponse,
  type GetApiV1AnalyticsWorkflowsByWorkflowIdChartsByChartKeyContentResponses,
  type GetApiV1AnalyticsWorkflowsChartsData,
  type GetApiV1AnalyticsWorkflowsChartsError,
  type GetApiV1AnalyticsWorkflowsChartsErrors,
  type GetApiV1AnalyticsWorkflowsChartsResponse,
  type GetApiV1AnalyticsWorkflowsChartsResponses,
  type GetApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  type GetApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  type GetApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  type GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  type GetApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  type GetApiV1ArticleTagsData,
  type GetApiV1ArticleTagsError,
  type GetApiV1ArticleTagsErrors,
  type GetApiV1ArticleTagsResponse,
  type GetApiV1ArticleTagsResponses,
  type GetApiV1AttachmentsDataByFilePathData,
  type GetApiV1AttachmentsDataByFilePathError,
  type GetApiV1AttachmentsDataByFilePathErrors,
  type GetApiV1AttachmentsDataByFilePathResponses,
  type GetApiV1AuthzOrganizationsByOrgIdData,
  type GetApiV1AuthzOrganizationsByOrgIdError,
  type GetApiV1AuthzOrganizationsByOrgIdErrors,
  type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsData,
  type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsError,
  type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsErrors,
  type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponse,
  type GetApiV1AuthzOrganizationsByOrgIdFullInvitationsResponses,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsData,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsError,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
  type GetApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsData,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsError,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsErrors,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponse,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdRequesterTeamsResponses,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessData,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessError,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessErrors,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponse,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdTeamsWithAccessResponses,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
  type GetApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineData,
  type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineError,
  type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineErrors,
  type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponse,
  type GetApiV1AuthzOrganizationsByOrgIdKnowledgeBasesByKbIdKbAccessRequestsMineResponses,
  type GetApiV1AuthzOrganizationsByOrgIdMembersData,
  type GetApiV1AuthzOrganizationsByOrgIdMembersError,
  type GetApiV1AuthzOrganizationsByOrgIdMembersErrors,
  type GetApiV1AuthzOrganizationsByOrgIdMembersResponse,
  type GetApiV1AuthzOrganizationsByOrgIdMembersResponses,
  type GetApiV1AuthzOrganizationsByOrgIdResponse,
  type GetApiV1AuthzOrganizationsByOrgIdResponses,
  type GetApiV1AuthzOrganizationsByOrgIdRolesData,
  type GetApiV1AuthzOrganizationsByOrgIdRolesError,
  type GetApiV1AuthzOrganizationsByOrgIdRolesErrors,
  type GetApiV1AuthzOrganizationsByOrgIdRolesResponse,
  type GetApiV1AuthzOrganizationsByOrgIdRolesResponses,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesData,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesError,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesErrors,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponse,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesResponses,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsData,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsError,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsResponse,
  type GetApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  type GetApiV1AuthzOrganizationsData,
  type GetApiV1AuthzOrganizationsError,
  type GetApiV1AuthzOrganizationsErrors,
  type GetApiV1AuthzOrganizationsResponse,
  type GetApiV1AuthzOrganizationsResponses,
  type GetApiV1BrandingData,
  type GetApiV1BrandingResponse,
  type GetApiV1BrandingResponses,
  type GetApiV1CalibrationFeedbackDimensionsByDimensionIdData,
  type GetApiV1CalibrationFeedbackDimensionsByDimensionIdError,
  type GetApiV1CalibrationFeedbackDimensionsByDimensionIdErrors,
  type GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponse,
  type GetApiV1CalibrationFeedbackDimensionsByDimensionIdResponses,
  type GetApiV1CalibrationFeedbackDimensionsData,
  type GetApiV1CalibrationFeedbackDimensionsError,
  type GetApiV1CalibrationFeedbackDimensionsErrors,
  type GetApiV1CalibrationFeedbackDimensionsResponse,
  type GetApiV1CalibrationFeedbackDimensionsResponses,
  type GetApiV1CalibrationFeedbackFullDimensionsData,
  type GetApiV1CalibrationFeedbackFullDimensionsError,
  type GetApiV1CalibrationFeedbackFullDimensionsErrors,
  type GetApiV1CalibrationFeedbackFullDimensionsResponse,
  type GetApiV1CalibrationFeedbackFullDimensionsResponses,
  type GetApiV1CalibrationFeedbackFullQueueItemsData,
  type GetApiV1CalibrationFeedbackFullQueueItemsError,
  type GetApiV1CalibrationFeedbackFullQueueItemsErrors,
  type GetApiV1CalibrationFeedbackFullQueueItemsResponse,
  type GetApiV1CalibrationFeedbackFullQueueItemsResponses,
  type GetApiV1CalibrationFeedbackFullVerdictsData,
  type GetApiV1CalibrationFeedbackFullVerdictsError,
  type GetApiV1CalibrationFeedbackFullVerdictsErrors,
  type GetApiV1CalibrationFeedbackFullVerdictsResponse,
  type GetApiV1CalibrationFeedbackFullVerdictsResponses,
  type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdData,
  type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdError,
  type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdErrors,
  type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponse,
  type GetApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdResponses,
  type GetApiV1CalibrationFeedbackInferenceDatapointsData,
  type GetApiV1CalibrationFeedbackInferenceDatapointsError,
  type GetApiV1CalibrationFeedbackInferenceDatapointsErrors,
  type GetApiV1CalibrationFeedbackInferenceDatapointsResponse,
  type GetApiV1CalibrationFeedbackInferenceDatapointsResponses,
  type GetApiV1CalibrationFeedbackInferenceDatapointsTagsData,
  type GetApiV1CalibrationFeedbackInferenceDatapointsTagsError,
  type GetApiV1CalibrationFeedbackInferenceDatapointsTagsErrors,
  type GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponse,
  type GetApiV1CalibrationFeedbackInferenceDatapointsTagsResponses,
  type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdData,
  type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdError,
  type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdErrors,
  type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponse,
  type GetApiV1CalibrationFeedbackQueueItemsByQueueItemIdResponses,
  type GetApiV1CalibrationFeedbackQueueItemsData,
  type GetApiV1CalibrationFeedbackQueueItemsError,
  type GetApiV1CalibrationFeedbackQueueItemsErrors,
  type GetApiV1CalibrationFeedbackQueueItemsResponse,
  type GetApiV1CalibrationFeedbackQueueItemsResponses,
  type GetApiV1CalibrationFeedbackQueueItemsTagsData,
  type GetApiV1CalibrationFeedbackQueueItemsTagsError,
  type GetApiV1CalibrationFeedbackQueueItemsTagsErrors,
  type GetApiV1CalibrationFeedbackQueueItemsTagsResponse,
  type GetApiV1CalibrationFeedbackQueueItemsTagsResponses,
  type GetApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  type GetApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  type GetApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  type GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  type GetApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  type GetApiV1CalibrationFeedbackVerdictsData,
  type GetApiV1CalibrationFeedbackVerdictsError,
  type GetApiV1CalibrationFeedbackVerdictsErrors,
  type GetApiV1CalibrationFeedbackVerdictsResponse,
  type GetApiV1CalibrationFeedbackVerdictsResponses,
  type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  type GetApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  type GetApiV1ChangeRequestsByChangeRequestIdData,
  type GetApiV1ChangeRequestsByChangeRequestIdError,
  type GetApiV1ChangeRequestsByChangeRequestIdErrors,
  type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesData,
  type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesError,
  type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesErrors,
  type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponse,
  type GetApiV1ChangeRequestsByChangeRequestIdPossibleAssigneesResponses,
  type GetApiV1ChangeRequestsByChangeRequestIdResponse,
  type GetApiV1ChangeRequestsByChangeRequestIdResponses,
  type GetApiV1ChangeRequestsData,
  type GetApiV1ChangeRequestsError,
  type GetApiV1ChangeRequestsErrors,
  type GetApiV1ChangeRequestsResponse,
  type GetApiV1ChangeRequestsResponses,
  type GetApiV1ChangeRequestTagsData,
  type GetApiV1ChangeRequestTagsError,
  type GetApiV1ChangeRequestTagsErrors,
  type GetApiV1ChangeRequestTagsResponse,
  type GetApiV1ChangeRequestTagsResponses,
  type GetApiV1CommentsByCommentIdData,
  type GetApiV1CommentsByCommentIdError,
  type GetApiV1CommentsByCommentIdErrors,
  type GetApiV1CommentsByCommentIdResponse,
  type GetApiV1CommentsByCommentIdResponses,
  type GetApiV1ConversationsData,
  type GetApiV1ConversationsError,
  type GetApiV1ConversationsErrors,
  type GetApiV1ConversationsGroupByExternalIdData,
  type GetApiV1ConversationsGroupByExternalIdError,
  type GetApiV1ConversationsGroupByExternalIdErrors,
  type GetApiV1ConversationsGroupByExternalIdResponse,
  type GetApiV1ConversationsGroupByExternalIdResponses,
  type GetApiV1ConversationsResponse,
  type GetApiV1ConversationsResponses,
  type GetApiV1DataDumpConversationsData,
  type GetApiV1DataDumpConversationsError,
  type GetApiV1DataDumpConversationsErrors,
  type GetApiV1DataDumpConversationsResponse,
  type GetApiV1DataDumpConversationsResponses,
  type GetApiV1DatapointEvidenceData,
  type GetApiV1DatapointEvidenceError,
  type GetApiV1DatapointEvidenceErrors,
  type GetApiV1DatapointEvidenceResponse,
  type GetApiV1DatapointEvidenceResponses,
  type GetApiV1EvaluatedInferenceDatapointsData,
  type GetApiV1EvaluatedInferenceDatapointsError,
  type GetApiV1EvaluatedInferenceDatapointsErrors,
  type GetApiV1EvaluatedInferenceDatapointsResponse,
  type GetApiV1EvaluatedInferenceDatapointsResponses,
  type GetApiV1ExternalInferencesByInferenceIdData,
  type GetApiV1ExternalInferencesByInferenceIdError,
  type GetApiV1ExternalInferencesByInferenceIdErrors,
  type GetApiV1ExternalInferencesByInferenceIdResponse,
  type GetApiV1ExternalInferencesByInferenceIdResponses,
  type GetApiV1ExternalInferencesData,
  type GetApiV1ExternalInferencesError,
  type GetApiV1ExternalInferencesErrors,
  type GetApiV1ExternalInferencesResponse,
  type GetApiV1ExternalInferencesResponses,
  type GetApiV1FrontendConfigData,
  type GetApiV1FrontendConfigResponse,
  type GetApiV1FrontendConfigResponses,
  type GetApiV1FullAgentSessionsData,
  type GetApiV1FullAgentSessionsError,
  type GetApiV1FullAgentSessionsErrors,
  type GetApiV1FullAgentSessionsResponse,
  type GetApiV1FullAgentSessionsResponses,
  type GetApiV1FullApiKeysData,
  type GetApiV1FullApiKeysError,
  type GetApiV1FullApiKeysErrors,
  type GetApiV1FullApiKeysResponse,
  type GetApiV1FullApiKeysResponses,
  type GetApiV1FullArticleLineRangeCommentThreadsData,
  type GetApiV1FullArticleLineRangeCommentThreadsError,
  type GetApiV1FullArticleLineRangeCommentThreadsErrors,
  type GetApiV1FullArticleLineRangeCommentThreadsResponse,
  type GetApiV1FullArticleLineRangeCommentThreadsResponses,
  type GetApiV1FullChangeRequestLineRangeCommentThreadsData,
  type GetApiV1FullChangeRequestLineRangeCommentThreadsError,
  type GetApiV1FullChangeRequestLineRangeCommentThreadsErrors,
  type GetApiV1FullChangeRequestLineRangeCommentThreadsResponse,
  type GetApiV1FullChangeRequestLineRangeCommentThreadsResponses,
  type GetApiV1FullChangeRequestsData,
  type GetApiV1FullChangeRequestsError,
  type GetApiV1FullChangeRequestsErrors,
  type GetApiV1FullChangeRequestsResponse,
  type GetApiV1FullChangeRequestsResponses,
  type GetApiV1FullCommentsData,
  type GetApiV1FullCommentsError,
  type GetApiV1FullCommentsErrors,
  type GetApiV1FullCommentsResponse,
  type GetApiV1FullCommentsResponses,
  type GetApiV1FullDataDumpConversationsData,
  type GetApiV1FullDataDumpConversationsError,
  type GetApiV1FullDataDumpConversationsErrors,
  type GetApiV1FullDataDumpConversationsResponse,
  type GetApiV1FullDataDumpConversationsResponses,
  type GetApiV1FullDatapointsData,
  type GetApiV1FullDatapointsError,
  type GetApiV1FullDatapointsErrors,
  type GetApiV1FullDatapointsResponse,
  type GetApiV1FullDatapointsResponses,
  type GetApiV1FullInferenceDatapointsByInferenceDatapointIdData,
  type GetApiV1FullInferenceDatapointsByInferenceDatapointIdError,
  type GetApiV1FullInferenceDatapointsByInferenceDatapointIdErrors,
  type GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponse,
  type GetApiV1FullInferenceDatapointsByInferenceDatapointIdResponses,
  type GetApiV1FullInferenceDatapointsData,
  type GetApiV1FullInferenceDatapointsError,
  type GetApiV1FullInferenceDatapointsErrors,
  type GetApiV1FullInferenceDatapointsResponse,
  type GetApiV1FullInferenceDatapointsResponses,
  type GetApiV1FullKbsData,
  type GetApiV1FullKbsError,
  type GetApiV1FullKbsErrors,
  type GetApiV1FullKbSimulationCompareData,
  type GetApiV1FullKbSimulationCompareError,
  type GetApiV1FullKbSimulationCompareErrors,
  type GetApiV1FullKbSimulationCompareResponse,
  type GetApiV1FullKbSimulationCompareResponses,
  type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdData,
  type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdError,
  type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdErrors,
  type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponse,
  type GetApiV1FullKbSimulationDatapointsBySimulationDatapointIdResponses,
  type GetApiV1FullKbSimulationDatapointsData,
  type GetApiV1FullKbSimulationDatapointsError,
  type GetApiV1FullKbSimulationDatapointsErrors,
  type GetApiV1FullKbSimulationDatapointsResponse,
  type GetApiV1FullKbSimulationDatapointsResponses,
  type GetApiV1FullKbSimulationResultJudgementsData,
  type GetApiV1FullKbSimulationResultJudgementsError,
  type GetApiV1FullKbSimulationResultJudgementsErrors,
  type GetApiV1FullKbSimulationResultJudgementsResponse,
  type GetApiV1FullKbSimulationResultJudgementsResponses,
  type GetApiV1FullKbSimulationResultsBySimulationResultIdData,
  type GetApiV1FullKbSimulationResultsBySimulationResultIdError,
  type GetApiV1FullKbSimulationResultsBySimulationResultIdErrors,
  type GetApiV1FullKbSimulationResultsBySimulationResultIdResponse,
  type GetApiV1FullKbSimulationResultsBySimulationResultIdResponses,
  type GetApiV1FullKbSimulationResultsData,
  type GetApiV1FullKbSimulationResultsError,
  type GetApiV1FullKbSimulationResultsErrors,
  type GetApiV1FullKbSimulationResultsResponse,
  type GetApiV1FullKbSimulationResultsResponses,
  type GetApiV1FullKbSimulationRunData,
  type GetApiV1FullKbSimulationRunError,
  type GetApiV1FullKbSimulationRunErrors,
  type GetApiV1FullKbSimulationRunResponse,
  type GetApiV1FullKbSimulationRunResponses,
  type GetApiV1FullKbsResponse,
  type GetApiV1FullKbsResponses,
  type GetApiV1FullOauthApplicationsData,
  type GetApiV1FullOauthApplicationsError,
  type GetApiV1FullOauthApplicationsErrors,
  type GetApiV1FullOauthApplicationsResponse,
  type GetApiV1FullOauthApplicationsResponses,
  type GetApiV1FullUserAgentSessionsData,
  type GetApiV1FullUserAgentSessionsError,
  type GetApiV1FullUserAgentSessionsErrors,
  type GetApiV1FullUserAgentSessionsResponse,
  type GetApiV1FullUserAgentSessionsResponses,
  type GetApiV1FullWorkEventsData,
  type GetApiV1FullWorkEventsError,
  type GetApiV1FullWorkEventsErrors,
  type GetApiV1FullWorkEventsResponse,
  type GetApiV1FullWorkEventsResponses,
  type GetApiV1FullWorkflowRunsData,
  type GetApiV1FullWorkflowRunsError,
  type GetApiV1FullWorkflowRunsErrors,
  type GetApiV1FullWorkflowRunsResponse,
  type GetApiV1FullWorkflowRunsResponses,
  type GetApiV1HubspotFullTenantsData,
  type GetApiV1HubspotFullTenantsError,
  type GetApiV1HubspotFullTenantsErrors,
  type GetApiV1HubspotFullTenantsResponse,
  type GetApiV1HubspotFullTenantsResponses,
  type GetApiV1HubspotTenantsByTenantIdCheckConnectionData,
  type GetApiV1HubspotTenantsByTenantIdCheckConnectionError,
  type GetApiV1HubspotTenantsByTenantIdCheckConnectionErrors,
  type GetApiV1HubspotTenantsByTenantIdCheckConnectionResponse,
  type GetApiV1HubspotTenantsByTenantIdCheckConnectionResponses,
  type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdData,
  type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdError,
  type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdErrors,
  type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponse,
  type GetApiV1HubspotTenantsByTenantIdCompaniesByCompanyIdResponses,
  type GetApiV1HubspotTenantsByTenantIdData,
  type GetApiV1HubspotTenantsByTenantIdError,
  type GetApiV1HubspotTenantsByTenantIdErrors,
  type GetApiV1HubspotTenantsByTenantIdManifestData,
  type GetApiV1HubspotTenantsByTenantIdManifestError,
  type GetApiV1HubspotTenantsByTenantIdManifestErrors,
  type GetApiV1HubspotTenantsByTenantIdManifestResponses,
  type GetApiV1HubspotTenantsByTenantIdResponse,
  type GetApiV1HubspotTenantsByTenantIdResponses,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdData,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdError,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdErrors,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesData,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesError,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesErrors,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponse,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdMessagesResponses,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponse,
  type GetApiV1HubspotTenantsByTenantIdThreadsByThreadIdResponses,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdData,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdError,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdErrors,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesData,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesError,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesErrors,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponse,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdNotesResponses,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponse,
  type GetApiV1HubspotTenantsByTenantIdTicketsByTicketIdResponses,
  type GetApiV1HubspotTenantsByTenantIdTicketsData,
  type GetApiV1HubspotTenantsByTenantIdTicketsError,
  type GetApiV1HubspotTenantsByTenantIdTicketsErrors,
  type GetApiV1HubspotTenantsByTenantIdTicketsResponse,
  type GetApiV1HubspotTenantsByTenantIdTicketsResponses,
  type GetApiV1HubspotTenantsData,
  type GetApiV1HubspotTenantsError,
  type GetApiV1HubspotTenantsErrors,
  type GetApiV1HubspotTenantsResponse,
  type GetApiV1HubspotTenantsResponses,
  type GetApiV1ImageAttachmentsDownloadByFilePathData,
  type GetApiV1ImageAttachmentsDownloadByFilePathError,
  type GetApiV1ImageAttachmentsDownloadByFilePathErrors,
  type GetApiV1ImageAttachmentsDownloadByFilePathResponses,
  type GetApiV1InferenceFeedbackData,
  type GetApiV1InferenceFeedbackError,
  type GetApiV1InferenceFeedbackErrors,
  type GetApiV1InferenceFeedbackResponse,
  type GetApiV1InferenceFeedbackResponses,
  type GetApiV1JudgesByJudgeIdData,
  type GetApiV1JudgesByJudgeIdError,
  type GetApiV1JudgesByJudgeIdErrors,
  type GetApiV1JudgesByJudgeIdResponse,
  type GetApiV1JudgesByJudgeIdResponses,
  type GetApiV1JudgesData,
  type GetApiV1JudgesError,
  type GetApiV1JudgesErrors,
  type GetApiV1JudgesResponse,
  type GetApiV1JudgesResponses,
  type GetApiV1KbAttachmentsDownloadByFilePathData,
  type GetApiV1KbAttachmentsDownloadByFilePathError,
  type GetApiV1KbAttachmentsDownloadByFilePathErrors,
  type GetApiV1KbAttachmentsDownloadByFilePathResponses,
  type GetApiV1KbSimulationBranchBreakdownStatsData,
  type GetApiV1KbSimulationBranchBreakdownStatsError,
  type GetApiV1KbSimulationBranchBreakdownStatsErrors,
  type GetApiV1KbSimulationBranchBreakdownStatsResponse,
  type GetApiV1KbSimulationBranchBreakdownStatsResponses,
  type GetApiV1KbSimulationCommitsData,
  type GetApiV1KbSimulationCommitsError,
  type GetApiV1KbSimulationCommitsErrors,
  type GetApiV1KbSimulationCommitsResponse,
  type GetApiV1KbSimulationCommitsResponses,
  type GetApiV1KbSimulationCompareSummaryData,
  type GetApiV1KbSimulationCompareSummaryError,
  type GetApiV1KbSimulationCompareSummaryErrors,
  type GetApiV1KbSimulationCompareSummaryResponse,
  type GetApiV1KbSimulationCompareSummaryResponses,
  type GetApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  type GetApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  type GetApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  type GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  type GetApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  type GetApiV1KbSimulationDatapointsData,
  type GetApiV1KbSimulationDatapointsError,
  type GetApiV1KbSimulationDatapointsErrors,
  type GetApiV1KbSimulationDatapointsResponse,
  type GetApiV1KbSimulationDatapointsResponses,
  type GetApiV1KbSimulationResultsBySimulationResultIdData,
  type GetApiV1KbSimulationResultsBySimulationResultIdError,
  type GetApiV1KbSimulationResultsBySimulationResultIdErrors,
  type GetApiV1KbSimulationResultsBySimulationResultIdResponse,
  type GetApiV1KbSimulationResultsBySimulationResultIdResponses,
  type GetApiV1KbSimulationResultsData,
  type GetApiV1KbSimulationResultsError,
  type GetApiV1KbSimulationResultsErrors,
  type GetApiV1KbSimulationResultsResponse,
  type GetApiV1KbSimulationResultsResponses,
  type GetApiV1KbsOwnedData,
  type GetApiV1KbsOwnedError,
  type GetApiV1KbsOwnedErrors,
  type GetApiV1KbsOwnedResponse,
  type GetApiV1KbsOwnedResponses,
  type GetApiV1MachineUsersByMachineUserIdApiKeysData,
  type GetApiV1MachineUsersByMachineUserIdApiKeysError,
  type GetApiV1MachineUsersByMachineUserIdApiKeysErrors,
  type GetApiV1MachineUsersByMachineUserIdApiKeysResponse,
  type GetApiV1MachineUsersByMachineUserIdApiKeysResponses,
  type GetApiV1MachineUsersByMachineUserIdData,
  type GetApiV1MachineUsersByMachineUserIdError,
  type GetApiV1MachineUsersByMachineUserIdErrors,
  type GetApiV1MachineUsersByMachineUserIdResponse,
  type GetApiV1MachineUsersByMachineUserIdResponses,
  type GetApiV1MachineUsersData,
  type GetApiV1MachineUsersError,
  type GetApiV1MachineUsersErrors,
  type GetApiV1MachineUsersResponse,
  type GetApiV1MachineUsersResponses,
  type GetApiV1McpToolsetsData,
  type GetApiV1McpToolsetsResponse,
  type GetApiV1McpToolsetsResponses,
  type GetApiV1MetricsChildJudgementData,
  type GetApiV1MetricsChildJudgementError,
  type GetApiV1MetricsChildJudgementErrors,
  type GetApiV1MetricsChildJudgementResponse,
  type GetApiV1MetricsChildJudgementResponses,
  type GetApiV1OauthApplicationsByOauthApplicationIdData,
  type GetApiV1OauthApplicationsByOauthApplicationIdError,
  type GetApiV1OauthApplicationsByOauthApplicationIdErrors,
  type GetApiV1OauthApplicationsByOauthApplicationIdResponse,
  type GetApiV1OauthApplicationsByOauthApplicationIdResponses,
  type GetApiV1OauthApplicationsData,
  type GetApiV1OauthApplicationsError,
  type GetApiV1OauthApplicationsErrors,
  type GetApiV1OauthApplicationsResponse,
  type GetApiV1OauthApplicationsResponses,
  type GetApiV1ObjectArticleByObjectArticleIdData,
  type GetApiV1ObjectArticleByObjectArticleIdError,
  type GetApiV1ObjectArticleByObjectArticleIdErrors,
  type GetApiV1ObjectArticleByObjectArticleIdResponse,
  type GetApiV1ObjectArticleByObjectArticleIdResponses,
  type GetApiV1ReposByRepositoryIdArticleByRefData,
  type GetApiV1ReposByRepositoryIdArticleByRefError,
  type GetApiV1ReposByRepositoryIdArticleByRefErrors,
  type GetApiV1ReposByRepositoryIdArticleByRefResponse,
  type GetApiV1ReposByRepositoryIdArticleByRefResponses,
  type GetApiV1ReposByRepositoryIdBlobByRefData,
  type GetApiV1ReposByRepositoryIdBlobByRefError,
  type GetApiV1ReposByRepositoryIdBlobByRefErrors,
  type GetApiV1ReposByRepositoryIdBlobByRefResponse,
  type GetApiV1ReposByRepositoryIdBlobByRefResponses,
  type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewData,
  type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewError,
  type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewErrors,
  type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponse,
  type GetApiV1ReposByRepositoryIdBranchesByBranchNameRebasePreviewResponses,
  type GetApiV1ReposByRepositoryIdBranchesByNameData,
  type GetApiV1ReposByRepositoryIdBranchesByNameError,
  type GetApiV1ReposByRepositoryIdBranchesByNameErrors,
  type GetApiV1ReposByRepositoryIdBranchesByNameResponse,
  type GetApiV1ReposByRepositoryIdBranchesByNameResponses,
  type GetApiV1ReposByRepositoryIdBranchesData,
  type GetApiV1ReposByRepositoryIdBranchesError,
  type GetApiV1ReposByRepositoryIdBranchesErrors,
  type GetApiV1ReposByRepositoryIdBranchesResponse,
  type GetApiV1ReposByRepositoryIdBranchesResponses,
  type GetApiV1ReposByRepositoryIdCommitByRefData,
  type GetApiV1ReposByRepositoryIdCommitByRefError,
  type GetApiV1ReposByRepositoryIdCommitByRefErrors,
  type GetApiV1ReposByRepositoryIdCommitByRefResponse,
  type GetApiV1ReposByRepositoryIdCommitByRefResponses,
  type GetApiV1ReposByRepositoryIdCommitsByRefData,
  type GetApiV1ReposByRepositoryIdCommitsByRefError,
  type GetApiV1ReposByRepositoryIdCommitsByRefErrors,
  type GetApiV1ReposByRepositoryIdCommitsByRefResponse,
  type GetApiV1ReposByRepositoryIdCommitsByRefResponses,
  type GetApiV1ReposByRepositoryIdCompareByBaseheadData,
  type GetApiV1ReposByRepositoryIdCompareByBaseheadError,
  type GetApiV1ReposByRepositoryIdCompareByBaseheadErrors,
  type GetApiV1ReposByRepositoryIdCompareByBaseheadResponse,
  type GetApiV1ReposByRepositoryIdCompareByBaseheadResponses,
  type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadData,
  type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadError,
  type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadErrors,
  type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponse,
  type GetApiV1ReposByRepositoryIdGitDiffBlameByBaseheadResponses,
  type GetApiV1ReposByRepositoryIdTreeByRefData,
  type GetApiV1ReposByRepositoryIdTreeByRefError,
  type GetApiV1ReposByRepositoryIdTreeByRefErrors,
  type GetApiV1ReposByRepositoryIdTreeByRefResponse,
  type GetApiV1ReposByRepositoryIdTreeByRefResponses,
  type GetApiV1SearchData,
  type GetApiV1SearchError,
  type GetApiV1SearchErrors,
  type GetApiV1SearchResponse,
  type GetApiV1SearchResponses,
  type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesData,
  type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesError,
  type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesErrors,
  type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponse,
  type GetApiV1ServiceNowTenantsByTenantIdApprovalsStateChoicesResponses,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesData,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesError,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesResponse,
  type GetApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsData,
  type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsError,
  type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdAssignmentGroupsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentData,
  type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentError,
  type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentErrors,
  type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponse,
  type GetApiV1ServiceNowTenantsByTenantIdAttachmentsByAttachmentSysIdContentResponses,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdData,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdError,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsBySysIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsData,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsError,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdCatalogItemsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdData,
  type GetApiV1ServiceNowTenantsByTenantIdError,
  type GetApiV1ServiceNowTenantsByTenantIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesData,
  type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesError,
  type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesErrors,
  type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponse,
  type GetApiV1ServiceNowTenantsByTenantIdIncidentsStateChoicesResponses,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
  type GetApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsData,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsError,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdApprovalsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksData,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksError,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksErrors,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponse,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsByRequestItemSysIdTasksResponses,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdData,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdError,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdRequestItemsBySysIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsData,
  type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsError,
  type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdRequestsByRequestSysIdRequestItemsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdTagsData,
  type GetApiV1ServiceNowTenantsByTenantIdTagsError,
  type GetApiV1ServiceNowTenantsByTenantIdTagsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdTagsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdTagsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdData,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdError,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdErrors,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponse,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsBySysIdResponses,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsData,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsError,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsByTicketSysIdAttachmentsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsData,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsError,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsErrors,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsResponse,
  type GetApiV1ServiceNowTenantsByTenantIdTicketsResponses,
  type GetApiV1ServiceNowTenantsByTenantIdUsersData,
  type GetApiV1ServiceNowTenantsByTenantIdUsersError,
  type GetApiV1ServiceNowTenantsByTenantIdUsersErrors,
  type GetApiV1ServiceNowTenantsByTenantIdUsersResponse,
  type GetApiV1ServiceNowTenantsByTenantIdUsersResponses,
  type GetApiV1ServiceNowTenantsData,
  type GetApiV1ServiceNowTenantsError,
  type GetApiV1ServiceNowTenantsErrors,
  type GetApiV1ServiceNowTenantsResponse,
  type GetApiV1ServiceNowTenantsResponses,
  type GetApiV1SesameEdraAccessData,
  type GetApiV1SesameEdraAccessError,
  type GetApiV1SesameEdraAccessErrors,
  type GetApiV1SesameEdraAccessResponse,
  type GetApiV1SesameEdraAccessResponses,
  type GetApiV1TasksByTaskIdFeedbackLabelsData,
  type GetApiV1TasksByTaskIdFeedbackLabelsError,
  type GetApiV1TasksByTaskIdFeedbackLabelsErrors,
  type GetApiV1TasksByTaskIdFeedbackLabelsResponse,
  type GetApiV1TasksByTaskIdFeedbackLabelsResponses,
  type GetApiV1TasksByTaskIdPromptsByPromptIdData,
  type GetApiV1TasksByTaskIdPromptsByPromptIdError,
  type GetApiV1TasksByTaskIdPromptsByPromptIdErrors,
  type GetApiV1TasksByTaskIdPromptsByPromptIdResponse,
  type GetApiV1TasksByTaskIdPromptsByPromptIdResponses,
  type GetApiV1TasksByTaskIdPromptsData,
  type GetApiV1TasksByTaskIdPromptsError,
  type GetApiV1TasksByTaskIdPromptsErrors,
  type GetApiV1TasksByTaskIdPromptsResponse,
  type GetApiV1TasksByTaskIdPromptsResponses,
  type GetApiV1UsageStatsAgentsData,
  type GetApiV1UsageStatsAgentsError,
  type GetApiV1UsageStatsAgentsErrors,
  type GetApiV1UsageStatsAgentsResponse,
  type GetApiV1UsageStatsAgentsResponses,
  type GetApiV1UsersByUserIdData,
  type GetApiV1UsersByUserIdError,
  type GetApiV1UsersByUserIdErrors,
  type GetApiV1UsersByUserIdNotificationSettingsData,
  type GetApiV1UsersByUserIdNotificationSettingsError,
  type GetApiV1UsersByUserIdNotificationSettingsErrors,
  type GetApiV1UsersByUserIdNotificationSettingsResponse,
  type GetApiV1UsersByUserIdNotificationSettingsResponses,
  type GetApiV1UsersByUserIdResponse,
  type GetApiV1UsersByUserIdResponses,
  type GetApiV1UsersData,
  type GetApiV1UsersError,
  type GetApiV1UsersErrors,
  type GetApiV1UsersMeData,
  type GetApiV1UsersMeResponse,
  type GetApiV1UsersMeResponses,
  type GetApiV1UsersResponse,
  type GetApiV1UsersResponses,
  type GetApiV1WorkEventsByEventIdData,
  type GetApiV1WorkEventsByEventIdError,
  type GetApiV1WorkEventsByEventIdErrors,
  type GetApiV1WorkEventsByEventIdResponse,
  type GetApiV1WorkEventsByEventIdResponses,
  type GetApiV1WorkflowAnalyticsEventsData,
  type GetApiV1WorkflowAnalyticsEventsError,
  type GetApiV1WorkflowAnalyticsEventsErrors,
  type GetApiV1WorkflowAnalyticsEventsResponse,
  type GetApiV1WorkflowAnalyticsEventsResponses,
  type GetApiV1WorkflowRunsByWorkflowRunIdData,
  type GetApiV1WorkflowRunsByWorkflowRunIdError,
  type GetApiV1WorkflowRunsByWorkflowRunIdErrors,
  type GetApiV1WorkflowRunsByWorkflowRunIdResponse,
  type GetApiV1WorkflowRunsByWorkflowRunIdResponses,
  type GetApiV1WorkflowsData,
  type GetApiV1WorkflowsError,
  type GetApiV1WorkflowsErrors,
  type GetApiV1WorkflowsResponse,
  type GetApiV1WorkflowsResponses,
  type GetApiV1WorkspacesByWorkspaceIdData,
  type GetApiV1WorkspacesByWorkspaceIdError,
  type GetApiV1WorkspacesByWorkspaceIdErrors,
  type GetApiV1WorkspacesByWorkspaceIdResponse,
  type GetApiV1WorkspacesByWorkspaceIdResponses,
  type GetApiV1WorkspacesData,
  type GetApiV1WorkspacesError,
  type GetApiV1WorkspacesErrors,
  type GetApiV1WorkspacesResponse,
  type GetApiV1WorkspacesResponses,
  type GetApiV1ZendeskOauthRedirectUriData,
  type GetApiV1ZendeskOauthRedirectUriResponse,
  type GetApiV1ZendeskOauthRedirectUriResponses,
  type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentData,
  type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentError,
  type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentErrors,
  type GetApiV1ZendeskTenantsByTenantIdArticleAttachmentsByAttachmentIdContentResponses,
  type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsData,
  type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsError,
  type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsErrors,
  type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponse,
  type GetApiV1ZendeskTenantsByTenantIdArticlesByArticleIdAttachmentsResponses,
  type GetApiV1ZendeskTenantsByTenantIdArticlesData,
  type GetApiV1ZendeskTenantsByTenantIdArticlesError,
  type GetApiV1ZendeskTenantsByTenantIdArticlesErrors,
  type GetApiV1ZendeskTenantsByTenantIdArticlesResponse,
  type GetApiV1ZendeskTenantsByTenantIdArticlesResponses,
  type GetApiV1ZendeskTenantsByTenantIdCheckConnectionData,
  type GetApiV1ZendeskTenantsByTenantIdCheckConnectionError,
  type GetApiV1ZendeskTenantsByTenantIdCheckConnectionErrors,
  type GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponse,
  type GetApiV1ZendeskTenantsByTenantIdCheckConnectionResponses,
  type GetApiV1ZendeskTenantsByTenantIdData,
  type GetApiV1ZendeskTenantsByTenantIdError,
  type GetApiV1ZendeskTenantsByTenantIdErrors,
  type GetApiV1ZendeskTenantsByTenantIdResponse,
  type GetApiV1ZendeskTenantsByTenantIdResponses,
  type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdData,
  type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdError,
  type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdErrors,
  type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponse,
  type GetApiV1ZendeskTenantsByTenantIdTicketsByTicketIdResponses,
  type GetApiV1ZendeskTenantsByTenantIdTicketsData,
  type GetApiV1ZendeskTenantsByTenantIdTicketsError,
  type GetApiV1ZendeskTenantsByTenantIdTicketsErrors,
  type GetApiV1ZendeskTenantsByTenantIdTicketsResponse,
  type GetApiV1ZendeskTenantsByTenantIdTicketsResponses,
  type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdData,
  type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdError,
  type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdErrors,
  type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponse,
  type GetApiV1ZendeskTenantsByTenantIdUsersByUserIdResponses,
  type GetApiV1ZendeskTenantsByTenantIdUsersData,
  type GetApiV1ZendeskTenantsByTenantIdUsersError,
  type GetApiV1ZendeskTenantsByTenantIdUsersErrors,
  type GetApiV1ZendeskTenantsByTenantIdUsersResponse,
  type GetApiV1ZendeskTenantsByTenantIdUsersResponses,
  type GetApiV1ZendeskTenantsData,
  type GetApiV1ZendeskTenantsError,
  type GetApiV1ZendeskTenantsErrors,
  type GetApiV1ZendeskTenantsResponse,
  type GetApiV1ZendeskTenantsResponses,
  type GetApiV2AttachmentsDataByAttachmentIdByFilenameData,
  type GetApiV2AttachmentsDataByAttachmentIdByFilenameError,
  type GetApiV2AttachmentsDataByAttachmentIdByFilenameErrors,
  type GetApiV2AttachmentsDataByAttachmentIdByFilenameResponses,
  type GetApiV2FinalizedConversationsData,
  type GetApiV2FinalizedConversationsError,
  type GetApiV2FinalizedConversationsErrors,
  type GetApiV2FinalizedConversationsResponse,
  type GetApiV2FinalizedConversationsResponses,
  type GetApiV2FullFinalizedConversationsByFinalizedConversationIdData,
  type GetApiV2FullFinalizedConversationsByFinalizedConversationIdError,
  type GetApiV2FullFinalizedConversationsByFinalizedConversationIdErrors,
  type GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponse,
  type GetApiV2FullFinalizedConversationsByFinalizedConversationIdResponses,
  type GetApiV2FullFinalizedConversationsData,
  type GetApiV2FullFinalizedConversationsError,
  type GetApiV2FullFinalizedConversationsErrors,
  type GetApiV2FullFinalizedConversationsResponse,
  type GetApiV2FullFinalizedConversationsResponses,
  type GetApiV2FullInferenceConversationInferencesData,
  type GetApiV2FullInferenceConversationInferencesError,
  type GetApiV2FullInferenceConversationInferencesErrors,
  type GetApiV2FullInferenceConversationInferencesResponse,
  type GetApiV2FullInferenceConversationInferencesResponses,
  type GetApiV2FullInferenceConversationsData,
  type GetApiV2FullInferenceConversationsError,
  type GetApiV2FullInferenceConversationsErrors,
  type GetApiV2FullInferenceConversationsResponse,
  type GetApiV2FullInferenceConversationsResponses,
  type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdData,
  type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdError,
  type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
  type GetApiV2InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  type GetApiV2InferenceConversationsByExternalIdData,
  type GetApiV2InferenceConversationsByExternalIdError,
  type GetApiV2InferenceConversationsByExternalIdErrors,
  type GetApiV2InferenceConversationsByExternalIdResponse,
  type GetApiV2InferenceConversationsByExternalIdResponses,
  type GetApiV2InferenceConversationsData,
  type GetApiV2InferenceConversationsError,
  type GetApiV2InferenceConversationsErrors,
  type GetApiV2InferenceConversationsResponse,
  type GetApiV2InferenceConversationsResponses,
  type GetApiV2JudgementsData,
  type GetApiV2JudgementsError,
  type GetApiV2JudgementsErrors,
  type GetApiV2JudgementsResponse,
  type GetApiV2JudgementsResponses,
  type GetApiV2JudgesByJudgeIdData,
  type GetApiV2JudgesByJudgeIdError,
  type GetApiV2JudgesByJudgeIdErrors,
  type GetApiV2JudgesByJudgeIdResponse,
  type GetApiV2JudgesByJudgeIdResponses,
  type GetApiV2JudgesData,
  type GetApiV2JudgesError,
  type GetApiV2JudgesErrors,
  type GetApiV2JudgesResponse,
  type GetApiV2JudgesResponses,
  type GetApiV2KanonicalDatapointsByKanonicalDatapointIdData,
  type GetApiV2KanonicalDatapointsByKanonicalDatapointIdError,
  type GetApiV2KanonicalDatapointsByKanonicalDatapointIdErrors,
  type GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponse,
  type GetApiV2KanonicalDatapointsByKanonicalDatapointIdResponses,
  type GetApiV2KanonicalDatapointsData,
  type GetApiV2KanonicalDatapointsError,
  type GetApiV2KanonicalDatapointsErrors,
  type GetApiV2KanonicalDatapointsResponse,
  type GetApiV2KanonicalDatapointsResponses,
  type GetApiV2KbsByKbIdData,
  type GetApiV2KbsByKbIdEmbeddingSummaryData,
  type GetApiV2KbsByKbIdEmbeddingSummaryError,
  type GetApiV2KbsByKbIdEmbeddingSummaryErrors,
  type GetApiV2KbsByKbIdEmbeddingSummaryResponse,
  type GetApiV2KbsByKbIdEmbeddingSummaryResponses,
  type GetApiV2KbsByKbIdError,
  type GetApiV2KbsByKbIdErrors,
  type GetApiV2KbsByKbIdResponse,
  type GetApiV2KbsByKbIdResponses,
  type GetApiV2MetricsChangeCountsData,
  type GetApiV2MetricsChangeCountsError,
  type GetApiV2MetricsChangeCountsErrors,
  type GetApiV2MetricsChangeCountsResponse,
  type GetApiV2MetricsChangeCountsResponses,
  type GetApiV2MetricsChangeUsersData,
  type GetApiV2MetricsChangeUsersError,
  type GetApiV2MetricsChangeUsersErrors,
  type GetApiV2MetricsChangeUsersResponse,
  type GetApiV2MetricsChangeUsersResponses,
  type GetApiV2MetricsTopArticleJudgementData,
  type GetApiV2MetricsTopArticleJudgementError,
  type GetApiV2MetricsTopArticleJudgementErrors,
  type GetApiV2MetricsTopArticleJudgementResponse,
  type GetApiV2MetricsTopArticleJudgementResponses,
  type GetApiV2MetricsVerificationData,
  type GetApiV2MetricsVerificationError,
  type GetApiV2MetricsVerificationErrors,
  type GetApiV2MetricsVerificationResponse,
  type GetApiV2MetricsVerificationResponses,
  type GetApiV2TasksByTaskIdData,
  type GetApiV2TasksByTaskIdError,
  type GetApiV2TasksByTaskIdErrors,
  type GetApiV2TasksByTaskIdResponse,
  type GetApiV2TasksByTaskIdResponses,
  type GetApiV2TasksData,
  type GetApiV2TasksError,
  type GetApiV2TasksErrors,
  type GetApiV2TasksResponse,
  type GetApiV2TasksResponses,
  type GetApiV3DatapointsByDatapointIdData,
  type GetApiV3DatapointsByDatapointIdError,
  type GetApiV3DatapointsByDatapointIdErrors,
  type GetApiV3DatapointsByDatapointIdResponse,
  type GetApiV3DatapointsByDatapointIdResponses,
  type GetApiV3FullJudgementsData,
  type GetApiV3FullJudgementsError,
  type GetApiV3FullJudgementsErrors,
  type GetApiV3FullJudgementsResponse,
  type GetApiV3FullJudgementsResponses,
  type GetApiV4KbsData,
  type GetApiV4KbsError,
  type GetApiV4KbsErrors,
  type GetApiV4KbsResponse,
  type GetApiV4KbsResponses,
  type GetApiZendeskV1TenantsByTenantIdActionsCategoriesData,
  type GetApiZendeskV1TenantsByTenantIdActionsCategoriesError,
  type GetApiZendeskV1TenantsByTenantIdActionsCategoriesErrors,
  type GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponse,
  type GetApiZendeskV1TenantsByTenantIdActionsCategoriesResponses,
  type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdData,
  type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdError,
  type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdErrors,
  type GetApiZendeskV1TenantsByTenantIdActionsDownloadTicketAttachmentByAttachmentIdResponses,
  type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsData,
  type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsError,
  type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsErrors,
  type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponse,
  type GetApiZendeskV1TenantsByTenantIdActionsSearchTicketsResponses,
  type GetApiZendeskV1TenantsByTenantIdActionsSectionsData,
  type GetApiZendeskV1TenantsByTenantIdActionsSectionsError,
  type GetApiZendeskV1TenantsByTenantIdActionsSectionsErrors,
  type GetApiZendeskV1TenantsByTenantIdActionsSectionsResponse,
  type GetApiZendeskV1TenantsByTenantIdActionsSectionsResponses,
  type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdData,
  type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdError,
  type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdErrors,
  type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponse,
  type GetApiZendeskV1TenantsByTenantIdActionsTicketAttachmentContentByAttachmentIdResponses,
  type GetArticleTagsKeyV1,
  type GetArticleTagsValueV1,
  type GetChangeRequestPossibleAssigneesResponseV1,
  type GetChangeRequestTagsKeyV1,
  type GetChangeRequestTagsValueV1,
  type GetEdraPbOpenapiJsonData,
  type GetEdraPbOpenapiJsonResponse,
  type GetEdraPbOpenapiJsonResponses,
  type GetEmbeddingSummaryResponseV2,
  type GetMcpToolsetsResponseV1,
  type GetMyKbAccessRequestResultV1,
  type GetObjectArticleV1ResponseV1,
  type GetPromptsResponseV1,
  type GetPublicHealthData,
  type GetPublicHealthResponse,
  type GetPublicHealthResponses,
  type GetRequesterTeamsResultV1,
  type GetRolesResultV1,
  type GetSdkOpenapiJsonData,
  type GetSdkOpenapiJsonResponse,
  type GetSdkOpenapiJsonResponses,
  type GetTeamArticlePermissionsResultV1,
  type GetTeamKbAssignmentsResultV1,
  type GetTeamsWithAccessResultV1,
  type GitAmendParamsV1,
  type GitArticleV1,
  type GitBlobV2,
  type GitBranchCreateParamsV2,
  type GitBranchUpdateParamsV1,
  type GitBranchV2,
  type GitCherryPickConflictErrorV1,
  type GitCherryPickErrorV1,
  type GitCherryPickParamsV1,
  type GitCherryPickStaleHeadErrorV1,
  type GitCommitAuthorV1,
  type GitCommitishV1Parse,
  type GitCommitParamsV2,
  type GitCommitV2,
  GitConflictCodeV1,
  type GitConflictV1,
  type GitDiffBlameEntryArticleV1AddedV1,
  type GitDiffBlameEntryArticleV1ModifiedV1,
  type GitDiffBlameEntryArticleV1RemovedV1,
  type GitDiffBlameEntryBlobAddedV1,
  type GitDiffBlameEntryBlobModifiedV1,
  type GitDiffBlameEntryBlobRemovedV1,
  type GitDiffBlameEntryV1,
  type GitDiffBlameHunkV1,
  type GitDiffBlameLineV1,
  type GitDiffBlameResponseV1,
  type GitDiffEntryArticleV1AddedV2,
  type GitDiffEntryArticleV1ModifiedV2,
  type GitDiffEntryArticleV1RemovedV2,
  type GitDiffEntryBlobAddedV2,
  type GitDiffEntryBlobModifiedV2,
  type GitDiffEntryBlobRemovedV2,
  type GitDiffEntryMovedV2,
  type GitDiffEntryReorderedV2,
  type GitDiffHunkV2,
  type GitDiffResponseV2,
  type GitLogCommitV2,
  type GitLogV2,
  type GitLsTreeResponseV2,
  type GitMergeV2,
  type GitObjectArticleV1SchemaV1,
  type GitPatchAddArticleV1SchemaV2,
  type GitPatchAddBlobV2,
  type GitPatchMoveV2,
  type GitPatchRemoveV2,
  type GitPatchReorderV2,
  type GitPatchUpdateArticleV1SchemaV2,
  type GitPatchUpdateBlobV2,
  type GitPatchV2,
  type GitRebaseConflictErrorV1,
  type GitRebasePreviewResultV1,
  type GitRebaseV2,
  type GitShowArticleV1,
  type GitShowV2,
  type GitTreeEntryArticleV1SchemaV2,
  type GitTreeEntryBlobV2,
  type GitTreeEntryTreeV2,
  type GitTreeEntryV2,
  type GrantSharepointSiteParamsV1,
  type HeadApiV1AttachmentsMetadataByFilePathData,
  type HeadApiV1AttachmentsMetadataByFilePathError,
  type HeadApiV1AttachmentsMetadataByFilePathErrors,
  type HeadApiV1AttachmentsMetadataByFilePathResponses,
  type HttpValidationError,
  type HubSpotAddNoteParamsV2,
  type HubSpotAddNoteResponseV2,
  type HubSpotAttachmentRefV1,
  type HubSpotCheckConnectionResponseV1,
  type HubSpotCompanyFullV1,
  type HubSpotCreateThreadOnTicketParamsV1,
  type HubSpotGetAttachmentContentResponseV1,
  type HubSpotGetAttachmentMetadataResponseV1,
  type HubSpotIngestResponseV1,
  type HubSpotManifestLastDownloadV1,
  type HubSpotNoteV1,
  type HubSpotReplyToThreadParamsV1,
  type HubSpotSendChannelV1,
  type HubSpotSetTicketOwnerParamsV1,
  type HubSpotSetTicketStatusParamsV1,
  type HubSpotTenantCredentialsV1,
  type HubSpotTenantFullV1,
  type HubSpotTenantInstallationV1,
  type HubSpotTenantV1,
  type HubSpotThreadMessageStatusV1,
  type HubSpotThreadMessageV1,
  type HubSpotThreadV1,
  type HubSpotTicketFullV1,
  type HubSpotTicketPageV1,
  type HubSpotTicketV1,
  type HubSpotUpdateNoteParamsV1,
  type HubSpotUpdateTicketPropertiesParamsV1,
  type HybridSearchParamsV1,
  type HybridSearchResponseV1,
  type HybridSearchSourceV1,
  ImageContentTypeV1,
  type ImageUploadUrlRequestV1,
  type ImageUploadUrlResponseV1,
  type IndexTextResponseV2,
  type InferenceCitationV1,
  InferenceConfidenceV1,
  type InferenceConversationFullV1,
  type InferenceConversationInferenceFullV1,
  type InferenceConversationInferenceV1,
  type InferenceConversationV1,
  type InferenceDatapointFullV1,
  type InferenceDatapointFullV2,
  type InferenceDatapointSpansV1,
  type InferenceDatapointV1,
  type InferenceEvalFullV1,
  type InferenceFeedbackFullV1,
  type InferenceFeedbackLabelV1,
  type InferenceFeedbackV1,
  type InferenceFullV1,
  InferenceModeV1,
  type IngestionFileV1,
  type InvitationFullV1,
  type InvitationV1,
  InviteRoleV1,
  type JiraAttachmentV1,
  type JiraCheckConnectionResponseV1,
  type JiraCommentV1,
  type JiraConnectedV1,
  type JiraCustomFieldOptionV1,
  type JiraCustomFieldV1,
  type JiraDisconnectedV1,
  type JiraGetAttachmentContentResponseV2,
  type JiraGetCustomFieldOptionsResponseV1,
  type JiraGetIssuesResponseV1,
  type JiraHandleWebhookEventResponseV1,
  JiraHeadingLevelV1,
  type JiraInlineTextLinkV1,
  type JiraInlineTextV1,
  type JiraInlineV1,
  type JiraIssueStatusV1,
  type JiraIssueTypeV1,
  type JiraIssueV1,
  JiraListTypeV1,
  JiraPanelTypeV1,
  type JiraPostCommentRequestV2,
  type JiraPostCommentResponseV2,
  type JiraProjectV1,
  type JiraRichTextCodeBlockV1,
  type JiraRichTextExpandV1,
  type JiraRichTextHeadingV1,
  type JiraRichTextListV1,
  type JiraRichTextPanelV1,
  type JiraRichTextParagraphV1,
  type JiraRichTextQuoteV1,
  type JiraRichTextRuleV1,
  type JiraRichTextV1,
  type JiraSetCustomFieldRequestV1,
  type JiraSetCustomFieldResponseV1,
  type JiraTenantConfigV1,
  type JiraTenantFullV1,
  type JiraTenantV1,
  type JiraUpdateIssueLabelsRequestV1,
  type JiraUpdateIssueLabelsResponseV1,
  JiraUserAccountTypeV1,
  type JiraUserV1,
  type Json,
  type JsonInput,
  type JsonOutput,
  type JsonSchemaV1Input,
  type JsonSchemaV1Output,
  type JudgeBarContentV1,
  type JudgeBarValueV1,
  type JudgeBucket,
  JudgeColorScale,
  type JudgeFilterOptionV1,
  type JudgeFullV2,
  type JudgeGaugeContentV1,
  type JudgeGaugeSegmentV1,
  type JudgementFilterOptionsParamsV1,
  type JudgementFilterOptionsResultV1,
  type JudgementFullAgentV3,
  type JudgementFullExternalV3,
  type JudgementFullPlatformV3,
  type JudgementFullV2,
  type JudgementFullV3,
  type JudgementOrdinalValueV2,
  type JudgementV2,
  type JudgementV3,
  type JudgementValueFilterV1,
  type JudgeOrdinalV2,
  type JudgePercentageContentV1,
  type JudgePercentageProgressBarContentV1,
  type JudgeSeriesContentV1,
  type JudgeSeriesV1,
  type JudgeSingleStatContentV1,
  type JudgeV2,
  type KanonicalDatapointFullV2,
  type KanonicalDatapointV1,
  type KanonicalInputOutputFullV2,
  type KanonicalizeDatapointsDequeueByDagsterRunV1,
  type KanonicalizeDatapointsDequeueByIdsV1,
  type KanonicalizeDatapointsDequeueRequestV1,
  type KanonicalizeDatapointsDequeueResponseV1,
  type KanonicalizeDatapointsEnqueueByDagsterRunV1,
  type KanonicalizeDatapointsEnqueueByIdsV1,
  type KanonicalizeDatapointsEnqueueRequestV1,
  type KanonicalizeDatapointsEnqueueResponseV1,
  type KanonicalizeDatapointsInputRequestV1,
  type KanonicalizeDatapointsInputResponseV1,
  type KanonicalizeDatapointsOutputCreateV1,
  type KanonicalizeDatapointsOutputRequestV1,
  type KanonicalizeDatapointsOutputResponseV1,
  type KanonicalizeDatapointsOutputUpdateV1,
  type KanonicalMessagesFullV2,
  type KbAccessRequestFullV1,
  KbAccessRequestResolutionV1,
  KbAccessRequestStatusV1,
  type KbAccessRequestV1,
  KbArticleRankOrderV1,
  type KbChildJudgementMetricsResponseV1,
  type KbChildJudgementMetricsV1,
  KbChildKindV1,
  type KbJudgementValueVolumeV1,
  KbScopeV1,
  type KbTopArticleJudgementMetricsV1,
  type KnowledgeBaseFullV1,
  type KnowledgeBaseSearchContentV1,
  type KnowledgeBaseV2,
  type KnownIncomingKbV1,
  type LimitFilterV1,
  type LimitV1,
  type LineChartContentSeriesV1,
  type LineChartContentV1,
  type LineRangeV1,
  type MachineUserFullV1,
  type MachineUserV1,
  type McpToolsetV1,
  type Metadata,
  Missing,
  type MovedArticleV1DiffV2,
  type NonEmptyStr,
  type NonEmptyStr09aF32,
  type NotificationSettingsV1,
  type NotionAnnotationsV1,
  type NotionBlockInputV1,
  type NotionBlockV1,
  type NotionBookmarkBlockInputV1,
  type NotionBookmarkBlockV1,
  type NotionBookmarkContentInputV1,
  type NotionBookmarkContentV1,
  type NotionBreadcrumbBlockV1,
  type NotionBulletedListItemBlockInputV1,
  type NotionBulletedListItemBlockV1,
  type NotionCallbackPayloadV1,
  type NotionCalloutBlockInputV1,
  type NotionCalloutBlockV1,
  type NotionCalloutContentInputV1,
  type NotionCalloutContentV1,
  type NotionCheckConnectionResponseV1,
  type NotionChildDatabaseBlockV1,
  type NotionChildPageBlockV1,
  type NotionChildPageContentV1,
  type NotionCodeBlockInputV1,
  type NotionCodeBlockV1,
  type NotionCodeContentInputV1,
  type NotionCodeContentV1,
  type NotionColumnBlockV1,
  type NotionColumnListBlockV1,
  type NotionCommentV1,
  type NotionConnectResponseV1,
  type NotionDatabaseV1,
  type NotionDividerBlockInputV1,
  type NotionDividerBlockV1,
  type NotionEmbedBlockInputV1,
  type NotionEmbedBlockV1,
  type NotionEmojiIconInputV1,
  type NotionEmojiIconV1,
  type NotionEmptyContentV1,
  type NotionEmptyInputV1,
  type NotionEquationBlockInputV1,
  type NotionEquationBlockV1,
  type NotionEquationContentInputV1,
  type NotionEquationContentV1,
  type NotionExternalFileInputV1,
  type NotionExternalFileObjectV1,
  type NotionExternalFileV1,
  type NotionExternalIconInputV1,
  type NotionExternalIconV1,
  type NotionFileBlockInputV1,
  type NotionFileBlockV1,
  type NotionFileObjectInputV1,
  type NotionFileObjectV1,
  type NotionHeading1BlockInputV1,
  type NotionHeading1BlockV1,
  type NotionHeading2BlockInputV1,
  type NotionHeading2BlockV1,
  type NotionHeading3BlockInputV1,
  type NotionHeading3BlockV1,
  type NotionHeadingContentInputV1,
  type NotionHeadingContentV1,
  type NotionHostedFileObjectV1,
  type NotionHostedFileV1,
  type NotionHostedIconV1,
  type NotionIconInputV1,
  type NotionIconV1,
  type NotionImageBlockInputV1,
  type NotionImageBlockV1,
  type NotionIngestResponseV1,
  type NotionKnownBlockV1,
  type NotionLinkInputV1,
  type NotionLinkPreviewBlockInputV1,
  type NotionLinkPreviewBlockV1,
  type NotionLinkPreviewContentInputV1,
  type NotionLinkPreviewContentV1,
  type NotionNumberedListItemBlockInputV1,
  type NotionNumberedListItemBlockV1,
  type NotionPageContentV1,
  type NotionPageV1,
  type NotionParagraphBlockInputV1,
  type NotionParagraphBlockV1,
  NotionParentKindV1,
  type NotionPdfBlockV1,
  type NotionQuoteBlockInputV1,
  type NotionQuoteBlockV1,
  type NotionRichTextContentInputV1,
  type NotionRichTextContentV1,
  type NotionRichTextInputV1,
  type NotionRichTextV1,
  type NotionSyncedBlockBlockV1,
  type NotionSyncedBlockContentV1,
  NotionSyncedFromKindV1,
  type NotionSyncedFromV1,
  type NotionTableBlockV1,
  type NotionTableContentV1,
  type NotionTableOfContentsBlockV1,
  type NotionTableOfContentsContentV1,
  type NotionTableRowBlockV1,
  type NotionTableRowContentV1,
  type NotionTenantFullV1,
  type NotionTenantV1,
  type NotionTextInputV1,
  type NotionToDoBlockInputV1,
  type NotionToDoBlockV1,
  type NotionToDoContentInputV1,
  type NotionToDoContentV1,
  type NotionToggleBlockInputV1,
  type NotionToggleBlockV1,
  type NotionUnsupportedBlockV1,
  type NotionVideoBlockInputV1,
  type NotionVideoBlockV1,
  type NotionWebhookVerificationTokenV1,
  type OAuthApplicationFullV1,
  OAuthApplicationProviderV1,
  type OAuthApplicationSecretV1,
  type OAuthApplicationV1,
  type OAuthAuthorizationServerMetadataV1,
  OAuthBearerMethodV1,
  OAuthCodeChallengeMethodV1,
  OAuthGrantTypeV1,
  type OAuthProtectedResourceMetadataV1,
  OAuthResponseTypeV1,
  type OauthSecretPlainValueV2,
  type OauthSecretValueParamsV1,
  OAuthTokenEndpointAuthMethodV1,
  type OrganizationFullV1,
  type OrganizationV1,
  type OrgMemberRoleChangeV1,
  OrgMemberRoleV1,
  type OrgMembershipChangeV1,
  OrgMembershipResultV1,
  OrgMembershipRoleV1,
  type OrgMemberV1,
  OrientationV1,
  type OutlookAddEmailAttachmentParamsV1,
  type OutlookAddEmailAttachmentResponseV1,
  type OutlookComposeResponseV1,
  type OutlookCopyEmailParamsV1,
  type OutlookCopyEmailResponseV1,
  type OutlookCreateDraftParamsV1,
  type OutlookDeleteEmailParamsV1,
  type OutlookDeleteEmailResponseV1,
  OutlookEmailImportanceV1,
  type OutlookFileAttachmentResponseV1,
  type OutlookForwardEmailParamsV1,
  type OutlookGetEmailAttachmentParamsV1,
  type OutlookGetEmailAttachmentResponseV1,
  type OutlookItemAttachmentResponseV1,
  type OutlookMarkEmailReadParamsV1,
  type OutlookModifyResponseV1,
  type OutlookMoveEmailParamsV1,
  type OutlookMoveEmailResponseV1,
  type OutlookReferenceAttachmentResponseV1,
  type OutlookRemoveEmailAttachmentParamsV1,
  type OutlookRemoveEmailAttachmentResponseV1,
  type OutlookReplyEmailParamsV1,
  type OutlookSendEmailParamsV1,
  type OutlookSendEmailResponseV1,
  type OutlookSetEmailCategoriesParamsV1,
  type OutlookSetEmailFlagParamsV1,
  OutlookSetEmailFlagStatusV1,
  type OutlookSetEmailImportanceParamsV1,
  type OutlookSubscriptionV1,
  type PageV1AgentSessionFullV1,
  type PageV1AgentSessionV1,
  type PageV1ApiKeyFullV1,
  type PageV1ApiKeyV1,
  type PageV1CalibrationFeedbackDimensionFullV1,
  type PageV1CalibrationFeedbackDimensionV1,
  type PageV1CalibrationFeedbackInferenceDatapointV1,
  type PageV1CalibrationFeedbackQueueItemFullV1,
  type PageV1CalibrationFeedbackQueueItemV1,
  type PageV1CalibrationFeedbackTagKeyV1,
  type PageV1CalibrationFeedbackVerdictFullV1,
  type PageV1CalibrationFeedbackVerdictV1,
  type PageV1ChangeRequestFullV1,
  type PageV1ChangeRequestV1,
  type PageV1CommentFullV1,
  type PageV1ConfluenceTenantV1,
  type PageV1DataDumpConversationFullV1,
  type PageV1DataDumpConversationV1,
  type PageV1DatapointEvidenceV1,
  type PageV1DatapointFullV3,
  type PageV1EntraProposedActionV1,
  type PageV1EntraTenantFullV1,
  type PageV1EntraTenantV1,
  type PageV1EvalJudgeV1,
  type PageV1FinalizedConversationFullV2,
  type PageV1FinalizedConversationV1,
  type PageV1GetArticleTagsKeyV1,
  type PageV1GetChangeRequestTagsKeyV1,
  type PageV1GitBranchV2,
  type PageV1HubSpotNoteV1,
  type PageV1HubSpotTenantFullV1,
  type PageV1HubSpotTenantV1,
  type PageV1HubSpotThreadMessageV1,
  type PageV1InferenceConversationFullV1,
  type PageV1InferenceConversationInferenceFullV1,
  type PageV1InferenceConversationV1,
  type PageV1InvitationFullV1,
  type PageV1InvitationV1,
  type PageV1JiraTenantFullV1,
  type PageV1JiraTenantV1,
  type PageV1JudgementFullV2,
  type PageV1JudgementFullV3,
  type PageV1JudgeV2,
  type PageV1KanonicalDatapointFullV2,
  type PageV1KnowledgeBaseFullV1,
  type PageV1KnowledgeBaseV2,
  type PageV1MachineUserV1,
  type PageV1NotionTenantV1,
  type PageV1OAuthApplicationFullV1,
  type PageV1OAuthApplicationV1,
  type PageV1OrganizationV1,
  type PageV1OrgMemberV1,
  type PageV1OutlookSubscriptionV1,
  type PageV1PlainTenantFullV1,
  type PageV1PlainTenantV1,
  type PageV1SalesforceTenantFullV1,
  type PageV1SalesforceTenantV1,
  type PageV1SearchResultV1,
  type PageV1SecretFullV1,
  type PageV1SecretV1,
  type PageV1SharepointTenantFullV1,
  type PageV1SharepointTenantV1,
  type PageV1SlackTenantFullV1,
  type PageV1SlackTenantV1,
  type PageV1TaskV2,
  type PageV1TeamsEndCustomerInstallV1,
  type PageV1TeamsTenantFullV1,
  type PageV1TeamsTenantV1,
  type PageV1TeamV1,
  type PageV1UserFullV1,
  type PageV1WorkflowAnalyticsEventV1,
  type PageV1WorkflowRunFullV1,
  type PageV1WorkflowV1,
  type PageV2AgentSessionInferenceV1,
  type PageV2ArticleLineRangeCommentThreadFullV1,
  type PageV2ChangeRequestLineRangeCommentThreadFullV1,
  type PageV2ConversationFullV1,
  type PageV2EvaluatedInferenceDatapointV1,
  type PageV2ExternalInferenceV1,
  type PageV2FreshserviceTenantFullV1,
  type PageV2FreshserviceTenantV1,
  type PageV2FullEvaluatedInferenceDatapointV1,
  type PageV2InferenceDatapointFullV1,
  type PageV2InferenceFeedbackFullV1,
  type PageV2KbAccessRequestFullV1,
  type PageV2KbTopArticleJudgementMetricsV1,
  type PageV2KnowledgeBaseV2,
  type PageV2ServiceNowApprovalV1,
  type PageV2ServiceNowAttachmentV1,
  type PageV2ServiceNowCatalogItemV1,
  type PageV2ServiceNowCatalogVariableValueV1,
  type PageV2ServiceNowKbArticleV1,
  type PageV2ServiceNowKbKnowledgeBaseV1,
  type PageV2ServiceNowRecordV1,
  type PageV2ServiceNowRequestItemV1,
  type PageV2ServiceNowTagV1,
  type PageV2ServiceNowTaskV1,
  type PageV2ServiceNowTenantV1,
  type PageV2ServiceNowTicketV1,
  type PageV2ServiceNowUserGroupV1,
  type PageV2SimulationDatapointFullV1,
  type PageV2SimulationDatapointV1,
  type PageV2SimulationResultFullV1,
  type PageV2SimulationResultJudgementFullV1,
  type PageV2SimulationResultV1,
  type PageV2WorkspaceV1,
  type PageV2ZendeskTenantV1,
  type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdData,
  type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdError,
  type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdErrors,
  type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponse,
  type PatchApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdResponses,
  type PatchApiConfluenceV1TenantsByTenantIdData,
  type PatchApiConfluenceV1TenantsByTenantIdError,
  type PatchApiConfluenceV1TenantsByTenantIdErrors,
  type PatchApiConfluenceV1TenantsByTenantIdResponse,
  type PatchApiConfluenceV1TenantsByTenantIdResponses,
  type PatchApiEntraV1TenantsByTenantIdData,
  type PatchApiEntraV1TenantsByTenantIdError,
  type PatchApiEntraV1TenantsByTenantIdErrors,
  type PatchApiEntraV1TenantsByTenantIdResponse,
  type PatchApiEntraV1TenantsByTenantIdResponses,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdData,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdError,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdErrors,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponse,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesByArticleIdResponses,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdData,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdError,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdErrors,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponse,
  type PatchApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdResponses,
  type PatchApiFreshserviceV1TenantsByTenantIdData,
  type PatchApiFreshserviceV1TenantsByTenantIdError,
  type PatchApiFreshserviceV1TenantsByTenantIdErrors,
  type PatchApiFreshserviceV1TenantsByTenantIdResponse,
  type PatchApiFreshserviceV1TenantsByTenantIdResponses,
  type PatchApiJiraV1TenantsByTenantIdData,
  type PatchApiJiraV1TenantsByTenantIdError,
  type PatchApiJiraV1TenantsByTenantIdErrors,
  type PatchApiJiraV1TenantsByTenantIdResponse,
  type PatchApiJiraV1TenantsByTenantIdResponses,
  type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdData,
  type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdError,
  type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdErrors,
  type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponse,
  type PatchApiNotionV1TenantsByTenantIdActionsBlocksByBlockIdResponses,
  type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdData,
  type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdError,
  type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdErrors,
  type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponse,
  type PatchApiNotionV1TenantsByTenantIdActionsPagesByPageIdResponses,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusData,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusError,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusErrors,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponse,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAgentStatusResponses,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityData,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityError,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityErrors,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponse,
  type PatchApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdPriorityResponses,
  type PatchApiPlainV1TenantsByTenantIdData,
  type PatchApiPlainV1TenantsByTenantIdError,
  type PatchApiPlainV1TenantsByTenantIdErrors,
  type PatchApiPlainV1TenantsByTenantIdResponse,
  type PatchApiPlainV1TenantsByTenantIdResponses,
  type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdData,
  type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdError,
  type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdErrors,
  type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponse,
  type PatchApiSalesforceV1TenantsByTenantIdActionsArticlesByArticleIdResponses,
  type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdData,
  type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdError,
  type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdErrors,
  type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponse,
  type PatchApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdResponses,
  type PatchApiSalesforceV1TenantsByTenantIdData,
  type PatchApiSalesforceV1TenantsByTenantIdError,
  type PatchApiSalesforceV1TenantsByTenantIdErrors,
  type PatchApiSalesforceV1TenantsByTenantIdResponse,
  type PatchApiSalesforceV1TenantsByTenantIdResponses,
  type PatchApiSecretsVaultV1SecretsBySecretIdData,
  type PatchApiSecretsVaultV1SecretsBySecretIdError,
  type PatchApiSecretsVaultV1SecretsBySecretIdErrors,
  type PatchApiSecretsVaultV1SecretsBySecretIdResponse,
  type PatchApiSecretsVaultV1SecretsBySecretIdResponses,
  type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdData,
  type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdError,
  type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdErrors,
  type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponse,
  type PatchApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdResponses,
  type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdData,
  type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdError,
  type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdErrors,
  type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponse,
  type PatchApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdResponses,
  type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdData,
  type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdError,
  type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdErrors,
  type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponse,
  type PatchApiServiceNowV1TenantsByTenantIdActionsRecordsByRecordIdResponses,
  type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdData,
  type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdError,
  type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdErrors,
  type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponse,
  type PatchApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdResponses,
  type PatchApiSharepointV1TenantsByTenantIdData,
  type PatchApiSharepointV1TenantsByTenantIdError,
  type PatchApiSharepointV1TenantsByTenantIdErrors,
  type PatchApiSharepointV1TenantsByTenantIdResponse,
  type PatchApiSharepointV1TenantsByTenantIdResponses,
  type PatchApiSlackV1TenantsByTenantIdData,
  type PatchApiSlackV1TenantsByTenantIdError,
  type PatchApiSlackV1TenantsByTenantIdErrors,
  type PatchApiSlackV1TenantsByTenantIdResponse,
  type PatchApiSlackV1TenantsByTenantIdResponses,
  type PatchApiTeamsV1TenantsByTenantIdData,
  type PatchApiTeamsV1TenantsByTenantIdError,
  type PatchApiTeamsV1TenantsByTenantIdErrors,
  type PatchApiTeamsV1TenantsByTenantIdResponse,
  type PatchApiTeamsV1TenantsByTenantIdResponses,
  type PatchApiV1AgentSessionsByAgentSessionIdData,
  type PatchApiV1AgentSessionsByAgentSessionIdError,
  type PatchApiV1AgentSessionsByAgentSessionIdErrors,
  type PatchApiV1AgentSessionsByAgentSessionIdResponse,
  type PatchApiV1AgentSessionsByAgentSessionIdResponses,
  type PatchApiV1ApiKeysByApiKeyIdData,
  type PatchApiV1ApiKeysByApiKeyIdError,
  type PatchApiV1ApiKeysByApiKeyIdErrors,
  type PatchApiV1ApiKeysByApiKeyIdResponse,
  type PatchApiV1ApiKeysByApiKeyIdResponses,
  type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdData,
  type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdError,
  type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdErrors,
  type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponse,
  type PatchApiV1ArticleLineRangeCommentThreadsByThreadIdResponses,
  type PatchApiV1AuthzOrganizationsByOrgIdData,
  type PatchApiV1AuthzOrganizationsByOrgIdError,
  type PatchApiV1AuthzOrganizationsByOrgIdErrors,
  type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdData,
  type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdError,
  type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdErrors,
  type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponse,
  type PatchApiV1AuthzOrganizationsByOrgIdInvitationsByInvitationIdResponses,
  type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdData,
  type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdError,
  type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdErrors,
  type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponse,
  type PatchApiV1AuthzOrganizationsByOrgIdMembersByUserIdResponses,
  type PatchApiV1AuthzOrganizationsByOrgIdResponse,
  type PatchApiV1AuthzOrganizationsByOrgIdResponses,
  type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdData,
  type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdError,
  type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdErrors,
  type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponse,
  type PatchApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdResponses,
  type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdData,
  type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdError,
  type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdErrors,
  type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponse,
  type PatchApiV1CalibrationFeedbackVerdictsByVerdictIdResponses,
  type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdData,
  type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdError,
  type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdErrors,
  type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponse,
  type PatchApiV1ChangeRequestLineRangeCommentThreadsByThreadIdResponses,
  type PatchApiV1ChangeRequestsByChangeRequestIdData,
  type PatchApiV1ChangeRequestsByChangeRequestIdError,
  type PatchApiV1ChangeRequestsByChangeRequestIdErrors,
  type PatchApiV1ChangeRequestsByChangeRequestIdResponse,
  type PatchApiV1ChangeRequestsByChangeRequestIdResponses,
  type PatchApiV1CommentsByCommentIdData,
  type PatchApiV1CommentsByCommentIdError,
  type PatchApiV1CommentsByCommentIdErrors,
  type PatchApiV1CommentsByCommentIdResponse,
  type PatchApiV1CommentsByCommentIdResponses,
  type PatchApiV1DataDumpConversationsByDataDumpConversationIdData,
  type PatchApiV1DataDumpConversationsByDataDumpConversationIdError,
  type PatchApiV1DataDumpConversationsByDataDumpConversationIdErrors,
  type PatchApiV1DataDumpConversationsByDataDumpConversationIdResponse,
  type PatchApiV1DataDumpConversationsByDataDumpConversationIdResponses,
  type PatchApiV1ExternalInferencesByInferenceIdData,
  type PatchApiV1ExternalInferencesByInferenceIdError,
  type PatchApiV1ExternalInferencesByInferenceIdErrors,
  type PatchApiV1ExternalInferencesByInferenceIdResponse,
  type PatchApiV1ExternalInferencesByInferenceIdResponses,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdData,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdError,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdErrors,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdData,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdError,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdErrors,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponse,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdMessagesByMessageIdResponses,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdResponse,
  type PatchApiV1FinalizedConversationsByFinalizedConversationIdResponses,
  type PatchApiV1HubspotTenantsByTenantIdData,
  type PatchApiV1HubspotTenantsByTenantIdError,
  type PatchApiV1HubspotTenantsByTenantIdErrors,
  type PatchApiV1HubspotTenantsByTenantIdResponse,
  type PatchApiV1HubspotTenantsByTenantIdResponses,
  type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdData,
  type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdError,
  type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdErrors,
  type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponse,
  type PatchApiV1InferenceConversationInferencesByInferenceConversationInferenceIdResponses,
  type PatchApiV1InferenceDatapointsByInferenceDatapointIdData,
  type PatchApiV1InferenceDatapointsByInferenceDatapointIdError,
  type PatchApiV1InferenceDatapointsByInferenceDatapointIdErrors,
  type PatchApiV1InferenceDatapointsByInferenceDatapointIdResponse,
  type PatchApiV1InferenceDatapointsByInferenceDatapointIdResponses,
  type PatchApiV1JudgesByJudgeIdData,
  type PatchApiV1JudgesByJudgeIdError,
  type PatchApiV1JudgesByJudgeIdErrors,
  type PatchApiV1JudgesByJudgeIdResponse,
  type PatchApiV1JudgesByJudgeIdResponses,
  type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdData,
  type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdError,
  type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdErrors,
  type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponse,
  type PatchApiV1KanonicalDatapointsByKanonicalDatapointIdResponses,
  type PatchApiV1KbsByKbIdArticlesByArticleIdData,
  type PatchApiV1KbsByKbIdArticlesByArticleIdError,
  type PatchApiV1KbsByKbIdArticlesByArticleIdErrors,
  type PatchApiV1KbsByKbIdArticlesByArticleIdResponse,
  type PatchApiV1KbsByKbIdArticlesByArticleIdResponses,
  type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdData,
  type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdError,
  type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdErrors,
  type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponse,
  type PatchApiV1KbSimulationDatapointsBySimulationDatapointIdResponses,
  type PatchApiV1KbSimulationResultsBySimulationResultIdData,
  type PatchApiV1KbSimulationResultsBySimulationResultIdError,
  type PatchApiV1KbSimulationResultsBySimulationResultIdErrors,
  type PatchApiV1KbSimulationResultsBySimulationResultIdResponse,
  type PatchApiV1KbSimulationResultsBySimulationResultIdResponses,
  type PatchApiV1MachineUsersByMachineUserIdData,
  type PatchApiV1MachineUsersByMachineUserIdError,
  type PatchApiV1MachineUsersByMachineUserIdErrors,
  type PatchApiV1MachineUsersByMachineUserIdResponse,
  type PatchApiV1MachineUsersByMachineUserIdResponses,
  type PatchApiV1OauthApplicationsByOauthApplicationIdData,
  type PatchApiV1OauthApplicationsByOauthApplicationIdError,
  type PatchApiV1OauthApplicationsByOauthApplicationIdErrors,
  type PatchApiV1OauthApplicationsByOauthApplicationIdResponse,
  type PatchApiV1OauthApplicationsByOauthApplicationIdResponses,
  type PatchApiV1ReposByRepositoryIdBranchesByNameData,
  type PatchApiV1ReposByRepositoryIdBranchesByNameError,
  type PatchApiV1ReposByRepositoryIdBranchesByNameErrors,
  type PatchApiV1ReposByRepositoryIdBranchesByNameResponse,
  type PatchApiV1ReposByRepositoryIdBranchesByNameResponses,
  type PatchApiV1ReposByRepositoryIdCommitByCommitIdData,
  type PatchApiV1ReposByRepositoryIdCommitByCommitIdError,
  type PatchApiV1ReposByRepositoryIdCommitByCommitIdErrors,
  type PatchApiV1ReposByRepositoryIdCommitByCommitIdResponse,
  type PatchApiV1ReposByRepositoryIdCommitByCommitIdResponses,
  type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdData,
  type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdError,
  type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdErrors,
  type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponse,
  type PatchApiV1ServiceNowTenantsByTenantIdArticlesBySysIdResponses,
  type PatchApiV1ServiceNowTenantsByTenantIdData,
  type PatchApiV1ServiceNowTenantsByTenantIdError,
  type PatchApiV1ServiceNowTenantsByTenantIdErrors,
  type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdData,
  type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdError,
  type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdErrors,
  type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponse,
  type PatchApiV1ServiceNowTenantsByTenantIdKnowledgeBasesBySysIdResponses,
  type PatchApiV1ServiceNowTenantsByTenantIdResponse,
  type PatchApiV1ServiceNowTenantsByTenantIdResponses,
  type PatchApiV1SesameEdraAccessData,
  type PatchApiV1SesameEdraAccessError,
  type PatchApiV1SesameEdraAccessErrors,
  type PatchApiV1SesameEdraAccessResponse,
  type PatchApiV1SesameEdraAccessResponses,
  type PatchApiV1UsersByUserIdNotificationSettingsData,
  type PatchApiV1UsersByUserIdNotificationSettingsError,
  type PatchApiV1UsersByUserIdNotificationSettingsErrors,
  type PatchApiV1UsersByUserIdNotificationSettingsResponse,
  type PatchApiV1UsersByUserIdNotificationSettingsResponses,
  type PatchApiV1UsersMeData,
  type PatchApiV1UsersMeError,
  type PatchApiV1UsersMeErrors,
  type PatchApiV1UsersMeResponse,
  type PatchApiV1UsersMeResponses,
  type PatchApiV1WorkflowRunsByWorkflowRunIdData,
  type PatchApiV1WorkflowRunsByWorkflowRunIdError,
  type PatchApiV1WorkflowRunsByWorkflowRunIdErrors,
  type PatchApiV1WorkflowRunsByWorkflowRunIdResponse,
  type PatchApiV1WorkflowRunsByWorkflowRunIdResponses,
  type PatchApiV1ZendeskTenantsByTenantIdData,
  type PatchApiV1ZendeskTenantsByTenantIdError,
  type PatchApiV1ZendeskTenantsByTenantIdErrors,
  type PatchApiV1ZendeskTenantsByTenantIdResponse,
  type PatchApiV1ZendeskTenantsByTenantIdResponses,
  type PatchApiV2JudgesByJudgeIdData,
  type PatchApiV2JudgesByJudgeIdError,
  type PatchApiV2JudgesByJudgeIdErrors,
  type PatchApiV2JudgesByJudgeIdResponse,
  type PatchApiV2JudgesByJudgeIdResponses,
  type PatchApiV2TasksByTaskIdData,
  type PatchApiV2TasksByTaskIdError,
  type PatchApiV2TasksByTaskIdErrors,
  type PatchApiV2TasksByTaskIdResponse,
  type PatchApiV2TasksByTaskIdResponses,
  type PatchApiV3DatapointsByDatapointIdData,
  type PatchApiV3DatapointsByDatapointIdError,
  type PatchApiV3DatapointsByDatapointIdErrors,
  type PatchApiV3DatapointsByDatapointIdResponse,
  type PatchApiV3DatapointsByDatapointIdResponses,
  type PatchApiV3DatapointsData,
  type PatchApiV3DatapointsError,
  type PatchApiV3DatapointsErrors,
  type PatchApiV3DatapointsResponse,
  type PatchApiV3DatapointsResponses,
  type PatchApiV3KbsByKbIdCrReviewSlaData,
  type PatchApiV3KbsByKbIdCrReviewSlaError,
  type PatchApiV3KbsByKbIdCrReviewSlaErrors,
  type PatchApiV3KbsByKbIdCrReviewSlaResponse,
  type PatchApiV3KbsByKbIdCrReviewSlaResponses,
  type PatchApiV3KbsByKbIdData,
  type PatchApiV3KbsByKbIdError,
  type PatchApiV3KbsByKbIdErrors,
  type PatchApiV3KbsByKbIdResponse,
  type PatchApiV3KbsByKbIdResponses,
  type PatchArticleRequestV1,
  type PatchCommitRequestV1,
  type PatchJudgeParamsV2,
  type PatchKnowledgeBaseParamsV3,
  type PatchKnowledgeBasePositionAfterV3,
  type PatchKnowledgeBaseReviewSlaParamsV3,
  type PatchSharepointTenantParamsV1,
  type PendingWorkflowRunV1,
  type PlainActorV1,
  type PlainAddCustomerToGroupsParamsV1,
  type PlainAddCustomerToPlainTenantsParamsV1,
  type PlainAddThreadLabelsParamsV1,
  type PlainAgentHandedOffV1,
  type PlainAgentHandledV1,
  type PlainAgentInProgressV1,
  type PlainApiCredentialsConfiguredV1,
  type PlainApiCredentialsNotConfiguredV1,
  type PlainApiCredentialsParamsV1,
  type PlainApiCredentialsV1,
  type PlainAssignmentTransitionedTimelineEntryV1,
  type PlainAssignThreadParamsV1,
  type PlainChangeThreadPriorityParamsV1,
  type PlainChatTimelineEntryV1,
  type PlainCheckConnectionResponseV1,
  type PlainCompanyV1,
  type PlainCreateNoteParamsV1,
  type PlainCreateThreadParamsV1,
  type PlainCustomerActorV1,
  type PlainCustomerGroupV1,
  type PlainCustomerTenantV1,
  type PlainCustomerV1,
  type PlainCustomTimelineEntryV1,
  type PlainDeletedCustomerActorV1,
  type PlainEmailTimelineEntryV1,
  type PlainIngestResponseV1,
  type PlainLabelsChangedTimelineEntryV1,
  type PlainLabelV1,
  type PlainMachineUserActorV1,
  PlainMessageSourceV1,
  type PlainNoteTimelineEntryV1,
  type PlainNoteV1,
  type PlainOtherTimelineEntryV1,
  PlainPermissionV1,
  type PlainRemoveThreadLabelsParamsV1,
  type PlainSendMessageParamsV1,
  type PlainSetCustomerCompanyParamsV1,
  type PlainSlaAchievedV1,
  type PlainSlaBreachedV1,
  type PlainSlaBreachingV1,
  type PlainSlaCancelledV1,
  type PlainSlaImminentBreachV1,
  type PlainSlaPendingV1,
  type PlainSlaStatusSummaryV1,
  type PlainSlaStatusV1,
  type PlainSnoozeThreadParamsV1,
  type PlainStatusTransitionedTimelineEntryV1,
  type PlainSurveyResponseV1,
  PlainSurveySentimentV1,
  type PlainSystemActorV1,
  type PlainTenantFullV1,
  type PlainTenantV1,
  type PlainThreadAgentStateV1,
  PlainThreadAgentStatusV1,
  PlainThreadChannelV1,
  type PlainThreadFieldBoolV1,
  type PlainThreadFieldCurrencyV1,
  type PlainThreadFieldDateV1,
  type PlainThreadFieldEnumV1,
  type PlainThreadFieldNumberV1,
  type PlainThreadFieldStringV1,
  type PlainThreadFieldV1,
  type PlainThreadFieldValueV1,
  type PlainThreadFullV1,
  type PlainThreadMachineUserAssigneeV1,
  type PlainThreadMessageInfoV1,
  PlainThreadStatusV1,
  type PlainThreadUserAssigneeV1,
  type PlainThreadV1,
  type PlainTierV1,
  type PlainTimelineEntryDetailV1,
  type PlainTimelineEntryV1,
  type PlainUpdateThreadAgentStatusParamsV1,
  type PlainUpsertCompanyParamsV1,
  type PlainUpsertCustomerParamsV1,
  type PlainUpsertPlainTenantParamsV1,
  type PlainUpsertThreadFieldParamsV1,
  type PlainUserActorV1,
  type PlainWebhookCredentialsConfiguredV1,
  type PlainWebhookCredentialsNotConfiguredV1,
  type PlainWebhookCredentialsParamsV1,
  type PlainWebhookCredentialsV1,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsData,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsError,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsErrors,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponse,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesByPageIdCommentsResponses,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesData,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesError,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesErrors,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesResponse,
  type PostApiConfluenceV1TenantsByTenantIdActionsPagesResponses,
  type PostApiConfluenceV1TenantsByTenantIdCallbackData,
  type PostApiConfluenceV1TenantsByTenantIdCallbackError,
  type PostApiConfluenceV1TenantsByTenantIdCallbackErrors,
  type PostApiConfluenceV1TenantsByTenantIdCallbackResponse,
  type PostApiConfluenceV1TenantsByTenantIdCallbackResponses,
  type PostApiConfluenceV1TenantsByTenantIdConnectData,
  type PostApiConfluenceV1TenantsByTenantIdConnectError,
  type PostApiConfluenceV1TenantsByTenantIdConnectErrors,
  type PostApiConfluenceV1TenantsByTenantIdConnectResponse,
  type PostApiConfluenceV1TenantsByTenantIdConnectResponses,
  type PostApiConfluenceV1TenantsData,
  type PostApiConfluenceV1TenantsError,
  type PostApiConfluenceV1TenantsErrors,
  type PostApiConfluenceV1TenantsResponse,
  type PostApiConfluenceV1TenantsResponses,
  type PostApiDebugV1BackgroundTaskErrorData,
  type PostApiDebugV1BackgroundTaskErrorResponse,
  type PostApiDebugV1BackgroundTaskErrorResponses,
  type PostApiDebugV1OpenfgaCheckData,
  type PostApiDebugV1OpenfgaCheckError,
  type PostApiDebugV1OpenfgaCheckErrors,
  type PostApiDebugV1OpenfgaCheckResponse,
  type PostApiDebugV1OpenfgaCheckResponses,
  type PostApiDebugV1OpenfgaReadTuplesData,
  type PostApiDebugV1OpenfgaReadTuplesError,
  type PostApiDebugV1OpenfgaReadTuplesErrors,
  type PostApiDebugV1OpenfgaReadTuplesResponse,
  type PostApiDebugV1OpenfgaReadTuplesResponses,
  type PostApiDebugV1OpenfgaWriteTuplesData,
  type PostApiDebugV1OpenfgaWriteTuplesError,
  type PostApiDebugV1OpenfgaWriteTuplesErrors,
  type PostApiDebugV1OpenfgaWriteTuplesResponse,
  type PostApiDebugV1OpenfgaWriteTuplesResponses,
  type PostApiDebugV1SearchReindexData,
  type PostApiDebugV1SearchReindexError,
  type PostApiDebugV1SearchReindexErrors,
  type PostApiDebugV1SearchReindexResponse,
  type PostApiDebugV1SearchReindexResponses,
  type PostApiEntraV1TenantsByTenantIdActionsResolveCallerData,
  type PostApiEntraV1TenantsByTenantIdActionsResolveCallerError,
  type PostApiEntraV1TenantsByTenantIdActionsResolveCallerErrors,
  type PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponse,
  type PostApiEntraV1TenantsByTenantIdActionsResolveCallerResponses,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveData,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveError,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveErrors,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponse,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdApproveResponses,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectData,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectError,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectErrors,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponse,
  type PostApiEntraV1TenantsByTenantIdProposedActionsByActionIdRejectResponses,
  type PostApiEntraV1TenantsByTenantIdProposedActionsData,
  type PostApiEntraV1TenantsByTenantIdProposedActionsError,
  type PostApiEntraV1TenantsByTenantIdProposedActionsErrors,
  type PostApiEntraV1TenantsByTenantIdProposedActionsResponse,
  type PostApiEntraV1TenantsByTenantIdProposedActionsResponses,
  type PostApiEntraV1TenantsData,
  type PostApiEntraV1TenantsError,
  type PostApiEntraV1TenantsErrors,
  type PostApiEntraV1TenantsResponse,
  type PostApiEntraV1TenantsResponses,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesData,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesError,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesErrors,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponse,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsArticlesResponses,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersData,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersError,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersErrors,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponse,
  type PostApiFreshserviceV1TenantsByTenantIdActionsSolutionsFoldersResponses,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesData,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesError,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesErrors,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponse,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdNotesResponses,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyData,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyError,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyErrors,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponse,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsByTicketIdReplyResponses,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsData,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsError,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsErrors,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponse,
  type PostApiFreshserviceV1TenantsByTenantIdActionsTicketsResponses,
  type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookData,
  type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookError,
  type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookErrors,
  type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponse,
  type PostApiFreshserviceV1TenantsByTenantIdProvisionWebhookResponses,
  type PostApiFreshserviceV1TenantsData,
  type PostApiFreshserviceV1TenantsError,
  type PostApiFreshserviceV1TenantsErrors,
  type PostApiFreshserviceV1TenantsResponse,
  type PostApiFreshserviceV1TenantsResponses,
  type PostApiHubspotV1ActionsCreateThreadOnTicketData,
  type PostApiHubspotV1ActionsCreateThreadOnTicketError,
  type PostApiHubspotV1ActionsCreateThreadOnTicketErrors,
  type PostApiHubspotV1ActionsCreateThreadOnTicketResponse,
  type PostApiHubspotV1ActionsCreateThreadOnTicketResponses,
  type PostApiHubspotV1ActionsReplyToThreadData,
  type PostApiHubspotV1ActionsReplyToThreadError,
  type PostApiHubspotV1ActionsReplyToThreadErrors,
  type PostApiHubspotV1ActionsReplyToThreadResponse,
  type PostApiHubspotV1ActionsReplyToThreadResponses,
  type PostApiHubspotV1ActionsUpdateNoteData,
  type PostApiHubspotV1ActionsUpdateNoteError,
  type PostApiHubspotV1ActionsUpdateNoteErrors,
  type PostApiHubspotV1ActionsUpdateNoteResponse,
  type PostApiHubspotV1ActionsUpdateNoteResponses,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerData,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerError,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerErrors,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponse,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketOwnerResponses,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusData,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusError,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusErrors,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponse,
  type PostApiHubspotV1TenantsByTenantIdActionsSetTicketStatusResponses,
  type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesData,
  type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesError,
  type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesErrors,
  type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponse,
  type PostApiHubspotV1TenantsByTenantIdActionsUpdateTicketPropertiesResponses,
  type PostApiHubspotV2TenantsByTenantIdActionsAddNoteData,
  type PostApiHubspotV2TenantsByTenantIdActionsAddNoteError,
  type PostApiHubspotV2TenantsByTenantIdActionsAddNoteErrors,
  type PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponse,
  type PostApiHubspotV2TenantsByTenantIdActionsAddNoteResponses,
  type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldData,
  type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldError,
  type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldErrors,
  type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponse,
  type PostApiJiraV1TenantsByTenantIdActionsSetCustomFieldResponses,
  type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsData,
  type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsError,
  type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsErrors,
  type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponse,
  type PostApiJiraV1TenantsByTenantIdActionsUpdateIssueLabelsResponses,
  type PostApiJiraV1TenantsData,
  type PostApiJiraV1TenantsError,
  type PostApiJiraV1TenantsErrors,
  type PostApiJiraV1TenantsResponse,
  type PostApiJiraV1TenantsResponses,
  type PostApiJiraV2TenantsByTenantIdActionsPostCommentData,
  type PostApiJiraV2TenantsByTenantIdActionsPostCommentError,
  type PostApiJiraV2TenantsByTenantIdActionsPostCommentErrors,
  type PostApiJiraV2TenantsByTenantIdActionsPostCommentResponse,
  type PostApiJiraV2TenantsByTenantIdActionsPostCommentResponses,
  type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryData,
  type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryError,
  type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryErrors,
  type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponse,
  type PostApiNotionV1TenantsByTenantIdActionsDatabasesByDatabaseIdQueryResponses,
  type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksData,
  type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksError,
  type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksErrors,
  type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponse,
  type PostApiNotionV1TenantsByTenantIdActionsPagesByPageIdBlocksResponses,
  type PostApiNotionV1TenantsByTenantIdActionsPagesData,
  type PostApiNotionV1TenantsByTenantIdActionsPagesError,
  type PostApiNotionV1TenantsByTenantIdActionsPagesErrors,
  type PostApiNotionV1TenantsByTenantIdActionsPagesResponse,
  type PostApiNotionV1TenantsByTenantIdActionsPagesResponses,
  type PostApiNotionV1TenantsByTenantIdCallbackData,
  type PostApiNotionV1TenantsByTenantIdCallbackError,
  type PostApiNotionV1TenantsByTenantIdCallbackErrors,
  type PostApiNotionV1TenantsByTenantIdCallbackResponse,
  type PostApiNotionV1TenantsByTenantIdCallbackResponses,
  type PostApiNotionV1TenantsByTenantIdConnectData,
  type PostApiNotionV1TenantsByTenantIdConnectError,
  type PostApiNotionV1TenantsByTenantIdConnectErrors,
  type PostApiNotionV1TenantsByTenantIdConnectResponse,
  type PostApiNotionV1TenantsByTenantIdConnectResponses,
  type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenData,
  type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenError,
  type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenErrors,
  type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponse,
  type PostApiNotionV1TenantsByTenantIdRevealWebhookTokenResponses,
  type PostApiNotionV1TenantsData,
  type PostApiNotionV1TenantsError,
  type PostApiNotionV1TenantsErrors,
  type PostApiNotionV1TenantsResponse,
  type PostApiNotionV1TenantsResponses,
  type PostApiOutlookV1ActionsAddEmailAttachmentData,
  type PostApiOutlookV1ActionsAddEmailAttachmentError,
  type PostApiOutlookV1ActionsAddEmailAttachmentErrors,
  type PostApiOutlookV1ActionsAddEmailAttachmentResponse,
  type PostApiOutlookV1ActionsAddEmailAttachmentResponses,
  type PostApiOutlookV1ActionsCopyEmailData,
  type PostApiOutlookV1ActionsCopyEmailError,
  type PostApiOutlookV1ActionsCopyEmailErrors,
  type PostApiOutlookV1ActionsCopyEmailResponse,
  type PostApiOutlookV1ActionsCopyEmailResponses,
  type PostApiOutlookV1ActionsCreateDraftData,
  type PostApiOutlookV1ActionsCreateDraftError,
  type PostApiOutlookV1ActionsCreateDraftErrors,
  type PostApiOutlookV1ActionsCreateDraftResponse,
  type PostApiOutlookV1ActionsCreateDraftResponses,
  type PostApiOutlookV1ActionsDeleteEmailData,
  type PostApiOutlookV1ActionsDeleteEmailError,
  type PostApiOutlookV1ActionsDeleteEmailErrors,
  type PostApiOutlookV1ActionsDeleteEmailResponse,
  type PostApiOutlookV1ActionsDeleteEmailResponses,
  type PostApiOutlookV1ActionsForwardEmailData,
  type PostApiOutlookV1ActionsForwardEmailError,
  type PostApiOutlookV1ActionsForwardEmailErrors,
  type PostApiOutlookV1ActionsForwardEmailResponse,
  type PostApiOutlookV1ActionsForwardEmailResponses,
  type PostApiOutlookV1ActionsGetEmailAttachmentData,
  type PostApiOutlookV1ActionsGetEmailAttachmentError,
  type PostApiOutlookV1ActionsGetEmailAttachmentErrors,
  type PostApiOutlookV1ActionsGetEmailAttachmentResponse,
  type PostApiOutlookV1ActionsGetEmailAttachmentResponses,
  type PostApiOutlookV1ActionsMarkEmailReadData,
  type PostApiOutlookV1ActionsMarkEmailReadError,
  type PostApiOutlookV1ActionsMarkEmailReadErrors,
  type PostApiOutlookV1ActionsMarkEmailReadResponse,
  type PostApiOutlookV1ActionsMarkEmailReadResponses,
  type PostApiOutlookV1ActionsMoveEmailData,
  type PostApiOutlookV1ActionsMoveEmailError,
  type PostApiOutlookV1ActionsMoveEmailErrors,
  type PostApiOutlookV1ActionsMoveEmailResponse,
  type PostApiOutlookV1ActionsMoveEmailResponses,
  type PostApiOutlookV1ActionsRemoveEmailAttachmentData,
  type PostApiOutlookV1ActionsRemoveEmailAttachmentError,
  type PostApiOutlookV1ActionsRemoveEmailAttachmentErrors,
  type PostApiOutlookV1ActionsRemoveEmailAttachmentResponse,
  type PostApiOutlookV1ActionsRemoveEmailAttachmentResponses,
  type PostApiOutlookV1ActionsReplyEmailData,
  type PostApiOutlookV1ActionsReplyEmailError,
  type PostApiOutlookV1ActionsReplyEmailErrors,
  type PostApiOutlookV1ActionsReplyEmailResponse,
  type PostApiOutlookV1ActionsReplyEmailResponses,
  type PostApiOutlookV1ActionsSendEmailData,
  type PostApiOutlookV1ActionsSendEmailError,
  type PostApiOutlookV1ActionsSendEmailErrors,
  type PostApiOutlookV1ActionsSendEmailResponse,
  type PostApiOutlookV1ActionsSendEmailResponses,
  type PostApiOutlookV1ActionsSetEmailCategoriesData,
  type PostApiOutlookV1ActionsSetEmailCategoriesError,
  type PostApiOutlookV1ActionsSetEmailCategoriesErrors,
  type PostApiOutlookV1ActionsSetEmailCategoriesResponse,
  type PostApiOutlookV1ActionsSetEmailCategoriesResponses,
  type PostApiOutlookV1ActionsSetEmailFlagData,
  type PostApiOutlookV1ActionsSetEmailFlagError,
  type PostApiOutlookV1ActionsSetEmailFlagErrors,
  type PostApiOutlookV1ActionsSetEmailFlagResponse,
  type PostApiOutlookV1ActionsSetEmailFlagResponses,
  type PostApiOutlookV1ActionsSetEmailImportanceData,
  type PostApiOutlookV1ActionsSetEmailImportanceError,
  type PostApiOutlookV1ActionsSetEmailImportanceErrors,
  type PostApiOutlookV1ActionsSetEmailImportanceResponse,
  type PostApiOutlookV1ActionsSetEmailImportanceResponses,
  type PostApiOutlookV2SubscriptionsData,
  type PostApiOutlookV2SubscriptionsError,
  type PostApiOutlookV2SubscriptionsErrors,
  type PostApiOutlookV2SubscriptionsResponse,
  type PostApiOutlookV2SubscriptionsResponses,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsData,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsError,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsErrors,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponse,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdGroupsResponses,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsData,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsError,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsErrors,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponse,
  type PostApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdPlainTenantsResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdDoneResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsDeleteResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdLabelsResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdMessagesResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdNotesResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdSnoozeResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdTodoResponses,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsData,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsError,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsErrors,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsResponse,
  type PostApiPlainV1TenantsByTenantIdActionsThreadsResponses,
  type PostApiPlainV1TenantsData,
  type PostApiPlainV1TenantsError,
  type PostApiPlainV1TenantsErrors,
  type PostApiPlainV1TenantsResponse,
  type PostApiPlainV1TenantsResponses,
  type PostApiPublicFreshserviceV1WebhooksByTenantIdData,
  type PostApiPublicFreshserviceV1WebhooksByTenantIdError,
  type PostApiPublicFreshserviceV1WebhooksByTenantIdErrors,
  type PostApiPublicFreshserviceV1WebhooksByTenantIdResponse,
  type PostApiPublicFreshserviceV1WebhooksByTenantIdResponses,
  type PostApiPublicHubspotV1EventsByTenantIdData,
  type PostApiPublicHubspotV1EventsByTenantIdError,
  type PostApiPublicHubspotV1EventsByTenantIdErrors,
  type PostApiPublicHubspotV1EventsByTenantIdResponse,
  type PostApiPublicHubspotV1EventsByTenantIdResponses,
  type PostApiPublicJiraV1EventsData,
  type PostApiPublicJiraV1EventsResponse,
  type PostApiPublicJiraV1EventsResponses,
  type PostApiPublicNotionV1WebhooksIngestByTenantIdData,
  type PostApiPublicNotionV1WebhooksIngestByTenantIdError,
  type PostApiPublicNotionV1WebhooksIngestByTenantIdErrors,
  type PostApiPublicNotionV1WebhooksIngestByTenantIdResponse,
  type PostApiPublicNotionV1WebhooksIngestByTenantIdResponses,
  type PostApiPublicOauthV1ByOauthApplicationIdIntrospectData,
  type PostApiPublicOauthV1ByOauthApplicationIdIntrospectError,
  type PostApiPublicOauthV1ByOauthApplicationIdIntrospectErrors,
  type PostApiPublicOauthV1ByOauthApplicationIdIntrospectResponses,
  type PostApiPublicOauthV1ByOauthApplicationIdTokenData,
  type PostApiPublicOauthV1ByOauthApplicationIdTokenError,
  type PostApiPublicOauthV1ByOauthApplicationIdTokenErrors,
  type PostApiPublicOauthV1ByOauthApplicationIdTokenResponses,
  type PostApiPublicOauthV1TokenData,
  type PostApiPublicOauthV1TokenResponses,
  type PostApiPublicOutlookV2SubscriptionsEventsData,
  type PostApiPublicOutlookV2SubscriptionsEventsError,
  type PostApiPublicOutlookV2SubscriptionsEventsErrors,
  type PostApiPublicOutlookV2SubscriptionsEventsResponses,
  type PostApiPublicOutlookV2SubscriptionsLifecycleData,
  type PostApiPublicOutlookV2SubscriptionsLifecycleError,
  type PostApiPublicOutlookV2SubscriptionsLifecycleErrors,
  type PostApiPublicOutlookV2SubscriptionsLifecycleResponses,
  type PostApiPublicPlainV1WebhooksIngestByTenantIdData,
  type PostApiPublicPlainV1WebhooksIngestByTenantIdError,
  type PostApiPublicPlainV1WebhooksIngestByTenantIdErrors,
  type PostApiPublicPlainV1WebhooksIngestByTenantIdResponse,
  type PostApiPublicPlainV1WebhooksIngestByTenantIdResponses,
  type PostApiPublicServiceNowV1WebhooksData,
  type PostApiPublicServiceNowV1WebhooksError,
  type PostApiPublicServiceNowV1WebhooksErrors,
  type PostApiPublicServiceNowV1WebhooksResponse,
  type PostApiPublicServiceNowV1WebhooksResponses,
  type PostApiPublicSharepointV1LifecycleByTenantIdData,
  type PostApiPublicSharepointV1LifecycleByTenantIdError,
  type PostApiPublicSharepointV1LifecycleByTenantIdErrors,
  type PostApiPublicSharepointV1LifecycleByTenantIdResponses,
  type PostApiPublicSharepointV1NotificationsByTenantIdData,
  type PostApiPublicSharepointV1NotificationsByTenantIdError,
  type PostApiPublicSharepointV1NotificationsByTenantIdErrors,
  type PostApiPublicSharepointV1NotificationsByTenantIdResponses,
  type PostApiPublicSlackV2TenantsByTenantIdEventsData,
  type PostApiPublicSlackV2TenantsByTenantIdEventsError,
  type PostApiPublicSlackV2TenantsByTenantIdEventsErrors,
  type PostApiPublicSlackV2TenantsByTenantIdEventsResponse,
  type PostApiPublicSlackV2TenantsByTenantIdEventsResponses,
  type PostApiPublicSlackV2TenantsByTenantIdInteractivityData,
  type PostApiPublicSlackV2TenantsByTenantIdInteractivityError,
  type PostApiPublicSlackV2TenantsByTenantIdInteractivityErrors,
  type PostApiPublicSlackV2TenantsByTenantIdInteractivityResponse,
  type PostApiPublicSlackV2TenantsByTenantIdInteractivityResponses,
  type PostApiPublicV1SalesforceOauthTokenByTenantIdData,
  type PostApiPublicV1SalesforceOauthTokenByTenantIdError,
  type PostApiPublicV1SalesforceOauthTokenByTenantIdErrors,
  type PostApiPublicV1SalesforceOauthTokenByTenantIdResponse,
  type PostApiPublicV1SalesforceOauthTokenByTenantIdResponses,
  type PostApiPublicV1SalesforceWebhooksIngestByTenantIdData,
  type PostApiPublicV1SalesforceWebhooksIngestByTenantIdError,
  type PostApiPublicV1SalesforceWebhooksIngestByTenantIdErrors,
  type PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponse,
  type PostApiPublicV1SalesforceWebhooksIngestByTenantIdResponses,
  type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesData,
  type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesError,
  type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesErrors,
  type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponse,
  type PostApiPublicV1TeamsTenantsByTenantIdWebhooksMessagesResponses,
  type PostApiPublicV1ZendeskWebhooksIngestByTenantIdData,
  type PostApiPublicV1ZendeskWebhooksIngestByTenantIdError,
  type PostApiPublicV1ZendeskWebhooksIngestByTenantIdErrors,
  type PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponse,
  type PostApiPublicV1ZendeskWebhooksIngestByTenantIdResponses,
  type PostApiSalesforceV1TenantsByTenantIdActionsArticlesData,
  type PostApiSalesforceV1TenantsByTenantIdActionsArticlesError,
  type PostApiSalesforceV1TenantsByTenantIdActionsArticlesErrors,
  type PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponse,
  type PostApiSalesforceV1TenantsByTenantIdActionsArticlesResponses,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsData,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsError,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsErrors,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponse,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdCommentsResponses,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsData,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsError,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsErrors,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponse,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailDraftsResponses,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsData,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsError,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsErrors,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponse,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesByCaseIdEmailsResponses,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesData,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesError,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesErrors,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesResponse,
  type PostApiSalesforceV1TenantsByTenantIdActionsCasesResponses,
  type PostApiSalesforceV1TenantsByTenantIdCallbackData,
  type PostApiSalesforceV1TenantsByTenantIdCallbackError,
  type PostApiSalesforceV1TenantsByTenantIdCallbackErrors,
  type PostApiSalesforceV1TenantsByTenantIdCallbackResponse,
  type PostApiSalesforceV1TenantsByTenantIdCallbackResponses,
  type PostApiSalesforceV1TenantsByTenantIdConnectData,
  type PostApiSalesforceV1TenantsByTenantIdConnectError,
  type PostApiSalesforceV1TenantsByTenantIdConnectErrors,
  type PostApiSalesforceV1TenantsByTenantIdConnectResponse,
  type PostApiSalesforceV1TenantsByTenantIdConnectResponses,
  type PostApiSalesforceV1TenantsData,
  type PostApiSalesforceV1TenantsError,
  type PostApiSalesforceV1TenantsErrors,
  type PostApiSalesforceV1TenantsResponse,
  type PostApiSalesforceV1TenantsResponses,
  type PostApiSecretsVaultV1SecretsBySecretIdRestoreData,
  type PostApiSecretsVaultV1SecretsBySecretIdRestoreError,
  type PostApiSecretsVaultV1SecretsBySecretIdRestoreErrors,
  type PostApiSecretsVaultV1SecretsBySecretIdRestoreResponse,
  type PostApiSecretsVaultV1SecretsBySecretIdRestoreResponses,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreData,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreError,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreErrors,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponse,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsByVersionIdRestoreResponses,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsData,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsError,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsErrors,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsResponse,
  type PostApiSecretsVaultV1SecretsBySecretIdVersionsResponses,
  type PostApiSecretsVaultV1SecretsData,
  type PostApiSecretsVaultV1SecretsError,
  type PostApiSecretsVaultV1SecretsErrors,
  type PostApiSecretsVaultV1SecretsResponse,
  type PostApiSecretsVaultV1SecretsResponses,
  type PostApiSecretsVaultV2SecretsBySecretIdVersionsData,
  type PostApiSecretsVaultV2SecretsBySecretIdVersionsError,
  type PostApiSecretsVaultV2SecretsBySecretIdVersionsErrors,
  type PostApiSecretsVaultV2SecretsBySecretIdVersionsResponse,
  type PostApiSecretsVaultV2SecretsBySecretIdVersionsResponses,
  type PostApiSecretsVaultV2SecretsData,
  type PostApiSecretsVaultV2SecretsError,
  type PostApiSecretsVaultV2SecretsErrors,
  type PostApiSecretsVaultV2SecretsResponse,
  type PostApiSecretsVaultV2SecretsResponses,
  type PostApiServiceNowV1ActionsChangeAssignmentGroupData,
  type PostApiServiceNowV1ActionsChangeAssignmentGroupError,
  type PostApiServiceNowV1ActionsChangeAssignmentGroupErrors,
  type PostApiServiceNowV1ActionsChangeAssignmentGroupResponse,
  type PostApiServiceNowV1ActionsChangeAssignmentGroupResponses,
  type PostApiServiceNowV1ActionsChangeIncidentStateData,
  type PostApiServiceNowV1ActionsChangeIncidentStateError,
  type PostApiServiceNowV1ActionsChangeIncidentStateErrors,
  type PostApiServiceNowV1ActionsChangeIncidentStateResponse,
  type PostApiServiceNowV1ActionsChangeIncidentStateResponses,
  type PostApiServiceNowV1ActionsReplyData,
  type PostApiServiceNowV1ActionsReplyError,
  type PostApiServiceNowV1ActionsReplyErrors,
  type PostApiServiceNowV1ActionsReplyResponse,
  type PostApiServiceNowV1ActionsReplyResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentData,
  type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentError,
  type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsAddRecordAttachmentResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsData,
  type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsError,
  type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsAggregateRecordsResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsBatchData,
  type PostApiServiceNowV1TenantsByTenantIdActionsBatchError,
  type PostApiServiceNowV1TenantsByTenantIdActionsBatchErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsBatchResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsBatchResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksData,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksError,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesByChangeIdTasksResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesData,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesError,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsChangesResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideData,
  type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideError,
  type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsCheckoutOrderGuideResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentData,
  type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentError,
  type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsDeleteStagedCatalogAttachmentResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartData,
  type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartError,
  type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsEmptyCartResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideData,
  type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideError,
  type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsEvaluateOrderGuideResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsRecordsData,
  type PostApiServiceNowV1TenantsByTenantIdActionsRecordsError,
  type PostApiServiceNowV1TenantsByTenantIdActionsRecordsErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsRecordsResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsData,
  type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsError,
  type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsSearchRecordsResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentData,
  type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentError,
  type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsStageCatalogAttachmentResponses,
  type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerData,
  type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerError,
  type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerErrors,
  type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponse,
  type PostApiServiceNowV1TenantsByTenantIdActionsSubmitRecordProducerResponses,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionData,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionError,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionErrors,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponse,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByFolderIdChildrenUploadSessionResponses,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlData,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlError,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlErrors,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponse,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdDownloadUrlResponses,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionData,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionError,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionErrors,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponse,
  type PostApiSharepointV1TenantsByTenantIdActionsDrivesByDriveIdItemsByItemIdUploadSessionResponses,
  type PostApiSharepointV1TenantsByTenantIdCallbackData,
  type PostApiSharepointV1TenantsByTenantIdCallbackError,
  type PostApiSharepointV1TenantsByTenantIdCallbackErrors,
  type PostApiSharepointV1TenantsByTenantIdCallbackResponse,
  type PostApiSharepointV1TenantsByTenantIdCallbackResponses,
  type PostApiSharepointV1TenantsByTenantIdConnectData,
  type PostApiSharepointV1TenantsByTenantIdConnectError,
  type PostApiSharepointV1TenantsByTenantIdConnectErrors,
  type PostApiSharepointV1TenantsByTenantIdConnectResponse,
  type PostApiSharepointV1TenantsByTenantIdConnectResponses,
  type PostApiSharepointV1TenantsByTenantIdFolderScopesData,
  type PostApiSharepointV1TenantsByTenantIdFolderScopesError,
  type PostApiSharepointV1TenantsByTenantIdFolderScopesErrors,
  type PostApiSharepointV1TenantsByTenantIdFolderScopesResponse,
  type PostApiSharepointV1TenantsByTenantIdFolderScopesResponses,
  type PostApiSharepointV1TenantsByTenantIdSitesData,
  type PostApiSharepointV1TenantsByTenantIdSitesError,
  type PostApiSharepointV1TenantsByTenantIdSitesErrors,
  type PostApiSharepointV1TenantsByTenantIdSitesGrantData,
  type PostApiSharepointV1TenantsByTenantIdSitesGrantError,
  type PostApiSharepointV1TenantsByTenantIdSitesGrantErrors,
  type PostApiSharepointV1TenantsByTenantIdSitesGrantResponse,
  type PostApiSharepointV1TenantsByTenantIdSitesGrantResponses,
  type PostApiSharepointV1TenantsByTenantIdSitesResponse,
  type PostApiSharepointV1TenantsByTenantIdSitesResponses,
  type PostApiSharepointV1TenantsData,
  type PostApiSharepointV1TenantsError,
  type PostApiSharepointV1TenantsErrors,
  type PostApiSharepointV1TenantsResponse,
  type PostApiSharepointV1TenantsResponses,
  type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleData,
  type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleError,
  type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleErrors,
  type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponse,
  type PostApiSlackV1TenantsByTenantIdActionsSetAssistantTitleResponses,
  type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsData,
  type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsError,
  type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsErrors,
  type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponse,
  type PostApiSlackV1TenantsByTenantIdActionsSetSuggestedPromptsResponses,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupData,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupError,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupErrors,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponse,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupResponses,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersData,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersError,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersErrors,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponse,
  type PostApiSlackV1TenantsByTenantIdActionsUpdateUserGroupUsersResponses,
  type PostApiSlackV1TenantsByTenantIdActionsViewsOpenData,
  type PostApiSlackV1TenantsByTenantIdActionsViewsOpenError,
  type PostApiSlackV1TenantsByTenantIdActionsViewsOpenErrors,
  type PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponse,
  type PostApiSlackV1TenantsByTenantIdActionsViewsOpenResponses,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeData,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeError,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeErrors,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponse,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPublishHomeResponses,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPushData,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPushError,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPushErrors,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPushResponse,
  type PostApiSlackV1TenantsByTenantIdActionsViewsPushResponses,
  type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateData,
  type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateError,
  type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateErrors,
  type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponse,
  type PostApiSlackV1TenantsByTenantIdActionsViewsUpdateResponses,
  type PostApiSlackV1TenantsByTenantIdCallbackData,
  type PostApiSlackV1TenantsByTenantIdCallbackError,
  type PostApiSlackV1TenantsByTenantIdCallbackErrors,
  type PostApiSlackV1TenantsByTenantIdCallbackResponse,
  type PostApiSlackV1TenantsByTenantIdCallbackResponses,
  type PostApiSlackV1TenantsByTenantIdConnectData,
  type PostApiSlackV1TenantsByTenantIdConnectError,
  type PostApiSlackV1TenantsByTenantIdConnectErrors,
  type PostApiSlackV1TenantsByTenantIdConnectResponse,
  type PostApiSlackV1TenantsByTenantIdConnectResponses,
  type PostApiSlackV1TenantsData,
  type PostApiSlackV1TenantsError,
  type PostApiSlackV1TenantsErrors,
  type PostApiSlackV1TenantsResponse,
  type PostApiSlackV1TenantsResponses,
  type PostApiSlackV2TenantsByTenantIdActionsAddReactionData,
  type PostApiSlackV2TenantsByTenantIdActionsAddReactionError,
  type PostApiSlackV2TenantsByTenantIdActionsAddReactionErrors,
  type PostApiSlackV2TenantsByTenantIdActionsAddReactionResponse,
  type PostApiSlackV2TenantsByTenantIdActionsAddReactionResponses,
  type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadData,
  type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadError,
  type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadErrors,
  type PostApiSlackV2TenantsByTenantIdActionsFilesByFileIdDownloadResponses,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentData,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentError,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentErrors,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponse,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadContentResponses,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadData,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadError,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadErrors,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponse,
  type PostApiSlackV2TenantsByTenantIdActionsFilesUploadResponses,
  type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageData,
  type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageError,
  type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageErrors,
  type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponse,
  type PostApiSlackV2TenantsByTenantIdActionsPostChatMessageResponses,
  type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusData,
  type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusError,
  type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusErrors,
  type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponse,
  type PostApiSlackV2TenantsByTenantIdActionsSetAssistantStatusResponses,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionData,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionError,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionErrors,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponse,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelDescriptionResponses,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicData,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicError,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicErrors,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponse,
  type PostApiSlackV2TenantsByTenantIdActionsSetChannelTopicResponses,
  type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageData,
  type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageError,
  type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageErrors,
  type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponse,
  type PostApiSlackV2TenantsByTenantIdActionsUpdateChatMessageResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionData,
  type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionError,
  type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsCheckConnectionResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListData,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListError,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsActivitiesListResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetData,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetError,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersGetResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListData,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListError,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsConversationsMembersListResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadData,
  type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadError,
  type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsFilesDownloadResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteData,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteError,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesDeleteResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostData,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostError,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesPostResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveData,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveError,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesSendProactiveResponses,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateData,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateError,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateErrors,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponse,
  type PostApiTeamsV1TenantsByTenantIdActionsMessagesUpdateResponses,
  type PostApiTeamsV1TenantsByTenantIdIconsData,
  type PostApiTeamsV1TenantsByTenantIdIconsError,
  type PostApiTeamsV1TenantsByTenantIdIconsErrors,
  type PostApiTeamsV1TenantsByTenantIdIconsResponse,
  type PostApiTeamsV1TenantsByTenantIdIconsResponses,
  type PostApiTeamsV1TenantsData,
  type PostApiTeamsV1TenantsError,
  type PostApiTeamsV1TenantsErrors,
  type PostApiTeamsV1TenantsResponse,
  type PostApiTeamsV1TenantsResponses,
  type PostApiV1AgentSessionInferenceByAgentSessionIdData,
  type PostApiV1AgentSessionInferenceByAgentSessionIdError,
  type PostApiV1AgentSessionInferenceByAgentSessionIdErrors,
  type PostApiV1AgentSessionInferenceByAgentSessionIdResponse,
  type PostApiV1AgentSessionInferenceByAgentSessionIdResponses,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesData,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesError,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesErrors,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesResponse,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesResponses,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncData,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncError,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncErrors,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponse,
  type PostApiV1AgentSessionsByAgentSessionIdMessagesSyncResponses,
  type PostApiV1AgentSessionsByAgentSessionIdStopData,
  type PostApiV1AgentSessionsByAgentSessionIdStopError,
  type PostApiV1AgentSessionsByAgentSessionIdStopErrors,
  type PostApiV1AgentSessionsByAgentSessionIdStopResponse,
  type PostApiV1AgentSessionsByAgentSessionIdStopResponses,
  type PostApiV1AgentSessionsData,
  type PostApiV1AgentSessionsError,
  type PostApiV1AgentSessionsErrors,
  type PostApiV1AgentSessionsResponse,
  type PostApiV1AgentSessionsResponses,
  type PostApiV1ApiKeysData,
  type PostApiV1ApiKeysError,
  type PostApiV1ApiKeysErrors,
  type PostApiV1ApiKeysResponse,
  type PostApiV1ApiKeysResponses,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsData,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsError,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsErrors,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponse,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdCommentsResponses,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreData,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreError,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreErrors,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponse,
  type PostApiV1ArticleLineRangeCommentThreadsByThreadIdRestoreResponses,
  type PostApiV1ArticleLineRangeCommentThreadsData,
  type PostApiV1ArticleLineRangeCommentThreadsError,
  type PostApiV1ArticleLineRangeCommentThreadsErrors,
  type PostApiV1ArticleLineRangeCommentThreadsResponse,
  type PostApiV1ArticleLineRangeCommentThreadsResponses,
  type PostApiV1AttachmentsUploadUrlData,
  type PostApiV1AttachmentsUploadUrlError,
  type PostApiV1AttachmentsUploadUrlErrors,
  type PostApiV1AttachmentsUploadUrlResponse,
  type PostApiV1AttachmentsUploadUrlResponses,
  type PostApiV1AuthzKbOwnersSyncData,
  type PostApiV1AuthzKbOwnersSyncResponse,
  type PostApiV1AuthzKbOwnersSyncResponses,
  type PostApiV1AuthzOrganizationsByOrgIdInvitationsData,
  type PostApiV1AuthzOrganizationsByOrgIdInvitationsError,
  type PostApiV1AuthzOrganizationsByOrgIdInvitationsErrors,
  type PostApiV1AuthzOrganizationsByOrgIdInvitationsResponse,
  type PostApiV1AuthzOrganizationsByOrgIdInvitationsResponses,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveData,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveError,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveErrors,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponse,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsByRequestIdResolveResponses,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsData,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsError,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsErrors,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponse,
  type PostApiV1AuthzOrganizationsByOrgIdKbAccessRequestsResponses,
  type PostApiV1AuthzOrganizationsByOrgIdTeamsData,
  type PostApiV1AuthzOrganizationsByOrgIdTeamsError,
  type PostApiV1AuthzOrganizationsByOrgIdTeamsErrors,
  type PostApiV1AuthzOrganizationsByOrgIdTeamsResponse,
  type PostApiV1AuthzOrganizationsByOrgIdTeamsResponses,
  type PostApiV1AuthzSyncArticlesToOpenfgaData,
  type PostApiV1AuthzSyncArticlesToOpenfgaError,
  type PostApiV1AuthzSyncArticlesToOpenfgaErrors,
  type PostApiV1AuthzSyncArticlesToOpenfgaResponse,
  type PostApiV1AuthzSyncArticlesToOpenfgaResponses,
  type PostApiV1BrandingLogoUploadUrlData,
  type PostApiV1BrandingLogoUploadUrlError,
  type PostApiV1BrandingLogoUploadUrlErrors,
  type PostApiV1BrandingLogoUploadUrlResponse,
  type PostApiV1BrandingLogoUploadUrlResponses,
  type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreData,
  type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreError,
  type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreErrors,
  type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponse,
  type PostApiV1CalibrationFeedbackDimensionsByDimensionIdRestoreResponses,
  type PostApiV1CalibrationFeedbackDimensionsData,
  type PostApiV1CalibrationFeedbackDimensionsError,
  type PostApiV1CalibrationFeedbackDimensionsErrors,
  type PostApiV1CalibrationFeedbackDimensionsResponse,
  type PostApiV1CalibrationFeedbackDimensionsResponses,
  type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreData,
  type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreError,
  type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreErrors,
  type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponse,
  type PostApiV1CalibrationFeedbackInferenceDatapointsByInferenceDatapointIdRestoreResponses,
  type PostApiV1CalibrationFeedbackInferenceDatapointsData,
  type PostApiV1CalibrationFeedbackInferenceDatapointsError,
  type PostApiV1CalibrationFeedbackInferenceDatapointsErrors,
  type PostApiV1CalibrationFeedbackInferenceDatapointsResponse,
  type PostApiV1CalibrationFeedbackInferenceDatapointsResponses,
  type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreData,
  type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreError,
  type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreErrors,
  type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponse,
  type PostApiV1CalibrationFeedbackQueueItemsByQueueItemIdRestoreResponses,
  type PostApiV1CalibrationFeedbackQueueItemsData,
  type PostApiV1CalibrationFeedbackQueueItemsError,
  type PostApiV1CalibrationFeedbackQueueItemsErrors,
  type PostApiV1CalibrationFeedbackQueueItemsResponse,
  type PostApiV1CalibrationFeedbackQueueItemsResponses,
  type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreData,
  type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreError,
  type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreErrors,
  type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponse,
  type PostApiV1CalibrationFeedbackVerdictsByVerdictIdRestoreResponses,
  type PostApiV1CalibrationFeedbackVerdictsData,
  type PostApiV1CalibrationFeedbackVerdictsError,
  type PostApiV1CalibrationFeedbackVerdictsErrors,
  type PostApiV1CalibrationFeedbackVerdictsResponse,
  type PostApiV1CalibrationFeedbackVerdictsResponses,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsData,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsError,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsErrors,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponse,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdCommentsResponses,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreData,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreError,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreErrors,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponse,
  type PostApiV1ChangeRequestLineRangeCommentThreadsByThreadIdRestoreResponses,
  type PostApiV1ChangeRequestLineRangeCommentThreadsData,
  type PostApiV1ChangeRequestLineRangeCommentThreadsError,
  type PostApiV1ChangeRequestLineRangeCommentThreadsErrors,
  type PostApiV1ChangeRequestLineRangeCommentThreadsResponse,
  type PostApiV1ChangeRequestLineRangeCommentThreadsResponses,
  type PostApiV1ChangeRequestsByChangeRequestIdRestoreData,
  type PostApiV1ChangeRequestsByChangeRequestIdRestoreError,
  type PostApiV1ChangeRequestsByChangeRequestIdRestoreErrors,
  type PostApiV1ChangeRequestsByChangeRequestIdRestoreResponse,
  type PostApiV1ChangeRequestsByChangeRequestIdRestoreResponses,
  type PostApiV1ChangeRequestsData,
  type PostApiV1ChangeRequestsError,
  type PostApiV1ChangeRequestsErrors,
  type PostApiV1ChangeRequestsResponse,
  type PostApiV1ChangeRequestsResponses,
  type PostApiV1CommentsByCommentIdRestoreData,
  type PostApiV1CommentsByCommentIdRestoreError,
  type PostApiV1CommentsByCommentIdRestoreErrors,
  type PostApiV1CommentsByCommentIdRestoreResponse,
  type PostApiV1CommentsByCommentIdRestoreResponses,
  type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreData,
  type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreError,
  type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreErrors,
  type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponse,
  type PostApiV1DataDumpConversationsByDataDumpConversationIdRestoreResponses,
  type PostApiV1DataDumpConversationsData,
  type PostApiV1DataDumpConversationsError,
  type PostApiV1DataDumpConversationsErrors,
  type PostApiV1DataDumpConversationsResponse,
  type PostApiV1DataDumpConversationsResponses,
  type PostApiV1DatapointEvidenceSearchData,
  type PostApiV1DatapointEvidenceSearchError,
  type PostApiV1DatapointEvidenceSearchErrors,
  type PostApiV1DatapointEvidenceSearchResponse,
  type PostApiV1DatapointEvidenceSearchResponses,
  type PostApiV1DatapointsBackfillIndexData,
  type PostApiV1DatapointsBackfillIndexError,
  type PostApiV1DatapointsBackfillIndexErrors,
  type PostApiV1DatapointsBackfillIndexResponse,
  type PostApiV1DatapointsBackfillIndexResponses,
  type PostApiV1DatapointsEmbedData,
  type PostApiV1DatapointsEmbedError,
  type PostApiV1DatapointsEmbedErrors,
  type PostApiV1DatapointsEmbedResponse,
  type PostApiV1DatapointsEmbedResponses,
  type PostApiV1DatapointsRegexSearchData,
  type PostApiV1DatapointsRegexSearchError,
  type PostApiV1DatapointsRegexSearchErrors,
  type PostApiV1DatapointsRegexSearchResponse,
  type PostApiV1DatapointsRegexSearchResponses,
  type PostApiV1DatapointsSearchData,
  type PostApiV1DatapointsSearchError,
  type PostApiV1DatapointsSearchErrors,
  type PostApiV1DatapointsSearchResponse,
  type PostApiV1DatapointsSearchResponses,
  type PostApiV1ExternalInferencesData,
  type PostApiV1ExternalInferencesError,
  type PostApiV1ExternalInferencesErrors,
  type PostApiV1ExternalInferencesResponse,
  type PostApiV1ExternalInferencesResponses,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesData,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesError,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesErrors,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponse,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdMessagesResponses,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreData,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreError,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreErrors,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponse,
  type PostApiV1FinalizedConversationsByFinalizedConversationIdRestoreResponses,
  type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsData,
  type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsError,
  type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsErrors,
  type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponse,
  type PostApiV1FullEvaluatedInferenceDatapointsJudgementFilterOptionsResponses,
  type PostApiV1FullEvaluatedInferenceDatapointsSearchData,
  type PostApiV1FullEvaluatedInferenceDatapointsSearchError,
  type PostApiV1FullEvaluatedInferenceDatapointsSearchErrors,
  type PostApiV1FullEvaluatedInferenceDatapointsSearchResponse,
  type PostApiV1FullEvaluatedInferenceDatapointsSearchResponses,
  type PostApiV1HubspotTenantsData,
  type PostApiV1HubspotTenantsError,
  type PostApiV1HubspotTenantsErrors,
  type PostApiV1HubspotTenantsResponse,
  type PostApiV1HubspotTenantsResponses,
  type PostApiV1ImageAttachmentsUploadUrlData,
  type PostApiV1ImageAttachmentsUploadUrlError,
  type PostApiV1ImageAttachmentsUploadUrlErrors,
  type PostApiV1ImageAttachmentsUploadUrlResponse,
  type PostApiV1ImageAttachmentsUploadUrlResponses,
  type PostApiV1InferenceConversationsByExternalIdRestoreData,
  type PostApiV1InferenceConversationsByExternalIdRestoreError,
  type PostApiV1InferenceConversationsByExternalIdRestoreErrors,
  type PostApiV1InferenceConversationsByExternalIdRestoreResponse,
  type PostApiV1InferenceConversationsByExternalIdRestoreResponses,
  type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreData,
  type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreError,
  type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreErrors,
  type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponse,
  type PostApiV1InferenceDatapointsByInferenceDatapointIdRestoreResponses,
  type PostApiV1IngestionKnowledgeBasesIngestionFilesData,
  type PostApiV1IngestionKnowledgeBasesIngestionFilesError,
  type PostApiV1IngestionKnowledgeBasesIngestionFilesErrors,
  type PostApiV1IngestionKnowledgeBasesIngestionFilesResponse,
  type PostApiV1IngestionKnowledgeBasesIngestionFilesResponses,
  type PostApiV1IngestionSupportIngestionFilesData,
  type PostApiV1IngestionSupportIngestionFilesError,
  type PostApiV1IngestionSupportIngestionFilesErrors,
  type PostApiV1IngestionSupportIngestionFilesResponse,
  type PostApiV1IngestionSupportIngestionFilesResponses,
  type PostApiV1JudgesByJudgeIdRestoreData,
  type PostApiV1JudgesByJudgeIdRestoreError,
  type PostApiV1JudgesByJudgeIdRestoreErrors,
  type PostApiV1JudgesByJudgeIdRestoreResponse,
  type PostApiV1JudgesByJudgeIdRestoreResponses,
  type PostApiV1JudgesData,
  type PostApiV1JudgesError,
  type PostApiV1JudgesErrors,
  type PostApiV1JudgesResponse,
  type PostApiV1JudgesResponses,
  type PostApiV1JudgesSyncData,
  type PostApiV1JudgesSyncResponse,
  type PostApiV1JudgesSyncResponses,
  type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreData,
  type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreError,
  type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreErrors,
  type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponse,
  type PostApiV1KanonicalDatapointsByKanonicalDatapointIdRestoreResponses,
  type PostApiV1KbAttachmentsUploadUrlData,
  type PostApiV1KbAttachmentsUploadUrlError,
  type PostApiV1KbAttachmentsUploadUrlErrors,
  type PostApiV1KbAttachmentsUploadUrlResponse,
  type PostApiV1KbAttachmentsUploadUrlResponses,
  type PostApiV1KbsByKbIdEmbeddingSearchData,
  type PostApiV1KbsByKbIdEmbeddingSearchError,
  type PostApiV1KbsByKbIdEmbeddingSearchErrors,
  type PostApiV1KbsByKbIdEmbeddingSearchResponse,
  type PostApiV1KbsByKbIdEmbeddingSearchResponses,
  type PostApiV1KbsByKbIdHybridSearchData,
  type PostApiV1KbsByKbIdHybridSearchError,
  type PostApiV1KbsByKbIdHybridSearchErrors,
  type PostApiV1KbsByKbIdHybridSearchResponse,
  type PostApiV1KbsByKbIdHybridSearchResponses,
  type PostApiV1KbsByKbIdRegexSearchData,
  type PostApiV1KbsByKbIdRegexSearchError,
  type PostApiV1KbsByKbIdRegexSearchErrors,
  type PostApiV1KbsByKbIdRegexSearchResponse,
  type PostApiV1KbsByKbIdRegexSearchResponses,
  type PostApiV1KbsData,
  type PostApiV1KbsError,
  type PostApiV1KbsErrors,
  type PostApiV1KbSimulationDatapointsBatchData,
  type PostApiV1KbSimulationDatapointsBatchError,
  type PostApiV1KbSimulationDatapointsBatchErrors,
  type PostApiV1KbSimulationDatapointsBatchResponse,
  type PostApiV1KbSimulationDatapointsBatchResponses,
  type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreData,
  type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreError,
  type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreErrors,
  type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponse,
  type PostApiV1KbSimulationDatapointsBySimulationDatapointIdRestoreResponses,
  type PostApiV1KbSimulationDatapointsData,
  type PostApiV1KbSimulationDatapointsError,
  type PostApiV1KbSimulationDatapointsErrors,
  type PostApiV1KbSimulationDatapointsResponse,
  type PostApiV1KbSimulationDatapointsResponses,
  type PostApiV1KbSimulationResultJudgementsBatchData,
  type PostApiV1KbSimulationResultJudgementsBatchError,
  type PostApiV1KbSimulationResultJudgementsBatchErrors,
  type PostApiV1KbSimulationResultJudgementsBatchResponse,
  type PostApiV1KbSimulationResultJudgementsBatchResponses,
  type PostApiV1KbSimulationResultsBatchData,
  type PostApiV1KbSimulationResultsBatchError,
  type PostApiV1KbSimulationResultsBatchErrors,
  type PostApiV1KbSimulationResultsBatchResponse,
  type PostApiV1KbSimulationResultsBatchResponses,
  type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsData,
  type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsError,
  type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsErrors,
  type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponse,
  type PostApiV1KbSimulationResultsBySimulationResultIdJudgementsResponses,
  type PostApiV1KbSimulationResultsBySimulationResultIdRestoreData,
  type PostApiV1KbSimulationResultsBySimulationResultIdRestoreError,
  type PostApiV1KbSimulationResultsBySimulationResultIdRestoreErrors,
  type PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponse,
  type PostApiV1KbSimulationResultsBySimulationResultIdRestoreResponses,
  type PostApiV1KbSimulationResultsData,
  type PostApiV1KbSimulationResultsError,
  type PostApiV1KbSimulationResultsErrors,
  type PostApiV1KbSimulationResultsResponse,
  type PostApiV1KbSimulationResultsResponses,
  type PostApiV1KbsResponse,
  type PostApiV1KbsResponses,
  type PostApiV1MachineUsersByMachineUserIdApiKeysData,
  type PostApiV1MachineUsersByMachineUserIdApiKeysError,
  type PostApiV1MachineUsersByMachineUserIdApiKeysErrors,
  type PostApiV1MachineUsersByMachineUserIdApiKeysResponse,
  type PostApiV1MachineUsersByMachineUserIdApiKeysResponses,
  type PostApiV1MachineUsersData,
  type PostApiV1MachineUsersError,
  type PostApiV1MachineUsersErrors,
  type PostApiV1MachineUsersResponse,
  type PostApiV1MachineUsersResponses,
  type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretData,
  type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretError,
  type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretErrors,
  type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponse,
  type PostApiV1OauthApplicationsByOauthApplicationIdRotateSecretResponses,
  type PostApiV1OauthApplicationsData,
  type PostApiV1OauthApplicationsError,
  type PostApiV1OauthApplicationsErrors,
  type PostApiV1OauthApplicationsResponse,
  type PostApiV1OauthApplicationsResponses,
  type PostApiV1PipelinesCreateInferenceDatapointsDequeueData,
  type PostApiV1PipelinesCreateInferenceDatapointsDequeueError,
  type PostApiV1PipelinesCreateInferenceDatapointsDequeueErrors,
  type PostApiV1PipelinesCreateInferenceDatapointsDequeueResponse,
  type PostApiV1PipelinesCreateInferenceDatapointsDequeueResponses,
  type PostApiV1PipelinesCreateInferenceDatapointsEnqueueData,
  type PostApiV1PipelinesCreateInferenceDatapointsEnqueueError,
  type PostApiV1PipelinesCreateInferenceDatapointsEnqueueErrors,
  type PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponse,
  type PostApiV1PipelinesCreateInferenceDatapointsEnqueueResponses,
  type PostApiV1PipelinesCreateInferenceDatapointsInputData,
  type PostApiV1PipelinesCreateInferenceDatapointsInputError,
  type PostApiV1PipelinesCreateInferenceDatapointsInputErrors,
  type PostApiV1PipelinesCreateInferenceDatapointsInputResponse,
  type PostApiV1PipelinesCreateInferenceDatapointsInputResponses,
  type PostApiV1PipelinesCreateInferenceDatapointsOutputData,
  type PostApiV1PipelinesCreateInferenceDatapointsOutputError,
  type PostApiV1PipelinesCreateInferenceDatapointsOutputErrors,
  type PostApiV1PipelinesCreateInferenceDatapointsOutputResponse,
  type PostApiV1PipelinesCreateInferenceDatapointsOutputResponses,
  type PostApiV1PipelinesCreateProdEvalsDequeueData,
  type PostApiV1PipelinesCreateProdEvalsDequeueError,
  type PostApiV1PipelinesCreateProdEvalsDequeueErrors,
  type PostApiV1PipelinesCreateProdEvalsDequeueResponse,
  type PostApiV1PipelinesCreateProdEvalsDequeueResponses,
  type PostApiV1PipelinesCreateProdEvalsEnqueueData,
  type PostApiV1PipelinesCreateProdEvalsEnqueueError,
  type PostApiV1PipelinesCreateProdEvalsEnqueueErrors,
  type PostApiV1PipelinesCreateProdEvalsEnqueueResponse,
  type PostApiV1PipelinesCreateProdEvalsEnqueueResponses,
  type PostApiV1PipelinesCreateProdEvalsInputData,
  type PostApiV1PipelinesCreateProdEvalsInputError,
  type PostApiV1PipelinesCreateProdEvalsInputErrors,
  type PostApiV1PipelinesCreateProdEvalsInputResponse,
  type PostApiV1PipelinesCreateProdEvalsInputResponses,
  type PostApiV1PipelinesCreateProdEvalsOutputData,
  type PostApiV1PipelinesCreateProdEvalsOutputError,
  type PostApiV1PipelinesCreateProdEvalsOutputErrors,
  type PostApiV1PipelinesCreateProdEvalsOutputResponse,
  type PostApiV1PipelinesCreateProdEvalsOutputResponses,
  type PostApiV1PipelinesExtractDataDumpConversationsDequeueData,
  type PostApiV1PipelinesExtractDataDumpConversationsDequeueError,
  type PostApiV1PipelinesExtractDataDumpConversationsDequeueErrors,
  type PostApiV1PipelinesExtractDataDumpConversationsDequeueResponse,
  type PostApiV1PipelinesExtractDataDumpConversationsDequeueResponses,
  type PostApiV1PipelinesExtractDataDumpConversationsEnqueueData,
  type PostApiV1PipelinesExtractDataDumpConversationsEnqueueError,
  type PostApiV1PipelinesExtractDataDumpConversationsEnqueueErrors,
  type PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponse,
  type PostApiV1PipelinesExtractDataDumpConversationsEnqueueResponses,
  type PostApiV1PipelinesExtractDataDumpConversationsInputData,
  type PostApiV1PipelinesExtractDataDumpConversationsInputError,
  type PostApiV1PipelinesExtractDataDumpConversationsInputErrors,
  type PostApiV1PipelinesExtractDataDumpConversationsInputResponse,
  type PostApiV1PipelinesExtractDataDumpConversationsInputResponses,
  type PostApiV1PipelinesExtractDataDumpConversationsOutputData,
  type PostApiV1PipelinesExtractDataDumpConversationsOutputError,
  type PostApiV1PipelinesExtractDataDumpConversationsOutputErrors,
  type PostApiV1PipelinesExtractDataDumpConversationsOutputResponse,
  type PostApiV1PipelinesExtractDataDumpConversationsOutputResponses,
  type PostApiV1PipelinesExtractDatapointsDequeueData,
  type PostApiV1PipelinesExtractDatapointsDequeueError,
  type PostApiV1PipelinesExtractDatapointsDequeueErrors,
  type PostApiV1PipelinesExtractDatapointsDequeueResponse,
  type PostApiV1PipelinesExtractDatapointsDequeueResponses,
  type PostApiV1PipelinesExtractDatapointsEnqueueData,
  type PostApiV1PipelinesExtractDatapointsEnqueueError,
  type PostApiV1PipelinesExtractDatapointsEnqueueErrors,
  type PostApiV1PipelinesExtractDatapointsEnqueueResponse,
  type PostApiV1PipelinesExtractDatapointsEnqueueResponses,
  type PostApiV1PipelinesExtractDatapointsInputData,
  type PostApiV1PipelinesExtractDatapointsInputError,
  type PostApiV1PipelinesExtractDatapointsInputErrors,
  type PostApiV1PipelinesExtractDatapointsInputResponse,
  type PostApiV1PipelinesExtractDatapointsInputResponses,
  type PostApiV1PipelinesExtractDatapointsOutputData,
  type PostApiV1PipelinesExtractDatapointsOutputError,
  type PostApiV1PipelinesExtractDatapointsOutputErrors,
  type PostApiV1PipelinesExtractDatapointsOutputResponse,
  type PostApiV1PipelinesExtractDatapointsOutputResponses,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueData,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueError,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueErrors,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponse,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesDequeueResponses,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueData,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueError,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueErrors,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponse,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesEnqueueResponses,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputData,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputError,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputErrors,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponse,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesInputResponses,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputData,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputError,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputErrors,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponse,
  type PostApiV1PipelinesExtractIncomingKnowledgeBasesOutputResponses,
  type PostApiV1PipelinesFinalizeConversationsDequeueData,
  type PostApiV1PipelinesFinalizeConversationsDequeueError,
  type PostApiV1PipelinesFinalizeConversationsDequeueErrors,
  type PostApiV1PipelinesFinalizeConversationsDequeueResponse,
  type PostApiV1PipelinesFinalizeConversationsDequeueResponses,
  type PostApiV1PipelinesFinalizeConversationsEnqueueData,
  type PostApiV1PipelinesFinalizeConversationsEnqueueError,
  type PostApiV1PipelinesFinalizeConversationsEnqueueErrors,
  type PostApiV1PipelinesFinalizeConversationsEnqueueResponse,
  type PostApiV1PipelinesFinalizeConversationsEnqueueResponses,
  type PostApiV1PipelinesFinalizeConversationsInputData,
  type PostApiV1PipelinesFinalizeConversationsInputError,
  type PostApiV1PipelinesFinalizeConversationsInputErrors,
  type PostApiV1PipelinesFinalizeConversationsInputResponse,
  type PostApiV1PipelinesFinalizeConversationsInputResponses,
  type PostApiV1PipelinesFinalizeConversationsOutputData,
  type PostApiV1PipelinesFinalizeConversationsOutputError,
  type PostApiV1PipelinesFinalizeConversationsOutputErrors,
  type PostApiV1PipelinesFinalizeConversationsOutputResponse,
  type PostApiV1PipelinesFinalizeConversationsOutputResponses,
  type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueData,
  type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueError,
  type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueErrors,
  type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponse,
  type PostApiV1PipelinesFinetuneKnowledgeBasesDequeueResponses,
  type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueData,
  type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueError,
  type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueErrors,
  type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponse,
  type PostApiV1PipelinesFinetuneKnowledgeBasesEnqueueResponses,
  type PostApiV1PipelinesFinetuneKnowledgeBasesInputData,
  type PostApiV1PipelinesFinetuneKnowledgeBasesInputError,
  type PostApiV1PipelinesFinetuneKnowledgeBasesInputErrors,
  type PostApiV1PipelinesFinetuneKnowledgeBasesInputResponse,
  type PostApiV1PipelinesFinetuneKnowledgeBasesInputResponses,
  type PostApiV1PipelinesFinetuneKnowledgeBasesOutputData,
  type PostApiV1PipelinesFinetuneKnowledgeBasesOutputError,
  type PostApiV1PipelinesFinetuneKnowledgeBasesOutputErrors,
  type PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponse,
  type PostApiV1PipelinesFinetuneKnowledgeBasesOutputResponses,
  type PostApiV1PipelinesKanonicalizeDatapointsDequeueData,
  type PostApiV1PipelinesKanonicalizeDatapointsDequeueError,
  type PostApiV1PipelinesKanonicalizeDatapointsDequeueErrors,
  type PostApiV1PipelinesKanonicalizeDatapointsDequeueResponse,
  type PostApiV1PipelinesKanonicalizeDatapointsDequeueResponses,
  type PostApiV1PipelinesKanonicalizeDatapointsEnqueueData,
  type PostApiV1PipelinesKanonicalizeDatapointsEnqueueError,
  type PostApiV1PipelinesKanonicalizeDatapointsEnqueueErrors,
  type PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponse,
  type PostApiV1PipelinesKanonicalizeDatapointsEnqueueResponses,
  type PostApiV1PipelinesKanonicalizeDatapointsInputData,
  type PostApiV1PipelinesKanonicalizeDatapointsInputError,
  type PostApiV1PipelinesKanonicalizeDatapointsInputErrors,
  type PostApiV1PipelinesKanonicalizeDatapointsInputResponse,
  type PostApiV1PipelinesKanonicalizeDatapointsInputResponses,
  type PostApiV1PipelinesKanonicalizeDatapointsOutputData,
  type PostApiV1PipelinesKanonicalizeDatapointsOutputError,
  type PostApiV1PipelinesKanonicalizeDatapointsOutputErrors,
  type PostApiV1PipelinesKanonicalizeDatapointsOutputResponse,
  type PostApiV1PipelinesKanonicalizeDatapointsOutputResponses,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendData,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendError,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendErrors,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponse,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameAmendResponses,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickData,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickError,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickErrors,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponse,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCherryPickResponses,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitData,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitError,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitErrors,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponse,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameCommitResponses,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeData,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeError,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeErrors,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponse,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameMergeResponses,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseData,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseError,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseErrors,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponse,
  type PostApiV1ReposByRepositoryIdBranchesByBranchNameRebaseResponses,
  type PostApiV1ReposByRepositoryIdBranchesByNameRestoreData,
  type PostApiV1ReposByRepositoryIdBranchesByNameRestoreError,
  type PostApiV1ReposByRepositoryIdBranchesByNameRestoreErrors,
  type PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponse,
  type PostApiV1ReposByRepositoryIdBranchesByNameRestoreResponses,
  type PostApiV1ReposByRepositoryIdBranchesData,
  type PostApiV1ReposByRepositoryIdBranchesError,
  type PostApiV1ReposByRepositoryIdBranchesErrors,
  type PostApiV1ReposByRepositoryIdBranchesResponse,
  type PostApiV1ReposByRepositoryIdBranchesResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAddAttachmentResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsAttachTagResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsChangeApprovalStateResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateCatalogRequestResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsCreateIncidentResponses,
  type PostApiV1ServiceNowTenantsByTenantIdActionsReplyData,
  type PostApiV1ServiceNowTenantsByTenantIdActionsReplyError,
  type PostApiV1ServiceNowTenantsByTenantIdActionsReplyErrors,
  type PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponse,
  type PostApiV1ServiceNowTenantsByTenantIdActionsReplyResponses,
  type PostApiV1ServiceNowTenantsByTenantIdArticlesData,
  type PostApiV1ServiceNowTenantsByTenantIdArticlesError,
  type PostApiV1ServiceNowTenantsByTenantIdArticlesErrors,
  type PostApiV1ServiceNowTenantsByTenantIdArticlesResponse,
  type PostApiV1ServiceNowTenantsByTenantIdArticlesResponses,
  type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesData,
  type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesError,
  type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesErrors,
  type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponse,
  type PostApiV1ServiceNowTenantsByTenantIdKnowledgeBasesResponses,
  type PostApiV1ServiceNowTenantsByTenantIdRestoreData,
  type PostApiV1ServiceNowTenantsByTenantIdRestoreError,
  type PostApiV1ServiceNowTenantsByTenantIdRestoreErrors,
  type PostApiV1ServiceNowTenantsByTenantIdRestoreResponse,
  type PostApiV1ServiceNowTenantsByTenantIdRestoreResponses,
  type PostApiV1ServiceNowTenantsByTenantIdSetupData,
  type PostApiV1ServiceNowTenantsByTenantIdSetupError,
  type PostApiV1ServiceNowTenantsByTenantIdSetupErrors,
  type PostApiV1ServiceNowTenantsByTenantIdSetupResponse,
  type PostApiV1ServiceNowTenantsByTenantIdSetupResponses,
  type PostApiV1ServiceNowTenantsByTenantIdTagsData,
  type PostApiV1ServiceNowTenantsByTenantIdTagsError,
  type PostApiV1ServiceNowTenantsByTenantIdTagsErrors,
  type PostApiV1ServiceNowTenantsByTenantIdTagsResponse,
  type PostApiV1ServiceNowTenantsByTenantIdTagsResponses,
  type PostApiV1ServiceNowTenantsData,
  type PostApiV1ServiceNowTenantsError,
  type PostApiV1ServiceNowTenantsErrors,
  type PostApiV1ServiceNowTenantsResponse,
  type PostApiV1ServiceNowTenantsResponses,
  type PostApiV1SesameEdraAccessData,
  type PostApiV1SesameEdraAccessError,
  type PostApiV1SesameEdraAccessErrors,
  type PostApiV1SesameEdraAccessResponse,
  type PostApiV1SesameEdraAccessResponses,
  type PostApiV1TasksByTaskIdFeedbackLabelsData,
  type PostApiV1TasksByTaskIdFeedbackLabelsError,
  type PostApiV1TasksByTaskIdFeedbackLabelsErrors,
  type PostApiV1TasksByTaskIdFeedbackLabelsResponse,
  type PostApiV1TasksByTaskIdFeedbackLabelsResponses,
  type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackData,
  type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackError,
  type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackErrors,
  type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponse,
  type PostApiV1TasksByTaskIdInferencesByInferenceIdFeedbackResponses,
  type PostApiV1TasksByTaskIdInferencesFeedbackLabelsData,
  type PostApiV1TasksByTaskIdInferencesFeedbackLabelsError,
  type PostApiV1TasksByTaskIdInferencesFeedbackLabelsErrors,
  type PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponse,
  type PostApiV1TasksByTaskIdInferencesFeedbackLabelsResponses,
  type PostApiV1TasksByTaskIdPromptsData,
  type PostApiV1TasksByTaskIdPromptsError,
  type PostApiV1TasksByTaskIdPromptsErrors,
  type PostApiV1TasksByTaskIdPromptsResponse,
  type PostApiV1TasksByTaskIdPromptsResponses,
  type PostApiV1UsersBotData,
  type PostApiV1UsersBotError,
  type PostApiV1UsersBotErrors,
  type PostApiV1UsersBotResponse,
  type PostApiV1UsersBotResponses,
  type PostApiV1UsersByUserIdRestoreData,
  type PostApiV1UsersByUserIdRestoreError,
  type PostApiV1UsersByUserIdRestoreErrors,
  type PostApiV1UsersByUserIdRestoreResponse,
  type PostApiV1UsersByUserIdRestoreResponses,
  type PostApiV1WorkClaimsByClaimIdCompleteData,
  type PostApiV1WorkClaimsByClaimIdCompleteError,
  type PostApiV1WorkClaimsByClaimIdCompleteErrors,
  type PostApiV1WorkClaimsByClaimIdCompleteResponse,
  type PostApiV1WorkClaimsByClaimIdCompleteResponses,
  type PostApiV1WorkClaimsData,
  type PostApiV1WorkClaimsError,
  type PostApiV1WorkClaimsErrors,
  type PostApiV1WorkClaimsResponse,
  type PostApiV1WorkClaimsResponses,
  type PostApiV1WorkEventsData,
  type PostApiV1WorkEventsError,
  type PostApiV1WorkEventsErrors,
  type PostApiV1WorkEventsResponse,
  type PostApiV1WorkEventsResponses,
  type PostApiV1WorkflowAnalyticsEventsData,
  type PostApiV1WorkflowAnalyticsEventsError,
  type PostApiV1WorkflowAnalyticsEventsErrors,
  type PostApiV1WorkflowAnalyticsEventsResponse,
  type PostApiV1WorkflowAnalyticsEventsResponses,
  type PostApiV1WorkspacesByWorkspaceIdRestoreData,
  type PostApiV1WorkspacesByWorkspaceIdRestoreError,
  type PostApiV1WorkspacesByWorkspaceIdRestoreErrors,
  type PostApiV1WorkspacesByWorkspaceIdRestoreResponse,
  type PostApiV1WorkspacesByWorkspaceIdRestoreResponses,
  type PostApiV1WorkspacesData,
  type PostApiV1WorkspacesResponse,
  type PostApiV1WorkspacesResponses,
  type PostApiV1ZendeskTenantsByTenantIdCallbackData,
  type PostApiV1ZendeskTenantsByTenantIdCallbackError,
  type PostApiV1ZendeskTenantsByTenantIdCallbackErrors,
  type PostApiV1ZendeskTenantsByTenantIdCallbackResponse,
  type PostApiV1ZendeskTenantsByTenantIdCallbackResponses,
  type PostApiV1ZendeskTenantsByTenantIdConnectData,
  type PostApiV1ZendeskTenantsByTenantIdConnectError,
  type PostApiV1ZendeskTenantsByTenantIdConnectErrors,
  type PostApiV1ZendeskTenantsByTenantIdConnectResponse,
  type PostApiV1ZendeskTenantsByTenantIdConnectResponses,
  type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionData,
  type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionError,
  type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionErrors,
  type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponse,
  type PostApiV1ZendeskTenantsByTenantIdWebhooksProvisionResponses,
  type PostApiV1ZendeskTenantsData,
  type PostApiV1ZendeskTenantsError,
  type PostApiV1ZendeskTenantsErrors,
  type PostApiV1ZendeskTenantsResponse,
  type PostApiV1ZendeskTenantsResponses,
  type PostApiV2AttachmentsUploadUrlData,
  type PostApiV2AttachmentsUploadUrlError,
  type PostApiV2AttachmentsUploadUrlErrors,
  type PostApiV2AttachmentsUploadUrlResponse,
  type PostApiV2AttachmentsUploadUrlResponses,
  type PostApiV2ConversationsByExternalIdFeedbackData,
  type PostApiV2ConversationsByExternalIdFeedbackError,
  type PostApiV2ConversationsByExternalIdFeedbackErrors,
  type PostApiV2ConversationsByExternalIdFeedbackResponse,
  type PostApiV2ConversationsByExternalIdFeedbackResponses,
  type PostApiV2ConversationsByExternalIdMessagesData,
  type PostApiV2ConversationsByExternalIdMessagesError,
  type PostApiV2ConversationsByExternalIdMessagesErrors,
  type PostApiV2ConversationsByExternalIdMessagesResponse,
  type PostApiV2ConversationsByExternalIdMessagesResponses,
  type PostApiV2ConversationsByExternalIdStatefulInferenceData,
  type PostApiV2ConversationsByExternalIdStatefulInferenceError,
  type PostApiV2ConversationsByExternalIdStatefulInferenceErrors,
  type PostApiV2ConversationsByExternalIdStatefulInferenceResponse,
  type PostApiV2ConversationsByExternalIdStatefulInferenceResponses,
  type PostApiV2ConversationsByExternalIdStatelessInferenceData,
  type PostApiV2ConversationsByExternalIdStatelessInferenceError,
  type PostApiV2ConversationsByExternalIdStatelessInferenceErrors,
  type PostApiV2ConversationsByExternalIdStatelessInferenceResponse,
  type PostApiV2ConversationsByExternalIdStatelessInferenceResponses,
  type PostApiV2DatapointsByDatapointIdRestoreData,
  type PostApiV2DatapointsByDatapointIdRestoreError,
  type PostApiV2DatapointsByDatapointIdRestoreErrors,
  type PostApiV2DatapointsByDatapointIdRestoreResponse,
  type PostApiV2DatapointsByDatapointIdRestoreResponses,
  type PostApiV2FinalizedConversationsData,
  type PostApiV2FinalizedConversationsError,
  type PostApiV2FinalizedConversationsErrors,
  type PostApiV2FinalizedConversationsResponse,
  type PostApiV2FinalizedConversationsResponses,
  type PostApiV2InferenceConversationsByExternalIdMessagesData,
  type PostApiV2InferenceConversationsByExternalIdMessagesError,
  type PostApiV2InferenceConversationsByExternalIdMessagesErrors,
  type PostApiV2InferenceConversationsByExternalIdMessagesResponse,
  type PostApiV2InferenceConversationsByExternalIdMessagesResponses,
  type PostApiV2InferenceConversationsByExternalIdStatefulInferenceData,
  type PostApiV2InferenceConversationsByExternalIdStatefulInferenceError,
  type PostApiV2InferenceConversationsByExternalIdStatefulInferenceErrors,
  type PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponse,
  type PostApiV2InferenceConversationsByExternalIdStatefulInferenceResponses,
  type PostApiV2InferenceConversationsByExternalIdStatelessInferenceData,
  type PostApiV2InferenceConversationsByExternalIdStatelessInferenceError,
  type PostApiV2InferenceConversationsByExternalIdStatelessInferenceErrors,
  type PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponse,
  type PostApiV2InferenceConversationsByExternalIdStatelessInferenceResponses,
  type PostApiV2InferenceDatapointsData,
  type PostApiV2InferenceDatapointsError,
  type PostApiV2InferenceDatapointsErrors,
  type PostApiV2InferenceDatapointsResponse,
  type PostApiV2InferenceDatapointsResponses,
  type PostApiV2JudgementsData,
  type PostApiV2JudgementsError,
  type PostApiV2JudgementsErrors,
  type PostApiV2JudgementsResponse,
  type PostApiV2JudgementsResponses,
  type PostApiV2JudgesBulkData,
  type PostApiV2JudgesBulkError,
  type PostApiV2JudgesBulkErrors,
  type PostApiV2JudgesBulkResponse,
  type PostApiV2JudgesBulkResponses,
  type PostApiV2JudgesData,
  type PostApiV2JudgesError,
  type PostApiV2JudgesErrors,
  type PostApiV2JudgesResponse,
  type PostApiV2JudgesResponses,
  type PostApiV2KanonicalDatapointsData,
  type PostApiV2KanonicalDatapointsError,
  type PostApiV2KanonicalDatapointsErrors,
  type PostApiV2KanonicalDatapointsResponse,
  type PostApiV2KanonicalDatapointsResponses,
  type PostApiV2KbsByKbIdEmbedData,
  type PostApiV2KbsByKbIdEmbedError,
  type PostApiV2KbsByKbIdEmbedErrors,
  type PostApiV2KbsByKbIdEmbedResponse,
  type PostApiV2KbsByKbIdEmbedResponses,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateData,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateError,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateErrors,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponse,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestItemStateResponses,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateData,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateError,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateErrors,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponse,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeRequestStateResponses,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateData,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateError,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateErrors,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponse,
  type PostApiV2ServiceNowTenantsByTenantIdActionsChangeTaskStateResponses,
  type PostApiV2TasksByTaskIdRestoreData,
  type PostApiV2TasksByTaskIdRestoreError,
  type PostApiV2TasksByTaskIdRestoreErrors,
  type PostApiV2TasksByTaskIdRestoreResponse,
  type PostApiV2TasksByTaskIdRestoreResponses,
  type PostApiV2TasksData,
  type PostApiV2TasksError,
  type PostApiV2TasksErrors,
  type PostApiV2TasksResponse,
  type PostApiV2TasksResponses,
  type PostApiV3DatapointsData,
  type PostApiV3DatapointsError,
  type PostApiV3DatapointsErrors,
  type PostApiV3DatapointsResponse,
  type PostApiV3DatapointsResponses,
  type PostApiV3JudgementsData,
  type PostApiV3JudgementsError,
  type PostApiV3JudgementsErrors,
  type PostApiV3JudgementsResponse,
  type PostApiV3JudgementsResponses,
  type PostApiV3KbsByKbIdRestoreData,
  type PostApiV3KbsByKbIdRestoreError,
  type PostApiV3KbsByKbIdRestoreErrors,
  type PostApiV3KbsByKbIdRestoreResponse,
  type PostApiV3KbsByKbIdRestoreResponses,
  type PostApiZendeskV1ActionsReplyToTicketData,
  type PostApiZendeskV1ActionsReplyToTicketError,
  type PostApiZendeskV1ActionsReplyToTicketErrors,
  type PostApiZendeskV1ActionsReplyToTicketResponse,
  type PostApiZendeskV1ActionsReplyToTicketResponses,
  type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsData,
  type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsError,
  type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsErrors,
  type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponse,
  type PostApiZendeskV1TenantsByTenantIdActionsUpdateTicketTagsResponses,
  PromptKind,
  type PromptV1,
  type PutApiDebugV1ValkeyValuesByKeyData,
  type PutApiDebugV1ValkeyValuesByKeyError,
  type PutApiDebugV1ValkeyValuesByKeyErrors,
  type PutApiDebugV1ValkeyValuesByKeyResponse,
  type PutApiDebugV1ValkeyValuesByKeyResponses,
  type PutApiPlainV1TenantsByTenantIdActionsCompaniesData,
  type PutApiPlainV1TenantsByTenantIdActionsCompaniesError,
  type PutApiPlainV1TenantsByTenantIdActionsCompaniesErrors,
  type PutApiPlainV1TenantsByTenantIdActionsCompaniesResponse,
  type PutApiPlainV1TenantsByTenantIdActionsCompaniesResponses,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyData,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyError,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyErrors,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponse,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersByCustomerIdCompanyResponses,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersData,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersError,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersErrors,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersResponse,
  type PutApiPlainV1TenantsByTenantIdActionsCustomersResponses,
  type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsData,
  type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsError,
  type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsErrors,
  type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponse,
  type PutApiPlainV1TenantsByTenantIdActionsPlainTenantsResponses,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeData,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeError,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeErrors,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponse,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeResponses,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfData,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfError,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfErrors,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponse,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdAssigneeSelfResponses,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyData,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyError,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyErrors,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponse,
  type PutApiPlainV1TenantsByTenantIdActionsThreadsByThreadIdFieldsByKeyResponses,
  type PutApiSalesforceV1TenantsByTenantIdIngestClientData,
  type PutApiSalesforceV1TenantsByTenantIdIngestClientError,
  type PutApiSalesforceV1TenantsByTenantIdIngestClientErrors,
  type PutApiSalesforceV1TenantsByTenantIdIngestClientResponse,
  type PutApiSalesforceV1TenantsByTenantIdIngestClientResponses,
  type PutApiV1AuthzOrganizationsByExternalIdData,
  type PutApiV1AuthzOrganizationsByExternalIdError,
  type PutApiV1AuthzOrganizationsByExternalIdErrors,
  type PutApiV1AuthzOrganizationsByExternalIdResponse,
  type PutApiV1AuthzOrganizationsByExternalIdResponses,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdData,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdError,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdErrors,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponse,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesByArticleIdResponses,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesData,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesError,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesErrors,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponse,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdArticlesResponses,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdData,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdError,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdErrors,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponse,
  type PutApiV1AuthzOrganizationsByOrgIdTeamsByTeamIdKnowledgeBasesByKbIdResponses,
  type PutApiV1SesameOrgMemberRolesData,
  type PutApiV1SesameOrgMemberRolesError,
  type PutApiV1SesameOrgMemberRolesErrors,
  type PutApiV1SesameOrgMemberRolesResponse,
  type PutApiV1SesameOrgMemberRolesResponses,
  type PutApiV1SesameOrgMembershipsData,
  type PutApiV1SesameOrgMembershipsError,
  type PutApiV1SesameOrgMembershipsErrors,
  type PutApiV1SesameOrgMembershipsResponse,
  type PutApiV1SesameOrgMembershipsResponses,
  type PutApiV1UsersExternalByExternalIdData,
  type PutApiV1UsersExternalByExternalIdError,
  type PutApiV1UsersExternalByExternalIdErrors,
  type PutApiV1UsersExternalByExternalIdResponse,
  type PutApiV1UsersExternalByExternalIdResponses,
  type PutApiV2ConversationsByExternalIdData,
  type PutApiV2ConversationsByExternalIdError,
  type PutApiV2ConversationsByExternalIdErrors,
  type PutApiV2ConversationsByExternalIdResponse,
  type PutApiV2ConversationsByExternalIdResponses,
  type PutApiV2InferenceConversationsByExternalIdData,
  type PutApiV2InferenceConversationsByExternalIdError,
  type PutApiV2InferenceConversationsByExternalIdErrors,
  type PutApiV2InferenceConversationsByExternalIdResponse,
  type PutApiV2InferenceConversationsByExternalIdResponses,
  type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextData,
  type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextError,
  type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextErrors,
  type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponse,
  type PutApiV3KbsByKbIdArticleByRefByArticleIdIndexTextResponses,
  type RedactedArticleContentV1,
  type RedactedChangeRequestContentV1,
  type RedactedKnowledgeBaseContentV1,
  type ReferenceLineV1,
  type RegexSearchArticlesParamsV1,
  type RegexSearchArticlesResponseV1,
  type RegexSearchArticlesSourceV1,
  type RegexSearchDatapointQueryV1,
  type RegexSearchDatapointsRequestV1,
  type RegexSearchDatapointsResponseV1,
  type RejectEntraProposedActionParamsV1,
  type ResolveEntraCallerParamsV1,
  type ResolveKbAccessRequestParamsV1,
  type RoleV1,
  type RunningWorkflowRunV1,
  type SalesforceAccountPageV1,
  type SalesforceAccountV1,
  type SalesforceArticlePageV1,
  SalesforceArticleStatusV1,
  type SalesforceArticleV1,
  type SalesforceCallbackPayloadV1,
  type SalesforceCaseCommentV1,
  type SalesforceCaseEmailV1,
  type SalesforceCaseMessagePageV1,
  type SalesforceCaseMessageV1,
  type SalesforceCasePageV1,
  type SalesforceCaseV1,
  type SalesforceCheckConnectionResponseV1,
  type SalesforceCheckReadyResponseV1,
  type SalesforceConnectedV1,
  type SalesforceConnectResponseV1,
  type SalesforceContactPageV1,
  type SalesforceContactV1,
  type SalesforceDefaultLanguageV1,
  type SalesforceDisconnectedV1,
  type SalesforceEntitlementPageV1,
  type SalesforceEntitlementV1,
  type SalesforceIngestAckV1,
  type SalesforceIngestClientCredentialsV1,
  type SalesforceIngestClientV1,
  type SalesforceOAuthRedirectUriV1,
  type SalesforceOAuthTokenResponseV1,
  type SalesforceQueuePageV1,
  type SalesforceQueueV1,
  type SalesforceRecordTypePageV1,
  type SalesforceRecordTypeV1,
  type SalesforceTenantFullV1,
  type SalesforceTenantV1,
  type SalesforceUserInfoV1,
  type SalesforceUserPageV1,
  type SalesforceUserV1,
  type SanitizedStr,
  type SanitizedStr09aF32,
  type SanitizedStrAZ09AZ09061AZ09,
  type SanitizedStrAZAZ09079,
  type SanitizedStrAZAZ09079AZAZ0907904,
  type SanitizedStrRN,
  type SankeyChartContentV1,
  type SankeyContentLinkV1,
  type SearchDatapointEvidenceRequestV1,
  type SearchDatapointEvidenceResponseV1,
  type SearchDatapointQueryV1,
  type SearchDatapointsRequestV1,
  type SearchDatapointsResponseV1,
  SearchDatapointStrategyV1,
  SearchEntityKindV1,
  type SearchFullEvaluatedInferenceDatapointsParamsV1,
  type SearchReindexParamsV1,
  type SearchReindexResultV1,
  type SearchResultArticleV1,
  type SearchResultChangeRequestV1,
  type SearchResultKnowledgeBaseV1,
  type SearchResultV1,
  type SearchSnippetSpanV1,
  type SearchSnippetV1,
  type SecretFullV1,
  SecretKindV1,
  type SecretV1,
  type SecretValueV1,
  type SecretValueV2,
  type SecretVersionFullV1,
  type SecretVersionV1,
  type SectionChangeReferenceLineV1,
  type SendAgentSessionMessageResponseV1,
  type SendAgentSessionMessageSyncResponseV1,
  type SendAgentSessionMessageSyncV1,
  type SendAgentSessionMessageV1,
  type SendSalesforceCaseEmailParamsV1,
  type ServiceNowAddAttachmentRequestV1,
  type ServiceNowAddAttachmentResponseV1,
  type ServiceNowAddRecordAttachmentRequestV1,
  type ServiceNowAggregateGroupV1,
  type ServiceNowAggregateRecordsV1,
  type ServiceNowAggregateV1,
  type ServiceNowApprovalStateChoicesV1,
  type ServiceNowApprovalV1,
  type ServiceNowAssignmentGroupByIdV1,
  type ServiceNowAssignmentGroupByNameV1,
  type ServiceNowAssignmentGroupRefV1,
  type ServiceNowAttachmentV1,
  type ServiceNowAttachTagRequestV1,
  type ServiceNowAttachTagResponseV1,
  ServiceNowAuthKindV1,
  type ServiceNowBatchCreateV1,
  type ServiceNowBatchItemResultV1,
  type ServiceNowBatchItemV1,
  type ServiceNowBatchReadV1,
  type ServiceNowBatchRequestV1,
  type ServiceNowBatchResultV1,
  type ServiceNowBatchUpdateV1,
  type ServiceNowCartIdV1Input,
  type ServiceNowCartIdV1Output,
  type ServiceNowCartItemV1,
  type ServiceNowCartItemVariableV1,
  type ServiceNowCartV1,
  type ServiceNowCatalogItemFullV1,
  type ServiceNowCatalogItemGuidV1,
  type ServiceNowCatalogItemV1,
  type ServiceNowCatalogItemVariableChoiceV1,
  type ServiceNowCatalogItemVariableV1,
  type ServiceNowCatalogLookupConfigurationChangedV1,
  type ServiceNowCatalogSysIdV1Input,
  type ServiceNowCatalogSysIdV1Output,
  ServiceNowCatalogValueMatchV1,
  type ServiceNowCatalogVariableLookupMetadataV1,
  type ServiceNowCatalogVariableValuesConflictV1,
  type ServiceNowCatalogVariableValueV1,
  type ServiceNowChangeApprovalStateRequestV1,
  type ServiceNowChangeApprovalStateResponseV1,
  type ServiceNowChangeAssignmentGroupRequestV1,
  type ServiceNowChangeAssignmentGroupResponseV1,
  type ServiceNowChangeIncidentStateRequestV1,
  type ServiceNowChangeIncidentStateResponseV1,
  type ServiceNowChangeRequestItemStateRequestV2,
  type ServiceNowChangeRequestItemStateResponseV2,
  type ServiceNowChangeRequestStateRequestV2,
  type ServiceNowChangeRequestStateResponseV2,
  type ServiceNowChangeTaskStateRequestV2,
  type ServiceNowChangeTaskStateResponseV2,
  type ServiceNowCheckoutOrderGuideForeignCartItemsV1,
  type ServiceNowCheckoutOrderGuideItemV1,
  type ServiceNowCheckoutOrderGuideRequestCreatedV1,
  type ServiceNowCheckoutOrderGuideResultV1,
  type ServiceNowCheckoutOrderGuideSelectionChangedV1,
  type ServiceNowCheckoutOrderGuideUncertainV1,
  type ServiceNowCheckoutOrderGuideV1,
  type ServiceNowChoiceV1,
  type ServiceNowColumnName,
  ServiceNowCommentFetchStrategyV1,
  ServiceNowCommentTypeV1,
  type ServiceNowCommentV1,
  type ServiceNowCreateAuthV1,
  type ServiceNowCreateBasicAuthV1,
  type ServiceNowCreateCatalogRequestResultV1,
  type ServiceNowCreateCatalogRequestV1,
  type ServiceNowCreateChangeTaskV1,
  type ServiceNowCreateChangeV1,
  type ServiceNowCreatedIncidentOriginV1,
  type ServiceNowCreateIncidentResultV1,
  type ServiceNowCreateIncidentV1,
  type ServiceNowCreateOAuthV1,
  type ServiceNowCreateRecordV1,
  type ServiceNowCreateTagV1,
  type ServiceNowCreateTenantV1,
  type ServiceNowDeleteStagedCatalogAttachmentRequestV1,
  type ServiceNowDisplayFieldV1,
  type ServiceNowEmergencyChangeV1,
  type ServiceNowEmptyCartRequestV1,
  type ServiceNowEvaluateOrderGuideForeignCartItemsV1,
  type ServiceNowEvaluateOrderGuideResultV1,
  type ServiceNowEvaluateOrderGuideSelectedV1,
  type ServiceNowEvaluateOrderGuideV1,
  ServiceNowFormVariableResolutionStatusV1,
  type ServiceNowFormVariableV1,
  type ServiceNowGetAttachmentContentResponseV1,
  ServiceNowImpactV1,
  type ServiceNowIncidentOriginV1,
  type ServiceNowIncidentStateChoicesV1,
  type ServiceNowIncidentV1,
  type ServiceNowKbArticleFullV1,
  type ServiceNowKbArticleV1,
  type ServiceNowKbKnowledgeBaseV1,
  type ServiceNowNormalChangeV1,
  type ServiceNowOrderGuideItemV1,
  type ServiceNowOrderGuideItemVariableV1,
  type ServiceNowQueryConditionV1,
  ServiceNowQueryJoinV1,
  ServiceNowQueryOperatorV1,
  type ServiceNowQueryOrderV1,
  type ServiceNowQueryV1,
  type ServiceNowQueryValue,
  type ServiceNowRecordFieldInputV1,
  type ServiceNowRecordFieldV1,
  type ServiceNowRecordV1,
  type ServiceNowReplyRequestV1,
  type ServiceNowReplyResponseV1,
  type ServiceNowReplyTenantNestedRequestV1,
  type ServiceNowRequestedForReadbackV1,
  type ServiceNowRequestedForReadV1,
  type ServiceNowRequestedForUnreadV1,
  type ServiceNowRequestFullV1,
  type ServiceNowRequestItemFullV1,
  type ServiceNowRequestItemV1,
  type ServiceNowRequestV1,
  type ServiceNowSearchRecordsV1,
  type ServiceNowSetupTenantResponseV1,
  type ServiceNowStageCatalogAttachmentRequestV1,
  type ServiceNowStagedCatalogAttachmentV1,
  type ServiceNowStandardChangeV1,
  type ServiceNowStateByLabelV1,
  type ServiceNowStateByValueV1,
  type ServiceNowStateRefV1,
  type ServiceNowSubmitRecordProducerResultV1,
  type ServiceNowSubmitRecordProducerV1,
  type ServiceNowTableName,
  type ServiceNowTagV1,
  type ServiceNowTaskV1,
  type ServiceNowTenantFullV1,
  ServiceNowTenantStatusV1,
  type ServiceNowTenantV1,
  type ServiceNowTicketFullV1,
  ServiceNowTicketTypeV1,
  type ServiceNowTicketV1,
  type ServiceNowUpdateChangeV1,
  type ServiceNowUpdateRecordV1,
  ServiceNowUrgencyV1,
  type ServiceNowUserGroupV1,
  type ServiceNowUserProfileV1,
  type ServiceNowUsersV1,
  type ServiceNowUserV1,
  type ServiceNowVariableOrder,
  type ServiceNowVariableType,
  ServiceNowVisibilityV1,
  type ServiceNowWebhookResponseV1,
  type SetOrgMemberRoleParamsV1,
  type SetOrgMembershipParamsV1,
  type SetTeamArticlePermissionParamsV1,
  type SetTeamArticlePermissionResultV1,
  type SetTeamArticlePermissionsParamsV1,
  type SetTeamArticlePermissionsResultV1,
  type SetTeamKbRoleParamsV1,
  type SetTeamKbRoleResultV1,
  type SetValkeyValueParamsV1,
  type SharepointAdminAccessResultV1,
  type SharepointAdminAccessV1,
  type SharepointAuthenticationFailedV1,
  SharepointAuthKindV1,
  type SharepointCallbackParamsV1,
  type SharepointCheckAccessResultV1,
  type SharepointCheckConnectionResultV1,
  type SharepointConnectedV1,
  type SharepointConnectionStatusV1,
  type SharepointConnectResponseV1,
  type SharepointCredentialsMissingV1,
  type SharepointCredentialsStateV1,
  type SharepointDownloadUrlV1,
  type SharepointDriveItemV1,
  type SharepointDriveV1,
  type SharepointElevatedV1,
  type SharepointFolderScopeAccessV1,
  type SharepointFolderScopesResultV1,
  type SharepointFolderScopeV1,
  type SharepointGrantedSiteV1,
  SharepointItemKindV1,
  type SharepointNoSiteReachableV1,
  type SharepointNotElevatedV1,
  type SharepointReachabilityV1,
  type SharepointReachableV1,
  type SharepointSiteAccessV1,
  type SharepointSitesResultV1,
  type SharepointTenantCredentialsParamsV1,
  type SharepointTenantFullV1,
  type SharepointTenantV1,
  type SharepointUnreachableV1,
  type SharepointUploadSessionV1,
  type SharepointWriteReceiptV1,
  type SimulationBranchBreakdownStatsV1,
  type SimulationBranchCommitBreakdownV1,
  type SimulationBranchJudgeBreakdownV1,
  type SimulationCommitsV1,
  type SimulationCompareJudgeSummaryV1,
  type SimulationCompareSummaryV1,
  type SimulationCompareV1,
  type SimulationDatapointExtractedInputOutputFullV1,
  type SimulationDatapointFullV1,
  type SimulationDatapointV1,
  type SimulationJudgeSummaryV1,
  type SimulationResultCitationV1,
  type SimulationResultContentBlockV1,
  type SimulationResultFullV1,
  type SimulationResultJudgementFullV1,
  type SimulationResultJudgementV1,
  type SimulationResultOutputFullV1,
  type SimulationResultOutputV1,
  type SimulationResultV1,
  type SimulationResultWithJudgementsV1,
  type SimulationRunV1,
  type SimulationRunVerdictBucketV1,
  type SingleStatContentV1,
  type SlackAddReactionRequestV2,
  type SlackAddReactionResponseV2,
  type SlackAppManifestV1,
  SlackAttachmentColorAliasV1,
  type SlackAttachmentV1,
  type SlackCallbackPayloadV1,
  type SlackChannelMessageV2,
  type SlackCheckConnectionResponseV1,
  type SlackConnectedV1,
  type SlackConnectResponseV1,
  type SlackDirectMessageDestinationV1,
  type SlackDisconnectedV1,
  SlackFileModeV1,
  type SlackFileV1,
  type SlackGetChannelMessagesResponseV2,
  type SlackGetReactionsMessageV2,
  type SlackGetReactionsResponseV2,
  type SlackGetUserGroupsResponseV1,
  type SlackGetUserGroupUsersResponseV1,
  type SlackGetUserInfoResponseV2,
  type SlackListUsersResponseV2,
  type SlackListUsersUserV2,
  type SlackManifestAgentActionV1,
  type SlackManifestAgentSuggestedPromptV1,
  type SlackManifestAgentViewV1,
  type SlackManifestAppHomeV1,
  type SlackManifestBotUserV1,
  type SlackManifestDisplayInformationV1,
  type SlackManifestEventSubscriptionsV1,
  type SlackManifestFeaturesV1,
  type SlackManifestInteractivityV1,
  type SlackManifestOauthConfigV1,
  type SlackManifestScopesV1,
  type SlackManifestSettingsV1,
  type SlackMessageMetadataV1,
  type SlackNotificationDestinationV1,
  type SlackNotificationSettingV1,
  SlackOauthScope,
  type SlackOauthScopesResponseV1,
  type SlackOpenViewRequestV1,
  type SlackOpenViewResponseV1,
  SlackParseModeV1,
  type SlackPostChatMessageRequestV2,
  type SlackPostChatMessageResponseV2,
  type SlackPublishHomeViewRequestV1,
  type SlackPublishHomeViewResponseV1,
  type SlackPushViewRequestV1,
  type SlackPushViewResponseV1,
  type SlackReactionV2,
  type SlackReceiveEventAckResponseV2,
  type SlackReceiveEventChallengeResponseV2,
  type SlackReceiveEventResponseV2,
  type SlackReceiveInteractivityAckResponseV2,
  type SlackSetAssistantStatusRequestV2,
  type SlackSetAssistantStatusResponseV2,
  type SlackSetAssistantTitleRequestV1,
  type SlackSetAssistantTitleResponseV1,
  type SlackSetChannelDescriptionRequestV2,
  type SlackSetChannelDescriptionResponseV2,
  type SlackSetChannelTopicRequestV2,
  type SlackSetChannelTopicResponseV2,
  type SlackSetSuggestedPromptsRequestV1,
  type SlackSetSuggestedPromptsResponseV1,
  SlackSnippetType,
  type SlackSuggestedPromptV1,
  type SlackTenantFullV1,
  type SlackTenantV1,
  type SlackUpdateChatMessageRequestV2,
  type SlackUpdateChatMessageResponseV2,
  type SlackUpdateUserGroupRequestV1,
  type SlackUpdateUserGroupUsersRequestV1,
  type SlackUpdateViewRequestV1,
  type SlackUpdateViewResponseV1,
  type SlackUploadContentRequestV2,
  type SlackUploadFilesResponseV2,
  type SlackUserGroupV1,
  type StatefulConversationMessageV1,
  type StatefulInferencePayloadV1,
  type StopAgentSessionResponseV1,
  type SucceededWorkflowRunV1,
  type SyncArticlesToOpenFgaResultV1,
  type SyncJudgesResultV1,
  type SyncKbOwnersResultV1,
  type TagFilterV1,
  type TaskFullV2,
  type TaskV2,
  type TeamFullV1,
  type TeamKbAssignmentV1,
  type TeamsAdaptiveCardV1,
  type TeamsBotCredentialsResponseV1,
  type TeamsBotCredentialsV1,
  type TeamsCheckConnectionResponseV1,
  type TeamsConversationActivityRefV1,
  type TeamsConversationMemberV1,
  type TeamsDeleteMessageRequestV1,
  type TeamsDeleteMessageResponseV1,
  type TeamsDownloadFileRequestV1,
  type TeamsEndCustomerInstallV1,
  type TeamsGetConversationMemberRequestV1,
  type TeamsGetConversationMemberResponseV1,
  TeamsIconKindV1,
  type TeamsJwksKeyV1,
  type TeamsJwksV1,
  type TeamsListConversationActivitiesRequestV1,
  type TeamsListConversationActivitiesResponseV1,
  type TeamsListConversationMembersRequestV1,
  type TeamsListConversationMembersResponseV1,
  type TeamsManifestLastDownloadV1,
  type TeamsMentionV1,
  type TeamsOidcFederationSetupV1,
  type TeamsOpenIdConfigurationV1,
  type TeamsPostMessageRequestV1,
  type TeamsPostMessageResponseV1,
  type TeamsReceiveMessageResponseV1,
  type TeamsSendProactiveMessageRequestV1,
  type TeamsSendProactiveMessageResponseV1,
  type TeamsSingleTenantBotCredentialsResponseV1,
  type TeamsSingleTenantBotCredentialsV1,
  type TeamsTenantFullV1,
  type TeamsTenantV1,
  type TeamsUpdateMessageRequestV1,
  type TeamsUpdateMessageResponseV1,
  type TeamsUserAssignedManagedIdentityBotCredentialsResponseV1,
  type TeamsUserAssignedManagedIdentityBotCredentialsV1,
  type TeamV1,
  TimeBucketV1,
  type ToolCallArgsV1,
  type ToolCallResultV1,
  type UnknownIncomingKbV1,
  type UpdateAgentSessionV1,
  type UpdateApiKeyParamsV1,
  type UpdateArticleLineRangeCommentThreadParamsV1,
  type UpdateCalibrationFeedbackVerdictDimensionParamsV1,
  type UpdateCalibrationFeedbackVerdictParamsV1,
  type UpdateChangeRequestLineRangeCommentThreadParamsV1,
  type UpdateChangeRequestParamsV1,
  type UpdateCommentParamsV1,
  type UpdateConfluencePageParamsV1,
  type UpdateConfluenceTenantCredentialsParamsV1,
  type UpdateConfluenceTenantParamsV1,
  type UpdateConversationMessageResponseV1,
  type UpdateConversationPayloadV1,
  type UpdateConversationResponseV1,
  type UpdateCurrentUserParamsV1,
  type UpdateDataDumpConversationParamsV1,
  type UpdateDatapointsResponseV3,
  type UpdateDatapointV2,
  type UpdateEntraTenantParamsV1,
  type UpdateEventSourceNotificationSettingsV1,
  type UpdateExternalInferenceParamsV1,
  type UpdateFinalizedConversationConversationV1,
  type UpdateFinalizedConversationMessageParamsV1,
  type UpdateFinalizedConversationParamsV1,
  type UpdateFinalizedConversationV1,
  type UpdateFreshserviceArticleParamsV1,
  type UpdateFreshserviceTenantParamsV1,
  type UpdateFreshserviceTicketParamsV1,
  type UpdateHubSpotTenantCredentialsParamsV1,
  type UpdateHubSpotTenantInstallationParamsV1,
  type UpdateHubSpotTenantParamsV1,
  type UpdateIndexTextParamsV2,
  type UpdateInferenceConversationInferenceParamsV1,
  type UpdateInferenceDatapointParamsV1,
  type UpdateInvitationParamsV1,
  type UpdateJiraTenantParamsV1,
  type UpdateJudgeParamsV1,
  type UpdateKanonicalDatapointV1,
  type UpdateMachineUserParamsV1,
  type UpdateNotificationSettingsParamsV1,
  type UpdateNotionBlockParamsV1,
  type UpdateNotionPageParamsV1,
  type UpdateOAuthApplicationParamsV1,
  type UpdateOrganizationParamsV1,
  type UpdateOrgMemberParamsV1,
  type UpdatePlainTenantParamsV1,
  type UpdateSalesforceArticleParamsV1,
  type UpdateSalesforceCaseParamsV1,
  type UpdateSalesforceIngestClientParamsV1,
  type UpdateSalesforceTenantCredentialsParamsV1,
  type UpdateSalesforceTenantParamsV1,
  type UpdateSecretParamsV1,
  type UpdateSecretVersionParamsV1,
  type UpdateServiceNowArticleV1,
  type UpdateServiceNowKnowledgeBaseV1,
  type UpdateSharepointItemParamsV1,
  type UpdateSimulationDatapointParamsV1,
  type UpdateSimulationResultParamsV1,
  type UpdateSlackTenantCredentialsParamsV1,
  type UpdateSlackTenantParamsV1,
  type UpdateTaskParamsV2,
  type UpdateTeamParamsV1,
  type UpdateTeamsTenantParamsV1,
  type UpdateTenantParamsV1,
  type UpdateWorkflowRunRequestV1,
  type UpdateWorkflowRunResponseV1,
  type UploadUrlRequestV1,
  type UploadUrlRequestV2,
  type UploadUrlResponseV1,
  type UploadUrlResponseV2,
  type UpsertInferenceConversationPayloadV1,
  type UpsertOrganizationParamsV1,
  type UserActionsTotalV2,
  type UserActivityDataPointV2,
  type UserActivitySeriesV2,
  type UserBotV1,
  type UserExternalV1,
  type UserFullV1,
  type UserOrganizationV1,
  type UserOrgMembershipV1,
  type UserV1,
  type ValidationError,
  type ValkeyPingV1,
  type ValkeyValueV1,
  type VerificationMetricsResponseV2,
  VisibilityFilterV1,
  VisibilityV1,
  type VisibleArticleContentV1,
  type VisibleChangeRequestContentV1,
  type VisibleKnowledgeBaseContentV1,
  WorkClaimStatusV1,
  type WorkClaimV1,
  type WorkEventFullV1,
  type WorkEventV1,
  WorkflowAnalyticsEventKindV1,
  type WorkflowAnalyticsEventV1,
  WorkflowKindV1,
  type WorkflowRunFullV1,
  type WorkflowRunStatusV1,
  type WorkflowRunV1,
  WorkflowStatusKindV1,
  type WorkflowTriggerV1,
  type WorkflowV1,
  type WorkspaceV1,
  type WsAgentSocketEventV1,
  type WsErrorEventV1,
  type WsJoinFeRoomRequestV1,
  type WsJoinFeRoomResponseV1,
  type XAxisLabelsDateV1,
  type XAxisLabelsTextV1,
  type ZendeskArticleAttachmentListV1,
  type ZendeskArticleAttachmentV1,
  type ZendeskArticlePageV1,
  type ZendeskArticleV1,
  type ZendeskCallbackPayloadV1,
  type ZendeskCategoryPageV1,
  type ZendeskCategoryV1,
  type ZendeskCheckConnectionResponseV1,
  type ZendeskCommentAttachmentV1,
  type ZendeskConnectResponseV1,
  type ZendeskCreateTenantV1,
  type ZendeskGetTicketAttachmentContentResponseV1,
  type ZendeskIngestResponseV1,
  ZendeskOAuthAuthMethod,
  type ZendeskOAuthRedirectUriV1,
  type ZendeskPatchTenantV1,
  type ZendeskReplyToTicketRequestV1,
  type ZendeskReplyToTicketResponseV1,
  type ZendeskReplyV1,
  type ZendeskSectionPageV1,
  type ZendeskSectionV1,
  type ZendeskSubdomain,
  type ZendeskTenantFullV1,
  type ZendeskTenantV1,
  type ZendeskTicketFullV1,
  type ZendeskTicketPageV1,
  type ZendeskTicketSearchPageV1,
  type ZendeskTicketSearchResultV1,
  ZendeskTicketSortV1,
  type ZendeskTicketV1,
  type ZendeskUpdateTicketTagsRequestV1,
  type ZendeskUpdateTicketTagsResponseV1,
  type ZendeskUserListV1,
  type ZendeskUserV1,
  type ZendeskWebhookProvisionResponseV1,
} from "./types.gen";
